/* lua.js generated code 0.3.0 */

let gotoFrameAndPlay = ccs.ActionTimeline.prototype.gotoFrameAndPlay
let { syncRequireGameModule } = require("gamepack/GamePackUtil")
function changeGotoFrameAndPlay(action, gotoFrameAndPlayFunc) {
    action.play = function (name, loop) {
        var info = this._animationInfos[name];
        if (!info)
            return cc.log("Can't find animation info for %s", name);
        gotoFrameAndPlay.call(this, info.startIndex, info.endIndex, loop);
    }
    action.gotoFrameAndPlay = gotoFrameAndPlayFunc
}

var GameGuideTimelineAnims = {}
GameGuideTimelineAnims.timelineAnims = function (animConfig) {
    var self = this
    var ret = cc.Node.create()
    var anim, action
    if (animConfig.type === "prop") {
        ;[anim, action] = self.prop(animConfig)
    } else if (animConfig.type === "block") {
        ;[anim, action] = self.obstacle(animConfig)
    } else if (animConfig.type === "custom") {
        // anim = cc.CSLoader:createNode("cocos/prop_anim_prop_anim_"..tostring(self.config.animPropId)..".csb")
        // action = cc.CSLoader:createTimeline("cocos/prop_anim_prop_anim_"..tostring(self.config.animPropId)..".csb")
        // anim:runAction(action)
    }
    if (anim) {
        ret.addChild(anim)
    }
    anim.setCascadeOpacityEnabled(true)
    ret.setCascadeOpacityEnabled(true)
    ret.runAction(cc.Sequence.create(cc.DelayTime.create(animConfig.delay || 0), cc.CallFunc.create(function () {
        if (action) {
            var replay = true
            if (animConfig.replay != null) {
                replay = animConfig.replay
            }
            if (action.playLoop) {
                action.playLoop()
            } else {
                action.gotoFrameAndPlay(0, replay)
            }
        }
    })))
    return ret
}
GameGuideTimelineAnims.prop = function (animConfig) {
    var self = this
    var anim = cc.CSLoader.createNode("cocos/prop_anim_prop_anim_" + tostring(animConfig.propId) + ".csb")
    var action = cc.CSLoader.createTimeline("cocos/prop_anim_prop_anim_" + tostring(animConfig.propId) + ".csb")
    anim.runAction(action)
    // FIXME: multi result
    return [anim, action]
}

GameGuideTimelineAnims.obstacleCandy = function () {
    var self = this
    var anim = cc.CSLoader.createNode("cocos/obstacle_anim_candy_checkboardd.csb")
    var bg = anim.getChildByName("checkboard")
    var size = bg.getContentSize()
    var candyFx = anim.getChildByName("candy_fx")
    candyFx.setOpacity(0)
    var action = cc.CSLoader.createTimeline("cocos/obstacle_anim_candy_checkboardd.csb")
    anim.runAction(action)
    anim.setContentSize(cc.size(315.05, 321.65))
    var playFrame = action.gotoFrameAndPlay
    function loopAnim() {
        action.setLastFrameCallFunc(function () {
            action.clearLastFrameCallFunc()
            anim.runAction(cc.Sequence.create(cc.FadeOut.create(0.4), cc.CallFunc.create(loopAnim)))
        })
        playFrame.call(action, 0, false)
        action.pause()
        anim.runAction(cc.Sequence.create(cc.FadeIn.create(0.4), cc.CallFunc.create(function () {
            action.resume()
        })))
    }
    changeGotoFrameAndPlay(action, loopAnim)

    // FIXME: multi result
    return [anim, action]
}
GameGuideTimelineAnims.obstacleFourTile = function (animConfig) {
    var self = this
    var anim = cc.CSLoader.createNode("cocos/obstacle_anim_fourtile_animation.csb")
    var bg = anim.getChildByName("checkboard")
    var size = bg.getContentSize()
    var action = cc.CSLoader.createTimeline("cocos/obstacle_anim_fourtile_animation.csb")
    anim.runAction(action)
    var phChicken = anim.getChildByName("chicken4")
    phChicken.setCascadeOpacityEnabled(true)
    FrameLoader.loadImageWithPlist("flash/chicken.plist")
    FrameLoader.loadImageWithPlist("flash/bg_tile.plist")
    syncRequireGameModule("clover/animation/TileCharacter")
    var chicken = TileCharacter.create("chicken")
    chicken.setCascadeOpacityEnabled(true)
    var $st31 = chicken.getChildren()
    for (var i = 1, v = $st31[1]; v; i++ , v = $st31[i]) {
        v.setCascadeOpacityEnabled(true)
    }
    var cSize = chicken.mainSprite.getContentSize()
    var phSize = phChicken.getContentSize()
    chicken.setScaleX(phSize.width / cSize.width)
    chicken.setScaleY(phSize.height / cSize.height)
    chicken.setPosition(cc.p(phSize.width / 2, phSize.height / 2))
    phChicken.addChild(chicken)
    var blasts = table()
    var positions = table(
        [0, cc.p(-20, 50)],
        [0, cc.p(50, 50)],
        [0, cc.p(120, 50)],
        [0, cc.p(-20, -20)],
        [0, cc.p(50, -20)],
        [0, cc.p(120, -20)]
    )
    var ph = anim.getChildByName("ph1")
    for (var i = 1; i <= 6; i += 1) {
        var sprite = GameGuideTimelineAnims._destroyEffect()
        sprite.setPosition(positions[i])
        ph.addChild(sprite)
        table.insert(blasts, sprite)
    }
    FrameLoader.loadImageWithPlist("flash/fourtile_effect.plist")
    var flyStartSprite = cc.Sprite.createWithSpriteFrameName("fourtile_combine_0000.png")
    var frames = SpriteUtil.buildFrames("fourtile_combine_%04d.png", 0, 14)
    var flyStartFx = SpriteUtil.buildAnimate(frames, 1 / 30)
    flyStartFx.retain()
    flyStartSprite.enableNodeEvents()
    flyStartSprite.onCleanup = function (self) {
        flyStartFx.release()
    }
    flyStartSprite.setVisible(false)
    flyStartSprite.setPosition(cc.p(ph.getPositionX() + 35, ph.getPositionY() - 35))
    anim.addChild(flyStartSprite)
    FrameLoader.loadImageWithPlist("flash/fourtile_effect.plist")
    var flyEndSprite = cc.Sprite.createWithSpriteFrameName("fourtile_combine_end_0000.png")
    var frames = SpriteUtil.buildFrames("fourtile_combine_end_%04d.png", 0, 21)
    var flyEndFx = SpriteUtil.buildAnimate(frames, 1 / 30)
    flyEndFx.retain()
    flyEndSprite.enableNodeEvents()
    flyEndSprite.onCleanup = function (self) {
        flyEndFx.release()
    }
    flyEndSprite.setVisible(false)
    flyEndSprite.setPosition(cc.p(phChicken.getPositionX(), phChicken.getPositionY()))
    anim.addChild(flyEndSprite)
    var grids = table()
    var positions = table(
        [0, cc.p(-20, 50)],
        [0, cc.p(50, 50)],
        [0, cc.p(120, 50)],
        [0, cc.p(-20, -20)],
        [0, cc.p(50, -20)],
        [0, cc.p(120, -20)]
    )
    var ph = anim.getChildByName("ph2")
    FrameLoader.loadImageWithPlist("flash/fourtile_effect.plist")
    for (var i = 1; i <= 6; i += 1) {
        function fourTileFx() {
            var destroySprite = cc.Sprite.createWithSpriteFrameName("fourtile_effect_0000.png")
            let frames = SpriteUtil.buildFrames("fourtile_effect_%04d.png", 0, 23)
            destroySprite.setBlendFunc(table([1, "src", gl.SRC_ALPHA], [1, "dst", gl.ONE]))
            var animate = SpriteUtil.buildAnimate(frames, 1 / 30)
            animate.retain()
            destroySprite.playAnim = function () {
                this.setVisible(true)
                this.play(animate, 0.1, 1)
            }
            destroySprite.enableNodeEvents()
            destroySprite.onCleanup = function () {
                animate.release()
            }
            // FIXME: multi result
            return [destroySprite, animate]
        }
        var [sprite, animation] = fourTileFx()
        animation.retain()
        sprite.setVisible(false)
        sprite.setPosition(positions[i])
        ph.addChild(sprite)
        table.insert(grids, sprite)
    }
    function loopAnim() {
        // chicken:setVisible(false)
        flyStartSprite.setVisible(false)
        flyEndSprite.setVisible(false)
        action.setLastFrameCallFunc(function () {
            action.clearLastFrameCallFunc()
            flyStartSprite.setVisible(true)
            flyStartSprite.play(flyStartFx, 0, 1)
            action.setLastFrameCallFunc(function () {
                for (var i = 1, v = table(
                    2,
                    3,
                    5,
                    6
                )[1]; v; i++ , v = table(
                    2,
                    3,
                    5,
                    6
                )[i]) {
                    blasts[v].playAnim()
                }
                action.setLastFrameCallFunc(function () {
                    action.clearLastFrameCallFunc()
                    flyStartSprite.setVisible(false)
                    FrameLoader.loadImageWithPlist("flash/bg_tile.plist")
                    chicken.play(kTileCharacterAnimation.kFourTile, 0)
                    action.setLastFrameCallFunc(function () {
                        action.clearLastFrameCallFunc()
                        flyEndSprite.setVisible(true)
                        flyEndSprite.play(flyEndFx, 0, 1)
                        action.setLastFrameCallFunc(function () {
                            action.clearLastFrameCallFunc()
                            FrameLoader.loadImageWithPlist("flash/bg_tile.plist")
                            chicken.play(kTileCharacterAnimation.kFourTileHalf, 0)
                            for (var i = 1, v = blasts[1]; v; i++ , v = blasts[i]) {
                                v.playAnim()
                            }
                            for (var i = 1, v = grids[1]; v; i++ , v = grids[i]) {
                                v.playAnim()
                            }
                            action.setLastFrameCallFunc(function () {
                                action.clearLastFrameCallFunc()
                                for (var i = 1, v = blasts[1]; v; i++ , v = blasts[i]) {
                                    v.playAnim()
                                }
                                for (var i = 1, v = grids[1]; v; i++ , v = grids[i]) {
                                    v.playAnim()
                                }
                                action.setLastFrameCallFunc(function () {
                                    action.clearLastFrameCallFunc()
                                    anim.runAction(cc.Sequence.create(cc.FadeOut.create(0.4), cc.CallFunc.create(loopAnim)))
                                })
                                action.play("part5", false)
                            })
                            action.play("part4", false)
                        })
                        action.play("part3", false)
                    })
                    action.play("fxframe2", false)
                })
                action.play("part2", false)
            })
            action.play("fxframe", false)
        })
        action.play("part1", false)
        action.pause()
        anim.runAction(cc.Sequence.create(cc.FadeIn.create(0.4), cc.CallFunc.create(function () {
            action.resume()
        })))
    }
    var clip = cc.ClippingRectangleNode.create()
    clip.setClippingRegion(cc.rect(0, -size.height * bg.getScaleY(), size.width * bg.getScaleX(), size.height * bg.getScaleY()))
    clip.setClippingEnabled(true)
    clip.addChild(anim)
    clip.setContentSize(cc.size(size.width * bg.getScaleX(), size.height * bg.getScaleY()))
    changeGotoFrameAndPlay(action, loopAnim)
    action.play("part1", false)
    action.pause()
    // FIXME: multi result
    return [clip, action]
}
GameGuideTimelineAnims.fishFx = function (animConfig) {
    var self = this
    var anim = cc.CSLoader.createNode("cocos/obstacle_anim_fish_guide.csb")
    var bg = anim.getChildByName("checkboard")
    var size = bg.getContentSize()
    var action = cc.CSLoader.createTimeline("cocos/obstacle_anim_fish_guide.csb")
    anim.runAction(action)
    anim.setContentSize(bg.getContentSize())
    var river = anim.getChildByName("river")
    var config = table(
        [0, table(
            [1, "isCorner", false],
            [1, "position", cc.p(50, 50)],
            [1, "rotation", 0]
        )],
        [0, table(
            [1, "isCorner", false],
            [1, "position", cc.p(150, 50)],
            [1, "rotation", 0]
        )],
        [0, table(
            [1, "isCorner", false],
            [1, "position", cc.p(250, 50)],
            [1, "rotation", 0]
        )],
        [0, table(
            [1, "isCorner", false],
            [1, "position", cc.p(350, 50)],
            [1, "rotation", 0]
        )],
        [0, table(
            [1, "isCorner", false],
            [1, "position", cc.p(450, 50)],
            [1, "rotation", 0]
        )]
    )
    for (var i = 1, v = config[1]; v; i++ , v = config[i]) {
        var road
        if (v.isCorner) {
            road = GameGuideTimelineAnims._createWaterCorner()
        } else {
            road = GameGuideTimelineAnims._createWaterNormal()
        }
        var size = road.getContentSize()
        if (v.isCorner) {
            road.setScaleX(-101 / size.width)
        } else {
            road.setScaleX(101 / size.width)
        }
        road.setScaleY(101 / size.height)
        road.setPosition(v.position)
        road.setRotation(v.rotation)
        river.addChild(road)
    }
    var sprays = table()
    var config = table(
        [0, cc.p(150, 50)],
        [0, cc.p(350, 50)],
        [0, cc.p(450, 50)]
    )
    for (var i = 1, v = config[1]; v; i++ , v = config[i]) {
        var sprite = GameGuideTimelineAnims._createWaterSpray()
        sprite.setPosition(v)
        river.addChild(sprite)
        table.insert(sprays, sprite)
    }
    var gate = anim.getChildByName("entrance")
    var entranceAnim = GameGuideTimelineAnims._createWaterEntrance()
    var aSize = entranceAnim.getContentSize()
    entranceAnim.setScaleX(103 / aSize.width)
    entranceAnim.setScaleY(103 / aSize.height)
    entranceAnim.setRotation(0)
    entranceAnim.setPosition(cc.p(51, 50))
    gate.addChild(entranceAnim)
    var exit = anim.getChildByName("exit")
    var exitAnim = GameGuideTimelineAnims._createWaterExit()
    var aSize = exitAnim.getContentSize()
    exitAnim.setScaleX(103 / aSize.width)
    exitAnim.setScaleY(103 / aSize.height)
    exitAnim.setPosition(cc.p(50, 50))
    exit.addChild(exitAnim)
    var config = table(
        [0, table([1, "color", 5], [1, "panic", false])],
        [0, table([1, "color", 6], [1, "panic", true])],
        [0, table([1, "color", 6], [1, "panic", true])],
        [0, table([1, "color", 2], [1, "panic", true])]
    )
    var fishes = table()
    for (var i = 1, v = config[1]; v; i++ , v = config[i]) {
        var fishLayer = anim.getChildByName("fish" + tostring(i))
        let fish = GameGuideTimelineAnims._createFishNormal(v.color)
        var size = fish.getContentSize()
        fish.setScaleX(110 / size.width)
        fish.setScaleY(110 / size.height)
        fish.setPosition(cc.p(45, 55))
        fishLayer.addChild(fish)
        let panic
        if (v.panic) {
            panic = GameGuideTimelineAnims._createFishPanic(v.color)
            var size = panic.getContentSize()
            panic.setScaleX(110 / size.width)
            panic.setScaleY(110 / size.height)
            panic.setPosition(cc.p(45, 55))
            fishLayer.addChild(panic)
        }
        fish.normal = function (self) {
            fish.setVisible(true)
            if (panic) {
                panic.setVisible(false)
            }
        }
        fish.panic = function (self) {
            if (panic) {
                fish.setVisible(false)
                panic.setVisible(true)
            }
        }
        fish.normal()
        table.insert(fishes, fish)
    }
    var blasts = table()
    var positions = table(
        [0, cc.p(150, 150)],
        [0, cc.p(150, 50)],
        [0, cc.p(250, 50)],
        [0, cc.p(350, 50)],
        [0, cc.p(450, 50)]
    )
    var ph = anim.getChildByName("blastfx")
    for (var i = 1; i <= 5; i += 1) {
        var sprite = GameGuideTimelineAnims._destroyEffect()
        sprite.setPosition(positions[i])
        ph.addChild(sprite)
        table.insert(blasts, sprite)
    }
    var portalNs = table(
        [0, cc.p(50, 25)],
        [0, cc.p(150, 25)],
        [0, cc.p(250, 25)],
        [0, cc.p(350, 25)],
        [0, cc.p(450, 25)],
        [0, cc.p(550, 25)]
    )
    var ph = anim.getChildByName("portals")
    for (var i = 1, v = portalNs[1]; v; i++ , v = portalNs[i]) {
        var sprite = GameGuideTimelineAnims._buildPortalEnter()
        sprite.setScale(100 / 70)
        sprite.setPosition(v)
        ph.addChild(sprite)
    }
    var portalXs = table(
        [0, cc.p(50, -125)],
        [0, cc.p(150, -125)],
        [0, cc.p(250, -125)],
        [0, cc.p(350, -125)],
        [0, cc.p(450, -125)],
        [0, cc.p(550, -125)]
    )
    for (var i = 1, v = portalXs[1]; v; i++ , v = portalXs[i]) {
        var sprite = GameGuideTimelineAnims._buildPortalExit()
        sprite.setScale(100 / 70)
        sprite.setPosition(v)
        ph.addChild(sprite)
    }
    function loopAnim() {
        action.setLastFrameCallFunc(function () {
            action.clearLastFrameCallFunc()
            blasts[1].playAnim()
            blasts[2].playAnim()
            fishes[2].panic()
            action.setLastFrameCallFunc(function () {
                action.clearLastFrameCallFunc()
                sprays[1].playAnim()
                action.setLastFrameCallFunc(function () {
                    action.clearLastFrameCallFunc()
                    action.setLastFrameCallFunc(function () {
                        action.clearLastFrameCallFunc()
                        action.setLastFrameCallFunc(function () {
                            action.clearLastFrameCallFunc()
                            blasts[3].playAnim()
                            blasts[4].playAnim()
                            blasts[5].playAnim()
                            fishes[3].panic()
                            fishes[4].panic()
                            action.setLastFrameCallFunc(function () {
                                action.clearLastFrameCallFunc()
                                sprays[2].playAnim()
                                sprays[3].playAnim()
                                action.setLastFrameCallFunc(function () {
                                    action.clearLastFrameCallFunc()
                                    anim.runAction(cc.Sequence.create(cc.FadeOut.create(0.4), cc.CallFunc.create(function () {
                                        for (var i = 1, v = fishes[1]; v; i++ , v = fishes[i]) {
                                            v.normal()
                                        }
                                        loopAnim()
                                    })))
                                })
                                action.play("part7", false)
                            })
                            action.play("part6", false)
                        })
                        action.play("part5", false)
                    })
                    action.play("part4", false)
                })
                action.play("part3", false)
            })
            action.play("part2", false)
        })
        action.play("part1", false)
        action.pause()
        anim.runAction(cc.Sequence.create(cc.FadeIn.create(0.4), cc.CallFunc.create(function () {
            action.resume()
        })))
    }
    changeGotoFrameAndPlay(action, loopAnim)
    // FIXME: multi result
    return [anim, action]
}
GameGuideTimelineAnims.fishPull = function (animConfig) {
    var self = this
    var anim = cc.CSLoader.createNode("cocos/obstacle_anim_fish_pull_fish_pull.csb")
    var bg = anim.getChildByName("checkboard")
    var size = bg.getContentSize()
    var action = cc.CSLoader.createTimeline("cocos/obstacle_anim_fish_pull_fish_pull.csb")
    anim.runAction(action)
    anim.setContentSize(bg.getContentSize())
    var curtain = anim.getChildByName("curtain")
    var mask = cc.LayerColor.create()
    mask.setContentSize(cc.size(100, 100))
    mask.setOpacity(128)
    curtain.addChild(mask)
    var river = anim.getChildByName("river")
    var config = table(
        [0, table(
            [1, "isCorner", false],
            [1, "position", cc.p(350, 50)],
            [1, "rotation", 180]
        )],
        [0, table(
            [1, "isCorner", false],
            [1, "position", cc.p(250, 50)],
            [1, "rotation", 180]
        )],
        [0, table(
            [1, "isCorner", false],
            [1, "position", cc.p(150, 50)],
            [1, "rotation", 180]
        )],
        [0, table(
            [1, "isCorner", true],
            [1, "position", cc.p(50, 50)],
            [1, "rotation", 0]
        )],
        [0, table(
            [1, "isCorner", false],
            [1, "position", cc.p(50, -50)],
            [1, "rotation", 90]
        )],
        [0, table(
            [1, "isCorner", false],
            [1, "position", cc.p(50, -150)],
            [1, "rotation", 90]
        )],
        [0, table(
            [1, "isCorner", true],
            [1, "position", cc.p(50, -250)],
            [1, "rotation", -90]
        )],
        [0, table(
            [1, "isCorner", false],
            [1, "position", cc.p(150, -250)],
            [1, "rotation", 0]
        )],
        [0, table(
            [1, "isCorner", false],
            [1, "position", cc.p(250, -250)],
            [1, "rotation", 0]
        )]
    )
    for (var i = 1, v = config[1]; v; i++ , v = config[i]) {
        var road
        if (v.isCorner) {
            road = GameGuideTimelineAnims._createWaterCorner()
        } else {
            road = GameGuideTimelineAnims._createWaterNormal()
        }
        var size = road.getContentSize()
        if (v.isCorner) {
            road.setScaleX(-101 / size.width)
        } else {
            road.setScaleX(101 / size.width)
        }
        road.setScaleY(101 / size.height)
        road.setPosition(v.position)
        road.setRotation(v.rotation)
        river.addChild(road)
    }
    var cConfig = table(
        [0, table(
            [1, "isCorner", true],
            [1, "position", cc.p(50, 50)],
            [1, "rotation", 180]
        )],
        [0, table(
            [1, "isCorner", false],
            [1, "position", cc.p(50, -50)],
            [1, "rotation", 90]
        )],
        [0, table(
            [1, "isCorner", false],
            [1, "position", cc.p(50, -150)],
            [1, "rotation", 90]
        )],
        [0, table(
            [1, "isCorner", true],
            [1, "position", cc.p(50, -250)],
            [1, "rotation", 90]
        )]
    )
    var backRoads = table()
    for (var i = 1, v = cConfig[1]; v; i++ , v = cConfig[i]) {
        var road
        if (v.isCorner) {
            road = GameGuideTimelineAnims._createWaterBackLineCorner()
        } else {
            road = GameGuideTimelineAnims._createWaterBackLineNormal()
        }
        var size = road.getContentSize()
        if (v.isCorner) {
            road.setScaleX(-101 / size.width)
        } else {
            road.setScaleX(101 / size.width)
        }
        road.setScaleY(101 / size.height)
        road.setPosition(v.position)
        road.setRotation(v.rotation)
        road.setOpacity(0)
        river.addChild(road)
        table.insert(backRoads, road)
    }
    var gate = anim.getChildByName("gate")
    var entranceAnim = GameGuideTimelineAnims._createWaterEntrance()
    var aSize = entranceAnim.getContentSize()
    entranceAnim.setScaleX(100 / aSize.width)
    entranceAnim.setScaleY(100 / aSize.height)
    entranceAnim.setRotation(180)
    entranceAnim.setPosition(cc.p(350, 50))
    gate.addChild(entranceAnim)
    var exit = anim.getChildByName("exit")
    var exitAnim = GameGuideTimelineAnims._createWaterExit()
    var aSize = exitAnim.getContentSize()
    exitAnim.setScaleX(100 / aSize.width)
    exitAnim.setScaleY(100 / aSize.height)
    exitAnim.setPosition(cc.p(350, -250))
    gate.addChild(exitAnim)
    var fishLayer = anim.getChildByName("fish")
    var fishes = table(
        [0, table([1, "position", cc.p(350, 50)], [1, "color", 4])],
        [0, table([1, "position", cc.p(250, 50)], [1, "color", 3])],
        [0, table([1, "position", cc.p(150, 50)], [1, "color", 6])]
    )
    var staticFishes = table()
    for (var i = 1, v = fishes[1]; v; i++ , v = fishes[i]) {
        var fish = GameGuideTimelineAnims._createFishNormal(v.color)
        var size = fish.getContentSize()
        fish.setScaleX(-100 / size.width)
        fish.setScaleY(100 / size.height)
        fish.setPosition(v.position)
        fishLayer.addChild(fish)
        table.insert(staticFishes, fish)
    }
    var dynFishConfig = table(6, 1)
    var dynFishes = table()
    for (var i = 1, v = dynFishConfig[1]; v; i++ , v = dynFishConfig[i]) {
        var ph = anim.getChildByName("fish" + tostring(i))
        var fish = GameGuideTimelineAnims._createFishNormal(v)
        var size = fish.getContentSize()
        fish.setScaleX(100 / size.width)
        fish.setScaleY(100 / size.height)
        fish.setPosition(cc.p(50, 50))
        ph.addChild(fish)
        table.insert(dynFishes, fish)
    }
    var lightConfig = table([0, table(
        [1, "fish", staticFishes[3]],
        [1, "color", 6],
        [1, "dirFront", true]
    )], [0, table(
        [1, "fish", dynFishes[1]],
        [1, "color", 6],
        [1, "dirFront", false]
    )])
    var lights = table()
    for (let i = 1, v = lightConfig[1]; v; i++ , v = lightConfig[i]) {
        var elem = table()
        for (var j = 1; j <= 4; j += 1) {
            var light = GameGuideTimelineAnims._createFishLight(v.color)
            var size = light.getContentSize()
            var oSize = v.fish.getContentSize()
            light.setScaleX(oSize.width / size.width + 0.2)
            light.setScaleY(oSize.height / size.height + 0.2)
            light.setPosition(cc.p(oSize.width / 2, oSize.height / 2 + 3))
            light.setOpacity(0)
            v.fish.addChild(light)
            table.insert(elem, light)
        }
        elem.flash = function () {
            var time = table(
                0.25,
                0.1667,
                0.125
            )
            var length = table(
                45.4,
                30.9,
                20.9
            )
            for (var i = 2; i <= 4; i += 1) {
                elem[i].setOpacity(204)
                elem[i].setPosition(cc.p(elem[1].getPosition()))
                elem[i].runAction(
                    cc.Sequence.create(
                        cc.DelayTime.create(0.15 * (i - 2)),
                        cc.Spawn.create(
                            cc.MoveBy.create(time[i - 1], cc.p(v.dirFront && length[i - 1] || -length[i - 1], 0)),
                            cc.FadeOut.create(time[i - 1])
                        )
                    )
                )
            }
        }
        elem.fadeIn = function () {
            elem[1].runAction(cc.FadeIn.create(0.2))
        }
        elem.fadeOut = function () {
            elem[1].runAction(cc.FadeOut.create(0.2))
        }
        table.insert(lights, elem)
    }
    function loopAnim() {
        for (var i = 1, v = backRoads[1]; v; i++ , v = backRoads[i]) {
            v.setOpacity(0)
        }
        action.setLastFrameCallFunc(function () {
            action.clearLastFrameCallFunc()
            for (var i = 1, v = lights[1]; v; i++ , v = lights[i]) {
                v.fadeIn()
                v.flash()
            }
            action.setLastFrameCallFunc(function () {
                action.clearLastFrameCallFunc()
                for (var i = 1, v = backRoads[1]; v; i++ , v = backRoads[i]) {
                    v.runAction(cc.FadeIn.create(0.2))
                }
                action.setLastFrameCallFunc(function () {
                    action.clearLastFrameCallFunc()
                    dynFishes[1].setScaleX(-dynFishes[1].getScaleX())
                    for (var i = 1, v = backRoads[1]; v; i++ , v = backRoads[i]) {
                        v.runAction(cc.FadeOut.create(0.2))
                    }
                    action.setLastFrameCallFunc(function () {
                        action.clearLastFrameCallFunc()
                        dynFishes[2].setScaleX(-dynFishes[2].getScaleX())
                        action.setLastFrameCallFunc(function () {
                            action.clearLastFrameCallFunc()
                            for (var i = 1, v = lights[1]; v; i++ , v = lights[i]) {
                                v.fadeOut()
                            }
                            action.setLastFrameCallFunc(function () {
                                action.clearLastFrameCallFunc()
                                anim.runAction(cc.Sequence.create(cc.FadeOut.create(0.4), cc.CallFunc.create(function () {
                                    dynFishes[1].setScaleX(-dynFishes[1].getScaleX())
                                    dynFishes[2].setScaleX(-dynFishes[2].getScaleX())
                                    loopAnim()
                                })))
                            })
                            action.play("part6", false)
                        })
                        action.play("part5", false)
                    })
                    action.play("part4", false)
                })
                action.play("part3", false)
            })
            action.play("part2", false)
        })
        action.play("part1", false)
        action.pause()
        anim.runAction(cc.Sequence.create(cc.FadeIn.create(0.4), cc.CallFunc.create(function () {
            action.resume()
        })))
    }
    changeGotoFrameAndPlay(action, loopAnim)

    // FIXME: multi result
    return [anim, action]
}
GameGuideTimelineAnims.iceChain = function () {
    var self = this
    var anim = cc.CSLoader.createNode("cocos/obstacle_anim_ice_chain_guide.csb")
    var action = cc.CSLoader.createTimeline("cocos/obstacle_anim_ice_chain_guide.csb")
    anim.runAction(action)
    var bg = anim.getChildByName("guide")
    anim.setContentSize(bg.getContentSize())
    var blasts = table()
    var layer = anim.getChildByName("blastfx")
    for (var i = 1; i <= 3; i += 1) {
        var sprite = GameGuideTimelineAnims._destroyEffect()
        sprite.setPosition(cc.p((i - 2) * 100 + 50, 50))
        layer.addChild(sprite)
        table.insert(blasts, sprite)
    }
    var chains = table()
    var iLayer = anim.getChildByName("icechain")
    for (var i = 1; i <= 2; i += 1) {
        var chain = GameGuideTimelineAnims._buildIceChain(4 - i)
        chain.setScale(1.5)
        chain.setPosition(cc.p(i * 100 - 103, 50))
        iLayer.addChild(chain.getObj())
        table.insert(chains, chain)
    }
    function loopAnim() {
        action.setLastFrameCallFunc(function () {
            action.clearLastFrameCallFunc()
            for (var i = 1, v = blasts[1]; v; i++ , v = blasts[i]) {
                v.playAnim()
            }
            for (var i = 1, v = chains[1]; v; i++ , v = chains[i]) {
                v.playAnim()
            }
            action.setLastFrameCallFunc(function () {
                action.clearLastFrameCallFunc()
                for (var i = 1, v = blasts[1]; v; i++ , v = blasts[i]) {
                    v.playAnim()
                }
                for (var i = 1, v = chains[1]; v; i++ , v = chains[i]) {
                    v.playAnim()
                }
                action.setLastFrameCallFunc(function () {
                    action.clearLastFrameCallFunc()
                    anim.runAction(cc.Sequence.create(cc.FadeOut.create(0.4), cc.CallFunc.create(function () {
                        for (var i = 1, v = chains[1]; v; i++ , v = chains[i]) {
                            v.resetAnim()
                        }
                        loopAnim()
                    })))
                })
                action.play("part3", false)
            })
            action.play("part2", false)
        })
        action.play("part1", false)
        action.pause()
        anim.runAction(cc.Sequence.create(cc.FadeIn.create(0.4), cc.CallFunc.create(function () {
            action.resume()
        })))
    }
    changeGotoFrameAndPlay(action, loopAnim)

    // FIXME: multi result
    return [anim, action]
}
GameGuideTimelineAnims.orange = function (animConfig) {
    var self = this
    var anim = cc.CSLoader.createNode("cocos/obstacle_anim_orange_guide.csb")
    var action = cc.CSLoader.createTimeline("cocos/obstacle_anim_orange_guide.csb")
    anim.runAction(action)
    var bg = anim.getChildByName("guide")
    anim.setContentSize(bg.getContentSize())
    var playFrame = action.gotoFrameAndPlay
    function loopAnim() {
        action.setLastFrameCallFunc(function () {
            action.clearLastFrameCallFunc()
            anim.runAction(cc.Sequence.create(cc.FadeOut.create(0.4), cc.CallFunc.create(loopAnim)))
        })
        playFrame.call(action, 0, false)
        action.pause()
        anim.runAction(cc.Sequence.create(cc.FadeIn.create(0.4), cc.CallFunc.create(function () {
            action.resume()
        })))
    }
    action.play(action, loopAnim)

    // FIXME: multi result
    return [anim, action]
}
GameGuideTimelineAnims.generator = function (animConfig) {
    var self = this
    var anim = cc.CSLoader.createNode("cocos/obstacle_anim_generator_guide.csb")
    var action = cc.CSLoader.createTimeline("cocos/obstacle_anim_generator_guide.csb")
    anim.runAction(action)
    var bg = anim.getChildByName("guide_52_66")
    anim.setContentSize(bg.getContentSize())
    var blasts = table()
    var layer = anim.getChildByName("blastfx")
    for (var i = 1; i <= 3; i += 1) {
        var sprite = GameGuideTimelineAnims._destroyEffect()
        sprite.setPosition(cc.p(50, (i - 2) * 100 + 50))
        layer.addChild(sprite)
        layer.setCascadeOpacityEnabled(true)
        table.insert(blasts, sprite)
    }
    var generators = table()
    for (var i = 44; i <= 45; i += 1) {
        var ph = anim.getChildByName("iconplaceholder_" + tostring(i))
        var generator = GameGuideTimelineAnims._buildGenerator(1)
        generator.setPosition(cc.p(50, 50))
        generator.setScale(1.2)
        ph.addChild(generator.getObj())
        table.insert(generators, generator)
    }
    function loopAnim() {
        action.setLastFrameCallFunc(function () {
            action.clearLastFrameCallFunc()
            for (let i = 1, v = blasts[1]; v; i++ , v = blasts[i]) {
                v.playAnim()
            }
            for (let i = 1, v = generators[1]; v; i++ , v = generators[i]) {
                v.playAnim()
            }
            action.setLastFrameCallFunc(function () {
                action.clearLastFrameCallFunc()
                for (let i = 1, v = blasts[1]; v; i++ , v = blasts[i]) {
                    v.playAnim()
                }
                for (let i = 1, v = generators[1]; v; i++ , v = generators[i]) {
                    v.playAnim()
                }
                action.setLastFrameCallFunc(function () {
                    action.clearLastFrameCallFunc()
                    for (let i = 1, v = blasts[1]; v; i++ , v = blasts[i]) {
                        v.playAnim()
                    }
                    for (let i = 1, v = generators[1]; v; i++ , v = generators[i]) {
                        v.playAnim()
                    }
                    action.setLastFrameCallFunc(function () {
                        action.clearLastFrameCallFunc()
                        for (let i = 1, v = generators[1]; v; i++ , v = generators[i]) {
                            v.playAnim()
                        }
                        action.setLastFrameCallFunc(function () {
                            action.clearLastFrameCallFunc()
                            for (let i = 1, v = generators[1]; v; i++ , v = generators[i]) {
                                v.resetAnim()
                            }
                            anim.runAction(cc.Sequence.create(cc.FadeOut.create(0.4), cc.CallFunc.create(function () {
                                loopAnim()
                            })))
                        })
                        action.play("part5", false)
                    })
                    action.play("part4", false)
                })
                action.play("part3", false)
            })
            action.play("part2", false)
        })
        action.play("part1", false)
        action.pause()
        anim.runAction(cc.Sequence.create(cc.FadeIn.create(0.4), cc.CallFunc.create(function () {
            action.resume()
        })))
    }
    changeGotoFrameAndPlay(action, loopAnim)

    // FIXME: multi result
    return [anim, action]
}
GameGuideTimelineAnims.lock = function (animConfig) {
    var self = this
    var anim = cc.CSLoader.createNode("cocos/obstacle_anim_lock_guide.csb")
    var action = cc.CSLoader.createTimeline("cocos/obstacle_anim_lock_guide.csb")
    anim.runAction(action)
    var bg = anim.getChildByName("checkboard")
    anim.setContentSize(bg.getContentSize())
    var blasts = table()
    var layer = anim.getChildByName("blastfx")
    for (var i = 1; i <= 2; i += 1) {
        var sprite = GameGuideTimelineAnims._destroyEffect()
        var size = sprite.getContentSize()
        sprite.setScale(100 / size.width)
        sprite.setPosition(cc.p(50, (i - 1) * 100 + 50))
        layer.addChild(sprite)
        layer.setCascadeOpacityEnabled(true)
        table.insert(blasts, sprite)
    }
    var layer = anim.getChildByName("lock")
    FrameLoader.loadImageWithPlist("flash/mapLock.plist")
    var sprite = cc.Sprite.createWithSpriteFrameName("Lock0001.png")
    var frames = SpriteUtil.buildFrames("Lock%04d.png", 0, 39)
    var animate = SpriteUtil.buildAnimate(frames, 1 / 30)
    animate.retain()
    sprite.playAnim = function (self) {
        sprite.play(animate, 0, 1)
    }
    sprite.resetAnim = function (self) {
        sprite.setSpriteFrame("Lock0001.png")
    }
    sprite.enableNodeEvents()
    sprite.onCleanup = function (self) {
        animate.release()
    }
    sprite.setScale(1.2)
    sprite.setPosition(cc.p(50, 50))
    layer.addChild(sprite)
    function loopAnim() {
        action.setLastFrameCallFunc(function () {
            action.clearLastFrameCallFunc()
            for (var i = 1, v = blasts[1]; v; i++ , v = blasts[i]) {
                v.playAnim()
            }
            sprite.playAnim()
            action.setLastFrameCallFunc(function () {
                action.clearLastFrameCallFunc()
                anim.runAction(cc.Sequence.create(cc.FadeOut.create(0.4), cc.CallFunc.create(function () {
                    sprite.resetAnim()
                    loopAnim()
                })))
            })
            action.play("part2", false)
        })
        action.play("part1", false)
        action.pause()
        anim.runAction(cc.Sequence.create(cc.FadeIn.create(0.4), cc.CallFunc.create(function () {
            action.resume()
        })))
    }
    changeGotoFrameAndPlay(action, loopAnim)

    action.play("part1", false)
    action.pause()
    // FIXME: multi result
    return [anim, action]
}
GameGuideTimelineAnims.lineFx = function (animConfig) {
    var self = this
    var anim = cc.CSLoader.createNode("cocos/obstacle_anim_line_guide.csb")
    var action = cc.CSLoader.createTimeline("cocos/obstacle_anim_line_guide.csb")
    anim.runAction(action)
    var bg = anim.getChildByName("guide")
    anim.setContentSize(bg.getContentSize())
    syncRequireGameModule("clover/animation/TileCharacter")
    FrameLoader.loadImageWithPlist("flash/chicken.plist")
    FrameLoader.loadImageWithPlist("flash/TileEffect.plist")
    var ph = anim.getChildByName("iconplaceholder")
    var sprite = TileCharacter.create("chicken")
    sprite.play(kTileCharacterAnimation.kLineRow)
    sprite.setCascadeOpacityEnabled(true)
    var $st270 = sprite.getChildren()
    for (var i = 1, v = $st270[1]; v; i++ , v = $st270[i]) {
        v.setCascadeOpacityEnabled(true)
    }
    var size = sprite.mainSprite.getContentSize()
    sprite.setScale(100 / size.width)
    sprite.setPosition(cc.p(50, 50))
    ph.addChild(sprite)
    var blasts = table()
    var ph = anim.getChildByName("blastfx")
    var config = table(
        [0, cc.p(50, 150)],
        [0, cc.p(50, -50)],
        [0, cc.p(50, -150)],
        [0, cc.p(-50, -150)],
        [0, cc.p(150, -50)],
        [0, cc.p(150, -150)],
        [0, cc.p(150, -250)]
    )
    for (var i = 1, v = config[1]; v; i++ , v = config[i]) {
        var sprite = GameGuideTimelineAnims._destroyEffect()
        var size = sprite.getContentSize()
        sprite.setScale(100 / size.width)
        sprite.setPosition(v)
        ph.addChild(sprite)
        ph.setCascadeOpacityEnabled(true)
        table.insert(blasts, sprite)
    }
    function loopAnim() {
        action.setLastFrameCallFunc(function () {
            action.clearLastFrameCallFunc()
            for (var i = 1, v = table(
                1,
                2,
                3
            )[1]; v; i++ , v = table(
                1,
                2,
                3
            )[i]) {
                blasts[v].playAnim()
            }
            action.setLastFrameCallFunc(function () {
                action.clearLastFrameCallFunc()
                for (var i = 1, v = table(
                    3,
                    4,
                    5,
                    6,
                    7
                )[1]; v; i++ , v = table(
                    3,
                    4,
                    5,
                    6,
                    7
                )[i]) {
                    blasts[v].playAnim()
                }
                var GameGuideTimelineFx = require("clover/gameGuide/GameGuideTimelineLineFx")
                var fx = GameGuideTimelineFx.create(false)
                fx.setPosition(cc.pAdd(cc.p(ph.getPosition()), cc.p(70, -140)))
                anim.addChild(fx)
                action.setLastFrameCallFunc(function () {
                    action.clearLastFrameCallFunc()
                    anim.runAction(cc.Sequence.create(cc.FadeOut.create(0.4), cc.CallFunc.create(function () {
                        loopAnim()
                    })))
                })
                action.play("part3", false)
            })
            action.play("part2", false)
        })
        action.play("part1", false)
        action.pause()
        anim.runAction(cc.Sequence.create(cc.FadeIn.create(0.4), cc.CallFunc.create(function () {
            action.resume()
        })))
    }
    changeGotoFrameAndPlay(action, loopAnim)

    // FIXME: multi result
    return [anim, action]
}
GameGuideTimelineAnims.iceBreak = function (animConfig) {
    let self = this
    let anim = cc.CSLoader.createNode("cocos/obstacle_anim_ice_guide.csb")
    let action = cc.CSLoader.createTimeline("cocos/obstacle_anim_ice_guide.csb")
    anim.runAction(action)
    let bg = anim.getChildByName("checkboard")
    anim.setContentSize(bg.getContentSize())
    let blasts = table()
    let ph = anim.getChildByName("blastfx")
    let config = table(
        [0, cc.p(150, 50)],
        [0, cc.p(150, -50)],
        [0, cc.p(150, -150)],
        [0, cc.p(350, -150)],
        [0, cc.p(450, -150)],
        [0, cc.p(550, -150)],
        [0, cc.p(450, -50)],
        [0, cc.p(550, -50)],
        [0, cc.p(650, -50)]
    )
    for (let i = 1, v = config[1]; v; i++, v = config[i]) {
        let sprite = self._destroyEffect()
        let size = sprite.getContentSize()
        sprite.setScale(100 / size.width)
        sprite.setPosition(v)
        ph.addChild(sprite)
        ph.setCascadeOpacityEnabled(true)
        table.insert(blasts, sprite)
    }
    let ices = table()
    ph = anim.getChildByName("iceph")
    config = table(
        [0, cc.p(150, -50)],
        [0, cc.p(150, -150)],
        [0, cc.p(350, -150)],
        [0, cc.p(450, -150)],
        [0, cc.p(550, -150)],
        [0, cc.p(550, -50)]
    )
    for (let i = 1, v = config[1]; v; i++, v = config[i]) {
        let ice = self._iceBreak(1)
        let size = ice.getContentSize()
        ice.setScale(100 / 70)
        ice.setPosition(v)
        ph.addChild(ice)
        ph.setCascadeOpacityEnabled(true)
        table.insert(ices, ice)
    }
    function loopAnim() {
        action.setLastFrameCallFunc(function () {
            action.clearLastFrameCallFunc()
            let $st297 = table(
                4,
                5,
                6
            )
            for (let i = 1, v = $st297[1]; v; i++, v = $st297[i]) {
                blasts[v].playAnim()
            }
            let $st299 = table(
                3,
                4,
                5
            )
            for (let i = 1, v = $st299[1]; v; i++, v = $st299[i]) {
                ices[v].playAnim()
            }
            action.setLastFrameCallFunc(function () {
                action.clearLastFrameCallFunc()
                let $st301 = table(
                    7,
                    8,
                    9
                )
                for (let i = 1, v = $st301[1]; v; i++, v = $st301[i]) {
                    blasts[v].playAnim()
                }
                ices[6].playAnim()
                action.setLastFrameCallFunc(function () {
                    action.clearLastFrameCallFunc()
                    let $st303 = table(
                        5,
                        6,
                        7,
                        8
                    )
                    for (let i = 1, v = $st303[1]; v; i++, v = $st303[i]) {
                        blasts[v].playAnim()
                    }
                    action.setLastFrameCallFunc(function () {
                        action.clearLastFrameCallFunc()
                        anim.runAction(cc.Sequence.create(cc.FadeOut.create(0.4), cc.CallFunc.create(function () {
                            for (let i = 1, v = ices[1]; v; i++, v = ices[i]) {
                                v.resetAnim()
                            }
                            loopAnim()
                        })))
                    })
                    action.play("part6", false)
                })
                action.play("part5", false)
            })
            action.play("part4", false)
        })
        action.play("part3", false)
        action.pause()
        anim.runAction(cc.Sequence.create(cc.FadeIn.create(0.4), cc.CallFunc.create(function () {
            action.resume()
        })))
    }
    changeGotoFrameAndPlay(action, loopAnim)
    // FIXME: multi result
    return [anim, action]
}

GameGuideTimelineAnims.wrapFx = function (animConfig) {
    var self = this
    var anim = cc.CSLoader.createNode("cocos/obstacle_anim_wrap_guide2.csb")
    var action = cc.CSLoader.createTimeline("cocos/obstacle_anim_wrap_guide2.csb")
    anim.runAction(action)
    var bg = anim.getChildByName("checkboard")
    anim.setContentSize(bg.getContentSize())
    syncRequireGameModule("clover/animation/TileCharacter")
    FrameLoader.loadImageWithPlist("flash/fox.plist")
    FrameLoader.loadImageWithPlist("flash/TileEffect.plist")
    FrameLoader.loadImageWithPlist("flash/bg_tile.plist")
    var ph = anim.getChildByName("iconplaceholder")
    var sprite = TileCharacter.create("fox")
    sprite.play(kTileCharacterAnimation.kWrap)
    sprite.setCascadeOpacityEnabled(true)
    var $st326 = sprite.getChildren()
    for (var i = 1, v = $st326[1]; v; i++ , v = $st326[i]) {
        v.setCascadeOpacityEnabled(true)
    }
    sprite.setScale(100 / 72)
    sprite.setPosition(cc.p(50, 50))
    ph.addChild(sprite)
    var blasts = table()
    var ph = anim.getChildByName("blastfx")
    var config = table(
        [0, cc.p(250, 50)],
        [0, cc.p(350, 50)],
        [0, cc.p(150, -50)],
        [0, cc.p(250, -50)],
        [0, cc.p(350, -50)],
        [0, cc.p(450, -50)],
        [0, cc.p(50, -150)],
        [0, cc.p(150, -150)],
        [0, cc.p(250, -150)],
        [0, cc.p(350, -150)],
        [0, cc.p(450, -150)],
        [0, cc.p(150, -250)],
        [0, cc.p(250, -250)],
        [0, cc.p(350, -250)],
        [0, cc.p(450, -250)]
    )
    for (var i = 1, v = config[1]; v; i++ , v = config[i]) {
        var sprite = GameGuideTimelineAnims._destroyEffect()
        var size = sprite.getContentSize()
        sprite.setScale(100 / size.width)
        sprite.setPosition(v)
        ph.addChild(sprite)
        ph.setCascadeOpacityEnabled(true)
        table.insert(blasts, sprite)
    }
    var wraps = table()
    var ph = anim.getChildByName("wrapfx")
    var config = table(
        [0, cc.p(250, 50)],
        [0, cc.p(150, -50)],
        [0, cc.p(250, -50)],
        [0, cc.p(350, -50)],
        [0, cc.p(50, -150)],
        [0, cc.p(150, -150)],
        [0, cc.p(250, -150)],
        [0, cc.p(350, -150)],
        [0, cc.p(450, -150)],
        [0, cc.p(150, -250)],
        [0, cc.p(250, -250)],
        [0, cc.p(350, -250)]
    )
    for (var i = 1, v = config[1]; v; i++ , v = config[i]) {
        var sprite = GameGuideTimelineAnims._wrapFx()
        var size = sprite.getContentSize()
        sprite.setScale(100 / size.width)
        sprite.setPosition(v)
        ph.addChild(sprite)
        ph.setCascadeOpacityEnabled(true)
        table.insert(wraps, sprite)
    }
    function loopAnim() {
        action.setLastFrameCallFunc(function () {
            action.clearLastFrameCallFunc()
            for (var i = 1, v = table(
                2,
                3,
                4,
                6,
                10,
                11,
                15
            )[1]; v; i++ , v = table(
                2,
                3,
                4,
                6,
                10,
                11,
                15
            )[i]) {
                blasts[v].playAnim()
            }
            action.setLastFrameCallFunc(function () {
                action.clearLastFrameCallFunc()
                for (var i = 1, v = table(
                    1,
                    3,
                    4,
                    5,
                    7,
                    8,
                    9,
                    10,
                    11,
                    12,
                    13,
                    14
                )[1]; v; i++ , v = table(
                    1,
                    3,
                    4,
                    5,
                    7,
                    8,
                    9,
                    10,
                    11,
                    12,
                    13,
                    14
                )[i]) {
                    blasts[v].playAnim()
                }
                for (var i = 1, v = wraps[1]; v; i++ , v = wraps[i]) {
                    v.playAnim()
                }
                action.setLastFrameCallFunc(function () {
                    action.clearLastFrameCallFunc()
                    anim.runAction(cc.Sequence.create(cc.FadeOut.create(0.4), cc.CallFunc.create(function () {
                        loopAnim()
                    })))
                })
                action.play("part3", false)
            })
            action.play("part2", false)
        })
        action.play("part1", false)
        action.pause()
        anim.runAction(cc.Sequence.create(cc.FadeIn.create(0.4), cc.CallFunc.create(function () {
            action.resume()
        })))
    }
    changeGotoFrameAndPlay(action, loopAnim)

    action.play("part1", false)
    action.pause()
    // FIXME: multi result
    return [anim, action]
}
GameGuideTimelineAnims.obstacleToy = function (animConfig) {
    var self = this
    var anim = cc.CSLoader.createNode("cocos/obstacle_anim_toy_guide.csb")
    var action = cc.CSLoader.createTimeline("cocos/obstacle_anim_toy_guide.csb")
    anim.runAction(action)
    var bg = anim.getChildByName("checkboard_36_36")
    anim.setContentSize(bg.getContentSize())
    syncRequireGameModule("clover/animation/TileCharacter")
    FrameLoader.loadImageWithPlist("flash/horse.plist")
    FrameLoader.loadImageWithPlist("flash/TileEffect.plist")
    FrameLoader.loadImageWithPlist("flash/bg_tile.plist")
    var ph = anim.getChildByName("hippo-line-heng_0_0")
    var sprite = TileCharacter.create("horse")
    sprite.play(kTileCharacterAnimation.kLineColumn)
    sprite.setCascadeOpacityEnabled(true)
    var $st354 = sprite.getChildren()
    for (var i = 1, v = $st354[1]; v; i++ , v = $st354[i]) {
        v.setCascadeOpacityEnabled(true)
    }
    sprite.setScale(100 / 72)
    sprite.setPosition(cc.p(50, 50))
    ph.addChild(sprite)
    var blasts = table()
    var ph = anim.getChildByName("blastfx")
    var config = table(
        [0, cc.p(-50, 50)],
        [0, cc.p(50, 50)],
        [0, cc.p(150, 50)],
        [0, cc.p(50, -50)],
        [0, cc.p(50, -150)],
        [0, cc.p(50, -250)],
        [0, cc.p(50, -350)],
        [0, cc.p(50, -450)]
    )
    for (var i = 1, v = config[1]; v; i++ , v = config[i]) {
        var sprite = GameGuideTimelineAnims._destroyEffect()
        var size = sprite.getContentSize()
        sprite.setScale(100 / size.width)
        sprite.setPosition(v)
        ph.addChild(sprite)
        ph.setCascadeOpacityEnabled(true)
        table.insert(blasts, sprite)
    }
    function loopAnim() {
        action.setLastFrameCallFunc(function () {
            action.clearLastFrameCallFunc()
            for (var i = 1, v = table(
                1,
                2,
                3
            )[1]; v; i++ , v = table(
                1,
                2,
                3
            )[i]) {
                blasts[v].playAnim()
            }
            var GameGuideTimelineFx = require("clover/gameGuide/GameGuideTimelineLineFx")
            var fx = GameGuideTimelineFx.create(true)
            fx.setPosition(cc.p(105, -35))
            anim.addChild(fx)
            action.setLastFrameCallFunc(function () {
                action.clearLastFrameCallFunc()
                for (var i = 1, v = table(
                    4,
                    5,
                    6,
                    7,
                    8
                )[1]; v; i++ , v = table(
                    4,
                    5,
                    6,
                    7,
                    8
                )[i]) {
                    blasts[v].playAnim()
                }
                action.setLastFrameCallFunc(function () {
                    action.clearLastFrameCallFunc()
                    anim.runAction(cc.Sequence.create(cc.FadeOut.create(0.4), cc.CallFunc.create(function () {
                        loopAnim()
                    })))
                })
                action.play("part3", false)
            })
            action.play("part2", false)
        })
        action.play("part1", false)
        action.pause()
        anim.runAction(cc.Sequence.create(cc.FadeIn.create(0.4), cc.CallFunc.create(function () {
            action.resume()
        })))
    }
    changeGotoFrameAndPlay(action, loopAnim)

    action.play("part1", false)
    action.pause()
    // FIXME: multi result
    return [anim, action]
}
GameGuideTimelineAnims.birdFx = function (animConfig) {
    var self = this
    var anim = cc.CSLoader.createNode("cocos/obstacle_anim_bird_guide3.csb")
    var action = cc.CSLoader.createTimeline("cocos/obstacle_anim_bird_guide3.csb")
    anim.runAction(action)
    var bg = anim.getChildByName("checkboard")
    anim.setContentSize(bg.getContentSize())
    syncRequireGameModule("clover/animation/TileBird")
    FrameLoader.loadImageWithPlist("flash/bird.plist")
    var ph = anim.getChildByName("iconplaceholder")
    var sprite = TileBird.create()
    sprite.play(kTileBirdAnimation.kNormal)
    sprite.setCascadeOpacityEnabled(true)
    var $st375 = sprite.getChildren()
    for (var i = 1, v = $st375[1]; v; i++ , v = $st375[i]) {
        v.setCascadeOpacityEnabled(true)
    }
    sprite.setScale(100 / 72)
    sprite.setPosition(cc.p(50, 50))
    ph.addChild(sprite)
    var blasts = table()
    var ph = anim.getChildByName("blastfx")
    var config = table(
        [0, cc.p(-150, 50)],
        [0, cc.p(-50, 50)],
        [0, cc.p(150, 50)],
        [0, cc.p(250, 50)]
    )
    for (var i = 1, v = config[1]; v; i++ , v = config[i]) {
        var sprite = GameGuideTimelineAnims._destroyEffect()
        var size = sprite.getContentSize()
        sprite.setScale(100 / size.width)
        sprite.setPosition(v)
        ph.addChild(sprite)
        ph.setCascadeOpacityEnabled(true)
        table.insert(blasts, sprite)
    }
    function loopAnim() {
        action.setLastFrameCallFunc(function () {
            action.clearLastFrameCallFunc()
            for (var i = 1, v = blasts[1]; v; i++ , v = blasts[i]) {
                v.playAnim()
            }
            action.setLastFrameCallFunc(function () {
                action.clearLastFrameCallFunc()
                anim.runAction(cc.Sequence.create(cc.FadeOut.create(0.4), cc.CallFunc.create(function () {
                    loopAnim()
                })))
            })
            action.play("part2", false)
        })
        action.play("part1", false)
        action.pause()
        anim.runAction(cc.Sequence.create(cc.FadeIn.create(0.4), cc.CallFunc.create(function () {
            action.resume()
        })))
    }
    changeGotoFrameAndPlay(action, loopAnim)

    action.play("part1", false)
    action.pause()
    // FIXME: multi result
    return [anim, action]
}
GameGuideTimelineAnims.bossFx = function (animConfig) {
    var self = this
    var anim = cc.CSLoader.createNode("cocos/obstacle_anim_boss_guide.csb")
    var action = cc.CSLoader.createTimeline("cocos/obstacle_anim_boss_guide.csb")
    anim.runAction(action)
    var bg = anim.getChildByName("bossbitmap_46")
    var size = bg.getContentSize()
    anim.setContentSize(cc.size(size.width * bg.getScaleX(), size.height * bg.getScaleY()))
    var blasts = table()
    var ph = anim.getChildByName("blastfx")
    var config = table(
        [0, cc.p(-50, 50)],
        [0, cc.p(50, 50)],
        [0, cc.p(150, 50)]
    )
    for (var i = 1, v = config[1]; v; i++ , v = config[i]) {
        var sprite = GameGuideTimelineAnims._destroyEffect()
        var size = sprite.getContentSize()
        sprite.setScale(100 / size.width)
        sprite.setPosition(v)
        ph.addChild(sprite)
        ph.setCascadeOpacityEnabled(true)
        table.insert(blasts, sprite)
    }
    function loopAnim() {
        action.setLastFrameCallFunc(function () {
            action.clearLastFrameCallFunc()
            for (var i = 1, v = blasts[1]; v; i++ , v = blasts[i]) {
                v.playAnim()
            }
            action.setLastFrameCallFunc(function () {
                action.clearLastFrameCallFunc()
                anim.runAction(cc.Sequence.create(cc.FadeOut.create(0.4), cc.CallFunc.create(function () {
                    loopAnim()
                })))
            })
            action.play("part2", false)
        })
        action.play("part1", false)
        action.pause()
        anim.runAction(cc.Sequence.create(cc.FadeIn.create(0.4), cc.CallFunc.create(function () {
            action.resume()
        })))
    }
    changeGotoFrameAndPlay(action, loopAnim)

    action.play("part1", false)
    action.pause()
    // FIXME: multi result
    return [anim, action]
}
GameGuideTimelineAnims.bossAlert = function (animConfig) {
    var self = this
    var anim = cc.CSLoader.createNode("cocos/obstacle_anim_boss_alert_guide.csb")
    var action = cc.CSLoader.createTimeline("cocos/obstacle_anim_boss_alert_guide.csb")
    anim.runAction(action)
    var bg = anim.getChildByName("bossbitmap_46")
    anim.setContentSize(bg.getContentSize())
    var blasts = table()
    var ph = anim.getChildByName("blastfx")
    var config = table([0, cc.p(-50, -50)], [0, cc.p(150, -50)])
    for (var i = 1, v = config[1]; v; i++ , v = config[i]) {
        var sprite = GameGuideTimelineAnims._destroyEffect()
        var size = sprite.getContentSize()
        sprite.setScale(100 / size.width)
        sprite.setPosition(v)
        ph.addChild(sprite)
        ph.setCascadeOpacityEnabled(true)
        table.insert(blasts, sprite)
    }
    var ph = anim.getChildByName("iconplaceholder")
    var fish = GameGuideTimelineAnims._buildStarFish(2, 3)
    fish.setScale(100 / 72)
    fish.setPosition(cc.p(50, 50))
    ph.addChild(fish.getObj())
    function loopAnim() {
        action.setLastFrameCallFunc(function () {
            action.clearLastFrameCallFunc()
            for (var i = 1, v = blasts[1]; v; i++ , v = blasts[i]) {
                v.playAnim()
            }
            fish.playAnim(1)
            action.setLastFrameCallFunc(function () {
                action.clearLastFrameCallFunc()
                for (var i = 1, v = blasts[1]; v; i++ , v = blasts[i]) {
                    v.playAnim()
                }
                fish.playAnim(3)
                action.setLastFrameCallFunc(function () {
                    action.clearLastFrameCallFunc()
                    for (var i = 1, v = blasts[1]; v; i++ , v = blasts[i]) {
                        v.playAnim()
                    }
                    fish.playAnim(3)
                    action.setLastFrameCallFunc(function () {
                        action.clearLastFrameCallFunc()
                        anim.runAction(cc.Sequence.create(cc.FadeOut.create(0.4), cc.CallFunc.create(function () {
                            fish.resetAnim()
                            loopAnim()
                        })))
                    })
                    action.play("part4", false)
                })
                action.play("part3", false)
            })
            action.play("part2", false)
        })
        action.play("part1", false)
        action.pause()
        anim.runAction(cc.Sequence.create(cc.FadeIn.create(0.4), cc.CallFunc.create(function () {
            action.resume()
        })))
    }
    changeGotoFrameAndPlay(action, loopAnim)

    action.play("part1", false)
    action.pause()
    // FIXME: multi result
    return [anim, action]
}
GameGuideTimelineAnims.superBird = function (animConfig) {
    var self = this
    var anim = cc.CSLoader.createNode("cocos/obstacle_anim_superbird_guide.csb")
    var action = cc.CSLoader.createTimeline("cocos/obstacle_anim_superbird_guide.csb")
    anim.runAction(action)
    var bg = anim.getChildByName("guide_52")
    var bgSize = bg.getContentSize()
    var clip = cc.ClippingRectangleNode.create()
    clip.setClippingRegion(cc.rect(0, -bgSize.height * bg.getScaleY(), bgSize.width * bg.getScaleX(), bgSize.height * bg.getScaleY()))
    clip.setClippingEnabled(true)
    clip.addChild(anim)
    clip.setContentSize(cc.size(bgSize.width * bg.getScaleX(), bgSize.height * bg.getScaleY()))
    anim.setScale(1.3)
    anim.setPositionY(bgSize.height * 0.15)
    var blasts = table()
    var ph = anim.getChildByName("blastfx")
    var config = table(
        [0, cc.p(150, -50)],
        [0, cc.p(150, -150)],
        [0, cc.p(150, -250)],
        [0, cc.p(250, -250)],
        [0, cc.p(150, -350)],
        [0, cc.p(150, -450)]
    )
    for (var i = 1, v = config[1]; v; i++ , v = config[i]) {
        var sprite = GameGuideTimelineAnims._destroyEffect()
        var size = sprite.getContentSize()
        sprite.setScale(100 / size.width)
        sprite.setPosition(v)
        ph.addChild(sprite)
        ph.setCascadeOpacityEnabled(true)
        table.insert(blasts, sprite)
    }
    function loopAnim() {
        anim.setScale(1.3)
        anim.setPositionY(bgSize.height * 0.15)
        clip.setClippingEnabled(true)
        action.setLastFrameCallFunc(function () {
            action.clearLastFrameCallFunc()
            for (var i = 1, v = blasts[1]; v; i++ , v = blasts[i]) {
                v.playAnim()
            }
            action.setLastFrameCallFunc(function () {
                action.clearLastFrameCallFunc()
                anim.runAction(cc.Sequence.create(cc.Spawn.create(cc.MoveTo.create(0.3, cc.p(0, 0)), cc.ScaleTo.create(0.3, 1)), cc.CallFunc.create(function () {
                    clip.setClippingEnabled(false)
                })))
                action.setLastFrameCallFunc(function () {
                    action.clearLastFrameCallFunc()
                    anim.runAction(cc.Sequence.create(cc.FadeOut.create(0.4), cc.CallFunc.create(function () {
                        loopAnim()
                    })))
                })
                action.play("part3", false)
            })
            action.play("part2", false)
        })
        action.play("part1", false)
        action.pause()
        anim.runAction(cc.Sequence.create(cc.FadeIn.create(0.4), cc.CallFunc.create(function () {
            action.resume()
        })))
    }
    changeGotoFrameAndPlay(action, loopAnim)

    action.play("part1", false)
    action.pause()
    // FIXME: multi result
    return [clip, action]
}
GameGuideTimelineAnims.collectToy = function (animConfig) {
    var self = this
    var anim = cc.CSLoader.createNode("cocos/obstacle_anim_collect_guide.csb")
    var action = cc.CSLoader.createTimeline("cocos/obstacle_anim_collect_guide.csb")
    anim.runAction(action)
    var bg = anim.getChildByName("checkboard_67")
    anim.setContentSize(bg.getContentSize())
    var blasts = table()
    var ph = anim.getChildByName("blastfx")
    var config = table(
        [0, cc.p(-50, 50)],
        [0, cc.p(50, 50)],
        [0, cc.p(150, 50)]
    )
    for (var i = 1, v = config[1]; v; i++ , v = config[i]) {
        var sprite = GameGuideTimelineAnims._destroyEffect()
        var size = sprite.getContentSize()
        sprite.setScale(100 / size.width)
        sprite.setPosition(v)
        ph.addChild(sprite)
        ph.setCascadeOpacityEnabled(true)
        table.insert(blasts, sprite)
    }
    function loopAnim() {
        action.setLastFrameCallFunc(function () {
            action.clearLastFrameCallFunc()
            for (var i = 1, v = blasts[1]; v; i++ , v = blasts[i]) {
                v.playAnim()
            }
            action.setLastFrameCallFunc(function () {
                action.clearLastFrameCallFunc()
                anim.runAction(cc.Sequence.create(cc.FadeOut.create(0.4), cc.CallFunc.create(function () {
                    loopAnim()
                })))
            })
            action.play("part2", false)
        })
        action.play("part1", false)
        action.pause()
        anim.runAction(cc.Sequence.create(cc.FadeIn.create(0.4), cc.CallFunc.create(function () {
            action.resume()
        })))
    }
    changeGotoFrameAndPlay(action, loopAnim)

    action.play("part1", false)
    action.pause()
    // FIXME: multi result
    return [anim, action]
}
GameGuideTimelineAnims.coconutFx = function (animConfig) {
    var self = this
    var anim = cc.CSLoader.createNode("cocos/obstacle_anim_coconut_guide.csb")
    var action = cc.CSLoader.createTimeline("cocos/obstacle_anim_coconut_guide.csb")
    anim.runAction(action)
    var bg = anim.getChildByName("guide")
    anim.setContentSize(bg.getContentSize())
    syncRequireGameModule("clover/animation/TileCharacter")
    FrameLoader.loadImageWithPlist("flash/horse.plist")
    FrameLoader.loadImageWithPlist("flash/TileEffect.plist")
    var ph = anim.getChildByName("hippo1_eff")
    var sprite = TileCharacter.create("horse")
    sprite.play(kTileCharacterAnimation.kLineRow)
    sprite.setCascadeOpacityEnabled(true)
    var $st453 = sprite.getChildren()
    for (var i = 1, v = $st453[1]; v; i++ , v = $st453[i]) {
        v.setCascadeOpacityEnabled(true)
    }
    var size = sprite.mainSprite.getContentSize()
    sprite.setScale(100 / size.width)
    sprite.setPosition(cc.p(50, 50))
    ph.addChild(sprite)
    var blasts = table()
    var ph = anim.getChildByName("blastfx")
    var config = table(
        [0, cc.p(150, 50)],
        [0, cc.p(150, -50)],
        [0, cc.p(150, -150)],
        [0, cc.p(50, -150)],
        [0, cc.p(250, -150)]
    )
    for (var i = 1, v = config[1]; v; i++ , v = config[i]) {
        var sprite = GameGuideTimelineAnims._destroyEffect()
        var size = sprite.getContentSize()
        sprite.setScale(100 / size.width)
        sprite.setPosition(v)
        ph.addChild(sprite)
        ph.setCascadeOpacityEnabled(true)
        table.insert(blasts, sprite)
    }
    function loopAnim() {
        action.setLastFrameCallFunc(function () {
            action.clearLastFrameCallFunc()
            for (var i = 1, v = table(
                1,
                2,
                3
            )[1]; v; i++ , v = table(
                1,
                2,
                3
            )[i]) {
                blasts[v].playAnim()
            }
            action.setLastFrameCallFunc(function () {
                action.clearLastFrameCallFunc()
                for (var i = 1, v = table(
                    1,
                    2,
                    3
                )[1]; v; i++ , v = table(
                    1,
                    2,
                    3
                )[i]) {
                    blasts[v].playAnim()
                }
                var GameGuideTimelineFx = require("clover/gameGuide/GameGuideTimelineLineFx")
                var fx = GameGuideTimelineFx.create(false)
                fx.setPosition(cc.pAdd(cc.p(ph.getPosition()), cc.p(70, -140)))
                anim.addChild(fx)
                action.setLastFrameCallFunc(function () {
                    action.clearLastFrameCallFunc()
                    for (var i = 1, v = table(4, 5)[1]; v; i++ , v = table(4, 5)[i]) {
                        blasts[v].playAnim()
                    }
                    action.setLastFrameCallFunc(function () {
                        action.clearLastFrameCallFunc()
                        anim.runAction(cc.Sequence.create(cc.FadeOut.create(0.4), cc.CallFunc.create(function () {
                            loopAnim()
                        })))
                    })
                    action.play("part4", false)
                })
                action.play("part3", false)
            })
            action.play("part2", false)
        })
        action.play("part1", false)
        action.pause()
        anim.runAction(cc.Sequence.create(cc.FadeIn.create(0.4), cc.CallFunc.create(function () {
            action.resume()
        })))
    }
    changeGotoFrameAndPlay(action, loopAnim)

    action.play("part1", false)
    action.pause()
    // FIXME: multi result
    return [anim, action]
}
GameGuideTimelineAnims.waterDig = function (animConfig) {
    var self = this
    var anim = cc.CSLoader.createNode("cocos/obstacle_anim_waterdig_guide.csb")
    var action = cc.CSLoader.createTimeline("cocos/obstacle_anim_waterdig_guide.csb")
    anim.runAction(action)
    var bg = anim.getChildByName("guide")
    anim.setContentSize(bg.getContentSize())
    var soils = table()
    var ph = anim.getChildByName("blastfx")
    var sConfigs = table(
        [0, cc.p(150, -50)],
        [0, cc.p(250, -50)],
        [0, cc.p(350, -50)],
        [0, cc.p(150, -150)]
    )
    for (var i = 1, v = sConfigs[1]; v; i++ , v = sConfigs[i]) {
        var sprite = GameGuideTimelineAnims._buildSoilDestroy()
        var size = sprite.getContentSize()
        sprite.setScale(100 / size.width)
        sprite.setPosition(v)
        ph.addChild(sprite)
        ph.setCascadeOpacityEnabled(true)
        table.insert(soils, sprite)
    }
    var blasts = table()
    var config = table(
        [0, cc.p(150, 50)],
        [0, cc.p(150, -50)],
        [0, cc.p(250, -50)],
        [0, cc.p(350, -50)],
        [0, cc.p(150, -150)]
    )
    for (var i = 1, v = config[1]; v; i++ , v = config[i]) {
        var sprite = GameGuideTimelineAnims._destroyEffect()
        var size = sprite.getContentSize()
        sprite.setScale(100 / size.width)
        sprite.setPosition(v)
        ph.addChild(sprite)
        ph.setCascadeOpacityEnabled(true)
        table.insert(blasts, sprite)
    }
    function loopAnim() {
        action.setLastFrameCallFunc(function () {
            action.clearLastFrameCallFunc()
            for (var i = 1, v = table(
                2,
                3,
                4
            )[1]; v; i++ , v = table(
                2,
                3,
                4
            )[i]) {
                blasts[v].playAnim()
            }
            for (var i = 1, v = table(
                1,
                2,
                3
            )[1]; v; i++ , v = table(
                1,
                2,
                3
            )[i]) {
                soils[v].playAnim()
            }
            action.setLastFrameCallFunc(function () {
                action.clearLastFrameCallFunc()
                for (var i = 1, v = table(
                    1,
                    2,
                    5
                )[1]; v; i++ , v = table(
                    1,
                    2,
                    5
                )[i]) {
                    blasts[v].playAnim()
                }
                soils[4].playAnim()
                action.setLastFrameCallFunc(function () {
                    action.clearLastFrameCallFunc()
                    anim.runAction(cc.Sequence.create(cc.FadeOut.create(0.4), cc.CallFunc.create(function () {
                        loopAnim()
                    })))
                })
                action.play("part3", false)
            })
            action.play("part2", false)
        })
        action.play("part1", false)
        action.pause()
        anim.runAction(cc.Sequence.create(cc.FadeIn.create(0.4), cc.CallFunc.create(function () {
            action.resume()
        })))
    }
    changeGotoFrameAndPlay(action, loopAnim)

    action.play("part1", false)
    action.pause()
    // FIXME: multi result
    return [anim, action]
}
GameGuideTimelineAnims.reef = function (animConfig) {
    var self = this
    var anim = cc.CSLoader.createNode("cocos/obstacle_anim_reef_guide.csb")
    var action = cc.CSLoader.createTimeline("cocos/obstacle_anim_reef_guide.csb")
    anim.runAction(action)
    var bg = anim.getChildByName("guide")
    anim.setContentSize(bg.getContentSize())
    var blasts = table()
    var ph = anim.getChildByName("blastfx")
    var config = table(
        [0, cc.p(50, 50)],
        [0, cc.p(150, 50)],
        [0, cc.p(250, 50)]
    )
    for (var i = 1, v = config[1]; v; i++ , v = config[i]) {
        var sprite = GameGuideTimelineAnims._destroyEffect()
        var size = sprite.getContentSize()
        sprite.setScale(100 / size.width)
        sprite.setPosition(v)
        ph.addChild(sprite)
        ph.setCascadeOpacityEnabled(true)
        table.insert(blasts, sprite)
    }
    function loopAnim() {
        action.setLastFrameCallFunc(function () {
            action.clearLastFrameCallFunc()
            for (var i = 1, v = blasts[1]; v; i++ , v = blasts[i]) {
                v.playAnim()
            }
            action.setLastFrameCallFunc(function () {
                action.clearLastFrameCallFunc()
                anim.runAction(cc.Sequence.create(cc.FadeOut.create(0.4), cc.CallFunc.create(function () {
                    loopAnim()
                })))
            })
            action.play("part2", false)
        })
        action.play("part1", false)
        action.pause()
        anim.runAction(cc.Sequence.create(cc.FadeIn.create(0.4), cc.CallFunc.create(function () {
            action.resume()
        })))
    }
    changeGotoFrameAndPlay(action, loopAnim)

    action.play("part1", false)
    action.pause()
    // FIXME: multi result
    return [anim, action]
}
GameGuideTimelineAnims.butterfly = function (animConfig) {
    var self = this
    var anim = cc.CSLoader.createNode("cocos/obstacle_anim_butterfly_guide.csb")
    var action = cc.CSLoader.createTimeline("cocos/obstacle_anim_butterfly_guide.csb")
    anim.runAction(action)
    var ph = anim.getChildByName("butterflyfx")
    var bottleBlast = table()
    for (var i = 1, v = table(
        [0, cc.p(250, -50)],
        [0, cc.p(250, -150)],
        [0, cc.p(250, -250)]
    )[1]; v; i++ , v = table(
        [0, cc.p(250, -50)],
        [0, cc.p(250, -150)],
        [0, cc.p(250, -250)]
    )[i]) {
        var sprite = GameGuideTimelineAnims._buildBombBottle()
        sprite.setScale(100 / 70)
        sprite.setPosition(v)
        ph.addChild(sprite)
        ph.setCascadeOpacityEnabled(true)
        table.insert(bottleBlast, sprite)
    }
    var butterflyBlast = table()
    for (var i = 1, v = table(
        [0, cc.p(50, 50)],
        [0, cc.p(250, 50)],
        [0, cc.p(50, -50)]
    )[1]; v; i++ , v = table(
        [0, cc.p(50, 50)],
        [0, cc.p(250, 50)],
        [0, cc.p(50, -50)]
    )[i]) {
        var sprite = GameGuideTimelineAnims._buildBombButterfly()
        sprite.setScale(100 / 70)
        sprite.setPosition(v)
        ph.addChild(sprite)
        ph.setCascadeOpacityEnabled(true)
        table.insert(butterflyBlast, sprite)
    }
    function loopAnim() {
        action.setLastFrameCallFunc(function () {
            action.clearLastFrameCallFunc()
            for (var i = 1, v = bottleBlast[1]; v; i++ , v = bottleBlast[i]) {
                v.playAnim()
            }
            action.setLastFrameCallFunc(function () {
                action.clearLastFrameCallFunc()
                for (var i = 1, v = butterflyBlast[1]; v; i++ , v = butterflyBlast[i]) {
                    v.playAnim()
                }
                action.setLastFrameCallFunc(function () {
                    action.clearLastFrameCallFunc()
                    anim.runAction(cc.Sequence.create(cc.FadeOut.create(0.4), cc.CallFunc.create(function () {
                        loopAnim()
                    })))
                })
                action.play("part3", false)
            })
            action.play("part2", false)
        })
        action.play("part1", false)
        action.pause()
        anim.runAction(cc.Sequence.create(cc.FadeIn.create(0.4), cc.CallFunc.create(function () {
            action.resume()
        })))
    }
    var clip = cc.ClippingRectangleNode.create()
    var bg = anim.getChildByName("guide")
    var size = bg.getContentSize()
    clip.setClippingRegion(cc.rect(0, -size.height * bg.getScaleY(), size.width * bg.getScaleX(), size.height * bg.getScaleY()))
    clip.setClippingEnabled(true)
    clip.addChild(anim)
    clip.setContentSize(cc.size(size.width * bg.getScaleX(), size.height * bg.getScaleY()))
    changeGotoFrameAndPlay(action, loopAnim)

    action.play("part1", false)
    action.pause()
    // FIXME: multi result
    return [clip, action]
}
GameGuideTimelineAnims.venom = function (animConfig) {
    var self = this
    var anim = cc.CSLoader.createNode("cocos/obstacle_anim_venom_guide.csb")
    var action = cc.CSLoader.createTimeline("cocos/obstacle_anim_venom_guide.csb")
    anim.runAction(action)
    var bg = anim.getChildByName("guide")
    anim.setContentSize(bg.getContentSize())
    var blasts = table()
    var ph = anim.getChildByName("blastfx")
    var config = table(
        [0, cc.p(250, 50)],
        [0, cc.p(350, 50)],
        [0, cc.p(450, 50)],
        [0, cc.p(150, -50)],
        [0, cc.p(250, -50)],
        [0, cc.p(350, -50)]
    )
    for (var i = 1, v = config[1]; v; i++ , v = config[i]) {
        var sprite = GameGuideTimelineAnims._destroyEffect()
        var size = sprite.getContentSize()
        sprite.setScale(100 / size.width)
        sprite.setPosition(v)
        ph.addChild(sprite)
        ph.setCascadeOpacityEnabled(true)
        table.insert(blasts, sprite)
    }
    var venoms = table()
    var ph = anim.getChildByName("venom")
    table.insert(venoms, GameGuideTimelineAnims._buildVenom(true))
    table.insert(venoms, GameGuideTimelineAnims._buildVenom(false))
    venoms[1].setScale(100 / 70)
    venoms[1].setPosition(250, -150)
    ph.addChild(venoms[1])
    venoms[2].setScaleX(100 / 70)
    venoms[2].setScaleY(108 / 70)
    venoms[2].setPosition(350, -150)
    ph.addChild(venoms[2])
    function loopAnim() {
        for (var i = 1, v = venoms[1]; v; i++ , v = venoms[i]) {
            v.resetAnim()
        }
        action.setLastFrameCallFunc(function () {
            action.clearLastFrameCallFunc()
            for (var i = 1, v = table(
                1,
                2,
                3
            )[1]; v; i++ , v = table(
                1,
                2,
                3
            )[i]) {
                blasts[v].playAnim()
            }
            action.setLastFrameCallFunc(function () {
                action.clearLastFrameCallFunc()
                venoms[1].appearAnim()
                venoms[2].dirAnim(4)
                action.setLastFrameCallFunc(function () {
                    action.clearLastFrameCallFunc()
                    for (var i = 1, v = table(
                        4,
                        5,
                        6
                    )[1]; v; i++ , v = table(
                        4,
                        5,
                        6
                    )[i]) {
                        blasts[v].playAnim()
                    }
                    venoms[1].destroyAnim()
                    venoms[2].destroyAnim()
                    action.setLastFrameCallFunc(function () {
                        action.clearLastFrameCallFunc()
                        anim.runAction(cc.Sequence.create(cc.FadeOut.create(0.4), cc.CallFunc.create(function () {
                            loopAnim()
                        })))
                    })
                    action.play("part4", false)
                })
                action.play("part3", false)
            })
            action.play("part2", false)
        })
        action.play("part1", false)
        action.pause()
        anim.runAction(cc.Sequence.create(cc.FadeIn.create(0.4), cc.CallFunc.create(function () {
            action.resume()
        })))
    }
    changeGotoFrameAndPlay(action, loopAnim)

    action.play("part1", false)
    action.pause()
    // FIXME: multi result
    return [anim, action]
}
GameGuideTimelineAnims.bossFx2 = function (animConfig) {
    var self = this
    var anim = cc.CSLoader.createNode("cocos/obstacle_anim_boss2_guide.csb")
    var action = cc.CSLoader.createTimeline("cocos/obstacle_anim_boss2_guide.csb")
    anim.runAction(action)
    var clip = cc.ClippingRectangleNode.create()
    clip.setClippingRegion(cc.rect(0, -474.75, 477.95, 474.75))
    clip.setClippingEnabled(true)
    clip.addChild(anim)
    clip.setContentSize(cc.size(477.95, 474.75))
    var bg = anim.getChildByName("bg")
    var bgSize = bg.getContentSize()
    anim.setScale(477.95 / bgSize.width)
    var recScale = anim.getScale()
    var blasts = table()
    var ph = anim.getChildByName("blastfx")
    var config = table(
        [0, cc.p(250, 50)],
        [0, cc.p(350, 50)],
        [0, cc.p(450, 50)]
    )
    for (var i = 1, v = config[1]; v; i++ , v = config[i]) {
        var sprite = GameGuideTimelineAnims._destroyEffect()
        var size = sprite.getContentSize()
        sprite.setScale(100 / size.width)
        sprite.setPosition(v)
        ph.addChild(sprite)
        ph.setCascadeOpacityEnabled(true)
        table.insert(blasts, sprite)
    }
    function loopAnim() {
        anim.setScale(recScale)
        anim.setPosition(cc.p(0, 0))
        action.setLastFrameCallFunc(function () {
            action.clearLastFrameCallFunc()
            anim.runAction(cc.Sequence.create(cc.EaseSineOut.create(cc.Spawn.create(cc.ScaleTo.create(0.3, 1.5 * recScale), cc.MoveBy.create(0.3, cc.p(-30, 190)))), cc.Spawn.create(cc.ScaleTo.create(0.33, 1.42 * recScale), cc.MoveBy.create(0.33, cc.p(10, -20)))))
            action.setLastFrameCallFunc(function () {
                action.clearLastFrameCallFunc()
                for (var i = 1, v = blasts[1]; v; i++ , v = blasts[i]) {
                    v.playAnim()
                }
                action.setLastFrameCallFunc(function () {
                    action.clearLastFrameCallFunc()
                    anim.runAction(cc.Sequence.create(cc.EaseSineOut.create(cc.Spawn.create(cc.ScaleTo.create(0.36, 2.03 * recScale), cc.MoveBy.create(0.36, cc.p(-60, -10)))), cc.Spawn.create(cc.ScaleTo.create(0.4, 1.98 * recScale), cc.MoveBy.create(0.4, cc.p(5, 5)))))
                    action.setLastFrameCallFunc(function () {
                        action.clearLastFrameCallFunc()
                        anim.runAction(cc.EaseSineInOut.create(cc.Spawn.create(cc.ScaleTo.create(0.46, 1.18 * recScale), cc.MoveBy.create(0.46, cc.p(0, -160)))))
                        action.setLastFrameCallFunc(function () {
                            action.clearLastFrameCallFunc()
                            anim.runAction(cc.Sequence.create(cc.FadeOut.create(0.4), cc.CallFunc.create(function () {
                                loopAnim()
                            })))
                        })
                        action.play("part5", false)
                    })
                    action.play("part4", false)
                })
                action.play("part3", false)
            })
            action.play("part2", false)
        })
        action.play("part1", false)
        action.pause()
        anim.runAction(cc.Sequence.create(cc.FadeIn.create(0.4), cc.CallFunc.create(function () {
            action.resume()
        })))
    }
    changeGotoFrameAndPlay(action, loopAnim)

    action.play("part1", false)
    action.pause()
    // FIXME: multi result
    return [clip, action]
}
/*  Cake  */
GameGuideTimelineAnims.cake = function (animConfig) {
    let self = this
    // csb
    let name = "cocos/obstacle_anim_cake_animation.csb"
    let node = cc.CSLoader.createNode(name)
    let anim = cc.CSLoader.createTimeline(name)
    anim.gotoFrameAndPause(1)
    node.setPosition(0, 0)
    node.runAction(anim)
    let blasts = table()
    for (let i = 1; i <= 3; i += 1) {
        // root 
        let bomb = node.getChildByName("boom" + i)
        bomb.setCascadeOpacityEnabled(true)
        let sprite = GameGuideTimelineAnims._destroyEffect()
        sprite.setPosition(50, 50)
        bomb.addChild(sprite)
        table.insert(blasts, sprite)
    }
    function bomb3(fix) {
        for (let k = 1, v = blasts[1]; v; k++, v = blasts[k]) {
            v.playAnim()
            if (!fix) {
                v.setPosition(50, 50)
            } else {
                v.setPosition(-25, 50)
            }
        }
    }
    // bomb 16
    let blasts16 = table()
    for (let i = 4; i <= 19; i += 1) {
        // root 
        let bomb = node.getChildByName("boom" + i)
        bomb.setCascadeOpacityEnabled(true)
        let sprite = GameGuideTimelineAnims._destroyEffect()
        sprite.setPosition(50, 50)
        bomb.addChild(sprite)
        table.insert(blasts16, sprite)
    }
    function bomb16(min, max) {
        let $var585 = min,$limit586 = max
        for (let i = $var585; i <= $limit586; i += 1) {
            blasts16[i].playAnim()
        }
    }
    // anim chain
    let cake = null
    let effect = null
    let states = table()
    function state1() {
        // clean cake
        if (cake) {
            cake.removeCake()
            cake.removeFromParent(true)
            cake = null
        }
        if (effect) {
            effect.removeFromParent(true)
            effect = null
        }
        // tile cake 
        cake = TileAnimationFactory.getInstance().getTileClass("TileCake").create(8)
        cake.setPosition(0, 36)
        cake.mainSp.actionTimeLine.gotoFrameAndPause(0)
        node.addChild(cake)
        anim.gotoFrameAndPlay(1, 27, false)
    }
    states[1] = state1
    function state2() {
        bomb3()
        cake.updateLevel(7)
        anim.gotoFrameAndPlay(28, 71, false)
    }
    states[2] = state2
    function state3() {
        bomb3()
        cake.updateLevel(6)
        anim.gotoFrameAndPlay(72, 93, false)
    }
    states[3] = state3
    function state4() {
        cake.removeCake()
        cake.removeFromParent(true)
        cake = null
        anim.gotoFrameAndPlay(94, 151, false)
    }
    states[4] = state4
    function state5() {
        bomb3()
        cake = TileAnimationFactory.getInstance().getTileClass("TileCake").create(2)
        cake.updateLevel(1)
        cake.setPosition(0, 36)
        node.addChild(cake)
        anim.gotoFrameAndPlay(152, 200, false)
    }
    states[5] = state5
    function state6() {
        bomb3(true)
        cake.updateLevel(0)
        anim.gotoFrameAndPlay(201, 222, false)
    }
    states[6] = state6
    function state7() {
        cake.playBoom(function () {
            effect = CommonEffect.buildColorColorEffect(function () { }, function () { })[0]
            effect.setPosition(35, 50)
            node.addChild(effect)
        })
        anim.gotoFrameAndPlay(223, 344, false)
    }
    states[7] = state7
    function state8() {
        bomb16(1, 8)
        anim.gotoFrameAndPlay(345, 346, false)
    }
    states[8] = state8
    function state9() {
        bomb16(9, 12)
        anim.gotoFrameAndPlay(347, 348, false)
    }
    states[9] = state9
    function state10() {
        bomb16(13, 16)
        anim.gotoFrameAndPlay(349, 421, false)
    }
    states[10] = state10
    let state = 0
    let chainFun = function () {
        // step
        state = state + 1
        states[state]()
        if (state === $len(states)) {
            state = 0
        }
    }
    anim.setLastFrameCallFunc(chainFun)
    anim.playLoop = function () {
        chainFun()
    }
    // FIXME: multi result
    return [node, anim]
}
/*  Cake  */
GameGuideTimelineAnims.waterbomb = function (animConfig) {
    let self = this
    let [w, h] = [350.15, 282.10]
    let clip = cc.ClippingRectangleNode.create()
    clip.setPosition(0, -h)
    clip.setClippingEnabled(true)
    clip.setContentSize(cc.size(w, h))
    clip.setClippingRegion(cc.rect(0, 0, w, h))
    let name = "cocos/obstacle_anim_waterbomb_guide.csb"
    let node = cc.CSLoader.createNode(name)
    let anim = cc.CSLoader.createTimeline(name)
    node.runAction(anim)
    anim.gotoFrameAndPause(0)
    node.setPosition(-194, 642)
    node.setCascadeOpacityEnabled(true)
    clip.addChild(node)
    let blasts = table()
    for (let i = 1; i <= 3; i += 1) {
        // blast
        let sprite = GameGuideTimelineAnims._destroyEffect()
        sprite.setPosition(0, 0)
        clip.addChild(sprite, 999)
        table.insert(blasts, sprite)
    }
    let xy = table()
    xy[1] = table()
    xy[2] = table(
        [0, table(245, 35)],
        [0, table(245, 105)],
        [0, table(245, 175)]
    )
    xy[3] = table(
        [0, table(175, 105)],
        [0, table(245, 105)],
        [0, table(315, 105)]
    )
    function bomb3(idxa) {
        // idx
        if (idxa === 1) {
            return 
        }
        // play
        let xya = xy[idxa]
        for (let k = 1, v = blasts[1]; v; k++, v = blasts[k]) {
            let [x, y] = unpack(xya[k])
            v.playAnim()
            v.setPosition(x, y - 2)
        }
    }
    // chain funs
    let idx = 0
    let cfg = table(
        [0, table(0, 91)],
        [0, table(92, 167)],
        [0, table(168, 249)]
    )
    let chainFun = function () {
        // step
        idx = idx + 1
        let [s, e] = unpack(cfg[idx])
        bomb3(idx)
        anim.gotoFrameAndPlay(s, e, false)
        if (idx === $len(cfg)) {
            idx = 0
        }
    }
    anim.setLastFrameCallFunc(chainFun)
    anim.playLoop = function () {
        chainFun()
    }
    // FIXME: multi result
    return [clip, anim]
}
GameGuideTimelineAnims.bowknot = function (animConfig) {
    let self = this
    let name = "cocos/obstacle_anim_bowknot_guide.csb"
    let anim = cc.CSLoader.createNode(name)
    let action = cc.CSLoader.createTimeline(name)
    anim.setCascadeOpacityEnabled(true)
    anim.runAction(action)
    let size = anim.getChildByName("checkboard_115").getContentSize()
    anim.setContentSize(size)
    let clip = cc.ClippingRectangleNode.create(size)
    clip.setClippingRegion(cc.rect(0, -size.height, size.width, size.height))
    clip.setContentSize(cc.size(size.width, size.height))
    clip.setClippingEnabled(true)
    clip.addChild(anim)
    FrameLoader.loadImageWithPlist("flash/bomb.plist")
    FrameLoader.loadImageWithPlist("flash/bowknot_e.plist")
    let width = 70
    let [posX, posY] = [50, 50]
    let config = table(
        [0, table([1, "pos", cc.p(posX, posY)], [1, "pName", "all_blast_1"])],
        [0, table([1, "pos", cc.p(posX, posY)], [1, "pName", "all_blast_2"])],
        [0, table([1, "pos", cc.p(posX, posY)], [1, "pName", "all_blast_3"])],
        [0, table([1, "pos", cc.p(posX, posY)], [1, "pName", "all_blast_4"])],
        [0, table([1, "pos", cc.p(posX, posY)], [1, "pName", "all_blast_5"])],
        [0, table([1, "pos", cc.p(posX, posY)], [1, "pName", "all_blast_6"])],
        [0, table([1, "pos", cc.p(posX, posY)], [1, "pName", "all_blast_7"])]
    )
    let blasts = table()
    let $limit623 = $len(config)
    for (let i = 1; i <= $limit623; i += 1) {
        // let sprite = GameGuideTimelineAnims._destroyEffect()
        let sprite = GameGuideTimelineAnims._destroyEffect()
        let size = sprite.getContentSize()
        sprite.setScale(width / size.width)
        sprite.setPosition(config[i].pos)
        anim.getChildByName(config[i].pName).addChild(sprite)
        table.insert(blasts, sprite)
    }
    let butterflys = table()
    for (let i = 1; i <= 4; i += 1) {
        // let sprite = TileAnimationFactory.getInstance().getTileClass("TileMissile").create()
        let sprite = TileMissile.create()
        sprite.setPosition(posX, posY)
        anim.getChildByName("butterfly_" + i).addChild(sprite)
        sprite.setCascadeOpacityEnabled(true)
        sprite.guideFly()
        table.insert(butterflys, sprite)
    }
    let blasts1 = table(
        [0, blasts[5]],
        [0, blasts[6]],
        [0, blasts[7]]
    )
    let blasts2 = table(
        [0, blasts[4]],
        [0, blasts[6]],
        [0, blasts[7]]
    )
    let blasts3 = table(
        [0, blasts[2]],
        [0, blasts[3]],
        [0, blasts[4]]
    )
    let blasts4 = table([0, blasts[1]])
    let blastAry = table(
        [0, blasts1],
        [0, blasts2],
        [0, blasts3],
        [0, blasts4]
    )
    function blastPart(id) {
        let $limit638 = $len(blastAry[id])
        for (let i = 1; i <= $limit638; i += 1) {
            blastAry[id][i].playAnim()
        }
    }
    let bowknot = TileAnimationFactory.getInstance().getTileClass("TileBowknot").create(3)
    bowknot.setPosition(posX, posY)
    anim.getChildByName("butterfly").addChild(bowknot)
    let animAry = table(
        "part1",
        "anim1",
        "part2",
        "anim2",
        "anim3",
        "part3",
        "anim4",
        "anim5",
        "part4",
        "part5",
        "part6"
    )
    function loopAnim() {
        let __VA_ARG = $slice(arguments, 0)
        let curAnimIdx = 1
        function playNext() {
            let __VA_ARG = $slice(arguments, 0)
            action.clearLastFrameCallFunc()
            action.setLastFrameCallFunc(playNext)
            action.play(animAry[curAnimIdx], false)
            if (curAnimIdx === 1) { //part1
            } else if (curAnimIdx === 2) {
                bowknot.playDec(2)
            } else if (curAnimIdx === 3) {
                blastPart(1)
            } else if (curAnimIdx === 4) { //anim2
            } else if (curAnimIdx === 5) {
                bowknot.playDec(1)
            } else if (curAnimIdx === 6) {
                blastPart(2)
            } else if (curAnimIdx === 7) { //anim4
            } else if (curAnimIdx === 8) {
                bowknot.playDec(0)
            } else if (curAnimIdx === 9) {
                blastPart(3)
            } else if (curAnimIdx === 10) { //part5
            } else if (curAnimIdx === 11) {
                blastPart(4)
            }
            if (curAnimIdx < 11) {
                curAnimIdx = curAnimIdx + 1
            } else {
                curAnimIdx = 1
                bowknot.level = 3
                bowknot.update()
            }
        }
        playNext()
    }
    // action.gotoFrameAndPlay = function (self) {
    //     loopAnim()
    // }

    changeGotoFrameAndPlay(action, loopAnim)
    action.play("part1", false)
    action.pause()
    // FIXME: multi result
    return [clip, action]
}
GameGuideTimelineAnims.corssProp = function (animConfig) {
    let self = this
    // csb
    let name = "cocos/obstacle_anim_cross_item_guide.csb"
    let node = cc.CSLoader.createNode(name)
    let anim = cc.CSLoader.createTimeline(name)
    node.setPosition(-200, 250)
    node.runAction(anim)
    let ph = node.getChildByName("water")
    let width = 70
    let config = table(
        [0, cc.p(50, 50)],
        [0, cc.p(50 + width, 50)],
        [0, cc.p(50 + width * 2, 50)],
        [0, cc.p(50 - width, 50)],
        [0, cc.p(50 - width * 2, 50)],
        [0, cc.p(50, 50 - width)],
        [0, cc.p(50, 50 + width)],
        [0, cc.p(50, 50 + width * 2)]
    )
    let blasts = table()
    for (let i = 1, v = config[1]; v; i++, v = config[i]) {
        let sprite = GameGuideTimelineAnims._destroyEffect()
        let size = sprite.getContentSize()
        sprite.setScale(width / size.width)
        sprite.setPosition(v)
        ph.addChild(sprite, -1)
        ph.setCascadeOpacityEnabled(true)
        table.insert(blasts, sprite)
    }
    function blastEffect() {
        for (let k = 1, v = blasts[1]; v; k++, v = blasts[k]) {
            v.playAnim()
        }
    }
    width = 352
    let height = 282
    let clip = cc.ClippingRectangleNode.create()
    clip.setClippingEnabled(true)
    clip.setPosition(-width / 2 + 52, -height / 2 + 88)
    clip.setContentSize(cc.size(width, height))
    clip.setClippingRegion(cc.rect(0, 0, width, height))
    ph.addChild(clip)
    function lineEffect() {
        let pos = cc.p(width / 2, height / 2 - 35)
        let effect = CommonEffect.buildLineEffect()
        effect.setPosition(pos)
        clip.addChild(effect)
        effect = CommonEffect.buildLineEffect()
        effect.setRotation(90)
        effect.setPosition(pos)
        clip.addChild(effect)
        let effectWater = CommonEffect.buildLineWater()
        effectWater.setPosition(pos)
        clip.addChild(effectWater)
        effect = CommonEffect.buildLineCross()
        effect.setPosition(pos)
        clip.addChild(effect)
    }
    anim.playLoop = function () {
        anim.gotoFrameAndPlay(0, true)
        node.runAction(cc.RepeatForever.create(cc.Sequence.create(cc.DelayTime.create(1.15), cc.CallFunc.create(lineEffect), cc.DelayTime.create(0.2), cc.CallFunc.create(blastEffect), cc.DelayTime.create(1.15))))
    }
    // FIXME: multi result
    return [node, anim]
}
GameGuideTimelineAnims.jellyfish = function (animConfig) {
    let self = this
    let anim = cc.CSLoader.createNode("cocos/obstacle_anim_jellyfish_guide.csb")
    let action = cc.CSLoader.createTimeline("cocos/obstacle_anim_jellyfish_guide.csb")
    anim.runAction(action)
    var bg = anim.getChildByName("guide")
    anim.setContentSize(bg.getContentSize())
    syncRequireGameModule("clover/animation/TileCharacter")
    FrameLoader.loadImageWithPlist("flash/chicken.plist")
    FrameLoader.loadImageWithPlist("flash/TileEffect.plist")
    var ph = anim.getChildByName("chickenfx")
    var sprite = TileCharacter.create("chicken")
    sprite.play(kTileCharacterAnimation.kLineColumn)
    sprite.setCascadeOpacityEnabled(true)
    var $st567 = sprite.getChildren()
    for (var i = 1, v = $st567[1]; v; i++ , v = $st567[i]) {
        v.setCascadeOpacityEnabled(true)
    }
    var size = sprite.mainSprite.getContentSize()
    sprite.setScale(100 / size.width * 1.1)
    sprite.setPosition(cc.p(50, 50))
    ph.addChild(sprite)
    var blasts = table()
    var ph = anim.getChildByName("blastfx")
    var config = table(
        [0, cc.p(50, 50)],
        [0, cc.p(150, 50)],
        [0, cc.p(250, 50)],
        [0, cc.p(250, -50)],
        [0, cc.p(250, -250)]
    )
    for (var i = 1, v = config[1]; v; i++ , v = config[i]) {
        var sprite = GameGuideTimelineAnims._destroyEffect()
        var size = sprite.getContentSize()
        sprite.setScale(100 / size.width)
        sprite.setPosition(v)
        ph.addChild(sprite)
        ph.setCascadeOpacityEnabled(true)
        table.insert(blasts, sprite)
    }
    var venom = GameGuideTimelineAnims._buildVenom(true)
    venom.setScale(10 / 7)
    venom.setPosition(cc.p(150, -150))
    ph.addChild(venom)
    var jellyfish = GameGuideTimelineAnims._buildJellyfish(1)
    jellyfish.setScale(9 / 7)
    jellyfish.setPosition(cc.p(250, -150))
    ph.addChild(jellyfish)
    var ph = anim.getChildByName("linefx")
    function loopAnim() {
        venom.resetAnim()
        jellyfish.resetAnim()
        action.setLastFrameCallFunc(function () {
            action.clearLastFrameCallFunc()
            venom.appearAnim()
            jellyfish.splitAnim(4)
            action.setLastFrameCallFunc(function () {
                action.clearLastFrameCallFunc()
                var GameGuideTimelineFx = require("clover/gameGuide/GameGuideTimelineLineFx")
                var fx = GameGuideTimelineFx.create(true)
                fx.setPosition(cc.p(250, 50))
                ph.addChild(fx)
                for (var i = 1, v = table(
                    1,
                    2,
                    3
                )[1]; v; i++ , v = table(
                    1,
                    2,
                    3
                )[i]) {
                    blasts[v].playAnim()
                }
                action.setLastFrameCallFunc(function () {
                    action.clearLastFrameCallFunc()
                    for (var i = 1, v = table(4, 5)[1]; v; i++ , v = table(4, 5)[i]) {
                        blasts[v].playAnim()
                    }
                    jellyfish.playBeaten(0)
                    action.setLastFrameCallFunc(function () {
                        action.clearLastFrameCallFunc()
                        anim.runAction(cc.Sequence.create(cc.FadeOut.create(0.4), cc.CallFunc.create(function () {
                            loopAnim()
                        })))
                    })
                    action.play("part4", false)
                })
                action.play("part3", false)
            })
            action.play("part2", false)
        })
        action.play("part1", false)
        action.pause()
        anim.runAction(cc.Sequence.create(cc.FadeIn.create(0.4), cc.CallFunc.create(function () {
            action.resume()
        })))
    }
    changeGotoFrameAndPlay(action, loopAnim)

    action.play("part1", false)
    action.pause()
    // FIXME: multi result
    return [anim, action]

}
GameGuideTimelineAnims.lotus = function (animConfig) {
    var self = this
    var anim = cc.CSLoader.createNode("cocos/obstacle_anim_lotus_guide.csb")
    var action = cc.CSLoader.createTimeline("cocos/obstacle_anim_lotus_guide.csb")
    anim.runAction(action)
    var bg = anim.getChildByName("dii")
    anim.setContentSize(bg.getContentSize())
    var river = anim.getChildByName("river")
    var config = table(
        [0, cc.p(50, 50)],
        [0, cc.p(50, -50)],
        [0, cc.p(50, -150)],
        [0, cc.p(50, -250)],
        [0, cc.p(50, -350)]
    )
    for (var i = 1, v = config[1]; v; i++ , v = config[i]) {
        var road = GameGuideTimelineAnims._createWaterNormal()
        var size = road.getContentSize()
        road.setScaleX(101 / size.width)
        road.setScaleY(101 / size.height)
        road.setPosition(v)
        road.setRotation(-90)
        river.addChild(road)
    }
    var config = table(
        [0, table([1, "color", 3], [1, "panic", true])],
        [0, table([1, "color", 4], [1, "panic", false])],
        [0, table([1, "color", 4], [1, "panic", true])],
        [0, table([1, "color", 4], [1, "panic", false])]
    )
    var fishes = table()
    for (var i = 1, v = config[1]; v; i++ , v = config[i]) {
        var fishLayer = anim.getChildByName("fish" + tostring(i + 1))
        var fish = GameGuideTimelineAnims._createFishNormal(v.color)
        var size = fish.getContentSize()
        fish.setScaleX(110 / size.width)
        fish.setScaleY(110 / size.height)
        fish.setPosition(cc.p(45, 55))
        fishLayer.addChild(fish)
        var panic
        if (v.panic) {
            panic = GameGuideTimelineAnims._createFishPanic(v.color)
            var size = panic.getContentSize()
            panic.setScaleX(110 / size.width)
            panic.setScaleY(110 / size.height)
            panic.setPosition(cc.p(45, 55))
            fishLayer.addChild(panic)
        }
        fish.normal = function (self) {
            fish.setVisible(true)
            if (panic) {
                panic.setVisible(false)
            }
        }
        fish.panic = function (self) {
            if (panic) {
                fish.setVisible(false)
                panic.setVisible(true)
            }
        }
        fish.normal()
        table.insert(fishes, fish)
    }
    var gate = anim.getChildByName("entrance")
    var entranceAnim = GameGuideTimelineAnims._createWaterEntrance()
    var aSize = entranceAnim.getContentSize()
    entranceAnim.setScaleX(103 / aSize.width)
    entranceAnim.setScaleY(103 / aSize.height)
    entranceAnim.setRotation(-90)
    entranceAnim.setPosition(cc.p(51, 50))
    gate.addChild(entranceAnim)
    var sprays = table()
    var config = table([0, cc.p(50, 150)], [0, cc.p(50, 350)])
    for (var i = 1, v = config[1]; v; i++ , v = config[i]) {
        var sprite = GameGuideTimelineAnims._createWaterSpray()
        sprite.setPosition(v)
        gate.addChild(sprite)
        table.insert(sprays, sprite)
    }
    var blasts = table()
    var ph = anim.getChildByName("blastfx")
    var config = table(
        [0, cc.p(50, -150)],
        [0, cc.p(150, -150)],
        [0, cc.p(250, -150)]
    )
    for (var i = 1, v = config[1]; v; i++ , v = config[i]) {
        var sprite = GameGuideTimelineAnims._destroyEffect()
        var size = sprite.getContentSize()
        sprite.setScale(100 / size.width)
        sprite.setPosition(v)
        ph.addChild(sprite)
        ph.setCascadeOpacityEnabled(true)
        table.insert(blasts, sprite)
    }
    var leaf = anim.getChildByName("leaf")
    var sprite = GameGuideTimelineAnims._buildLotus()
    sprite.setScale(10 / 7)
    sprite.setPosition(cc.p(50, 50))
    leaf.addChild(sprite)
    function loopAnim() {
        for (var i = 1, v = fishes[1]; v; i++ , v = fishes[i]) {
            v.normal()
        }
        action.setLastFrameCallFunc(function () {
            action.clearLastFrameCallFunc()
            for (var i = 1, v = blasts[1]; v; i++ , v = blasts[i]) {
                v.playAnim()
            }
            for (var i = 1, v = table(1, 3)[1]; v; i++ , v = table(1, 3)[i]) {
                fishes[v].panic()
            }
            action.setLastFrameCallFunc(function () {
                action.clearLastFrameCallFunc()
                sprays[1].playAnim()
                action.setLastFrameCallFunc(function () {
                    action.clearLastFrameCallFunc()
                    sprays[2].playAnim()
                    action.setLastFrameCallFunc(function () {
                        action.clearLastFrameCallFunc()
                        sprite.playWave(1)
                        action.setLastFrameCallFunc(function () {
                            action.clearLastFrameCallFunc()
                            anim.runAction(cc.Sequence.create(cc.FadeOut.create(0.4), cc.CallFunc.create(function () {
                                loopAnim()
                            })))
                        })
                        action.play("part5", false)
                    })
                    action.play("part4", false)
                })
                action.play("part3", false)
            })
            action.play("part2", false)
        })
        action.play("part1", false)
        action.pause()
        anim.runAction(cc.Sequence.create(cc.FadeIn.create(0.4), cc.CallFunc.create(function () {
            action.resume()
        })))
    }
    changeGotoFrameAndPlay(action, loopAnim)

    action.play("part1", false)
    action.pause()
    // FIXME: multi result
    return [anim, action]
}
GameGuideTimelineAnims.lighthouse = function (animConfig) {
    var self = this
    var anim = cc.CSLoader.createNode("cocos/obstacle_anim_lighthouse_guide.csb")
    anim.setCascadeOpacityEnabled(true)
    var action = cc.CSLoader.createTimeline("cocos/obstacle_anim_lighthouse_guide.csb")
    anim.runAction(action)
    var blasts = table()
    var ph = anim.getChildByName("blastfx")
    var config = table(
        [0, cc.p(50, -50)],
        [0, cc.p(150, -50)],
        [0, cc.p(250, -50)]
    )
    for (var i = 1, v = config[1]; v; i++ , v = config[i]) {
        var sprite = GameGuideTimelineAnims._destroyEffect()
        var size = sprite.getContentSize()
        sprite.setScale(100 / size.width)
        sprite.setPosition(v)
        ph.addChild(sprite)
        ph.setCascadeOpacityEnabled(true)
        table.insert(blasts, sprite)
    }
    var [hives, bees] = [table(1, 0), table()]
    for (var i = 1; i <= 2; i += 1) {
        var hive = anim.getChildByName("hive" + tostring(i))
        var sp = GameGuideTimelineAnims._buildLighthouse(hives[i])
        sp.setScale(1.2)
        sp.setPosition(cc.p(50, 50))
        hive.addChild(sp)
        hives[i] = sp
        var bee = anim.getChildByName("bee" + tostring(i))
        var sp = GameGuideTimelineAnims._buildBee()
        bee.addChild(sp)
        bees[i] = sp
    }
    function loopAnim() {
        for (var i = 1, v = bees[1]; v; i++ , v = bees[i]) {
            v.reset()
        }
        for (var i = 1, v = hives[1]; v; i++ , v = hives[i]) {
            v.reset()
        }
        anim.setPosition(cc.p(-24, 264))
        anim.setScale(1)
        action.setLastFrameCallFunc(function () {
            action.clearLastFrameCallFunc()
            action.setLastFrameCallFunc(function () {
                action.clearLastFrameCallFunc()
                for (var i = 1, v = blasts[1]; v; i++ , v = blasts[i]) {
                    v.playAnim()
                }
                hives[2].playAnim()
                action.setLastFrameCallFunc(function () {
                    action.clearLastFrameCallFunc()
                    for (var i = 1, v = hives[1]; v; i++ , v = hives[i]) {
                        v.finAnim()
                    }
                    action.setLastFrameCallFunc(function () {
                        action.clearLastFrameCallFunc()
                        for (var i = 1, v = bees[1]; v; i++ , v = bees[i]) {
                            v.addTail()
                        }
                        action.setLastFrameCallFunc(function () {
                            action.clearLastFrameCallFunc()
                            anim.runAction(cc.Spawn.create(cc.MoveTo.create(0.35, cc.p(-120, 500)), cc.ScaleTo.create(0.35, 1.5)))
                            action.setLastFrameCallFunc(function () {
                                action.clearLastFrameCallFunc()
                                for (var i = 1; i<=bees.length; i++) {
                                    let v = bees[i]
                                    if(v==null) {
                                        break
                                    }
                                    v.removeTail()
                                    v.playAnim()
                                    v.runAction(cc.Sequence.create(cc.DelayTime.create(0.5), cc.CallFunc.create(function () {
                                        v.addTail()
                                    })))
                                }
                                action.setLastFrameCallFunc(function () {
                                    action.clearLastFrameCallFunc()
                                    anim.runAction(cc.Spawn.create(cc.MoveTo.create(0.23, cc.p(0, 0)), cc.ScaleTo.create(0.23, 0.78)))
                                    action.setLastFrameCallFunc(function () {
                                        action.clearLastFrameCallFunc()
                                        anim.runAction(cc.Spawn.create(cc.MoveTo.create(0.2, cc.p(-240, 0)), cc.ScaleTo.create(0.2, 1.25)))
                                        action.setLastFrameCallFunc(function () {
                                            action.clearLastFrameCallFunc()
                                            bees[1].removeTail()
                                            action.setLastFrameCallFunc(function () {
                                                action.clearLastFrameCallFunc()
                                                bees[2].removeTail()
                                                action.setLastFrameCallFunc(function () {
                                                    action.clearLastFrameCallFunc()
                                                    anim.runAction(cc.Sequence.create(cc.FadeOut.create(0.4), cc.CallFunc.create(loopAnim)))
                                                })
                                                action.play("ex3", false)
                                            })
                                            action.play("ex2", false)
                                        })
                                        action.play("part8", false)
                                    })
                                    action.play("part7", false)
                                })
                                action.play("part6", false)
                            })
                            action.play("part5", false)
                        })
                        action.play("ex1", false)
                    })
                    action.play("part4", false)
                })
                action.play("part3", false)
            })
            action.play("part2", false)
        })
        action.play("part1", false)
        action.pause()
        anim.runAction(cc.Sequence.create(cc.FadeIn.create(0.4), cc.CallFunc.create(function () {
            action.resume()
        })))
    }
    anim.setPosition(cc.p(-24, 264))
    var clip = cc.ClippingRectangleNode.create()
    clip.setClippingRegion(cc.rect(0, -350, 350, 350))
    clip.setClippingEnabled(true)
    clip.addChild(anim)
    clip.setContentSize(cc.size(350, 350))
    changeGotoFrameAndPlay(action, loopAnim)

    action.play("part1", false)
    action.pause()
    // FIXME: multi result
    return [clip, action]
}
GameGuideTimelineAnims.teamGetStar = function () {
    let self = this
    let anim = cc.CSLoader.createNode("cocos/game_guide_new_teamgetstar_all.csb")
    let action = cc.CSLoader.createTimeline("cocos/game_guide_new_teamgetstar_all.csb")
    action.setTimeSpeed(0.5)
    anim.runAction(action)
    let clip = cc.ClippingRectangleNode.create()
    clip.setClippingRegion(cc.rect(0, -440, 435, 440))
    clip.setContentSize(cc.size(435, 440))
    clip.setClippingEnabled(true)
    clip.addChild(anim)
    let playFrame = action.gotoFrameAndPlay
    function loopAnim() {
        action.setLastFrameCallFunc(function () {
            action.clearLastFrameCallFunc()
            anim.runAction(cc.Sequence.create(cc.FadeOut.create(0.4), cc.CallFunc.create(loopAnim)))
        })
        playFrame.call(action, 0, false)
        action.pause()
        anim.runAction(cc.Sequence.create(cc.FadeIn.create(0.4), cc.CallFunc.create(function () {
            action.resume()
        })))
    }    
    changeGotoFrameAndPlay(action, loopAnim)
    playFrame.call(action, 0, false)
    action.pause()
    // FIXME: multi result
    return [clip, action]
}
GameGuideTimelineAnims.hat = function () {
    let self = this
    let anim = cc.CSLoader.createNode("cocos/obstacle_anim_hat_animation.csb")
    let action = cc.CSLoader.createTimeline("cocos/obstacle_anim_hat_animation.csb")
    anim.runAction(action)
    let bg = anim.getChildByName("checkboard")
    anim.setContentSize(bg.getContentSize())
    let blasts = table()
    let ph = anim.getChildByName("blastfx")
    let config = table(
        [0, cc.p(50, -50)],
        [0, cc.p(150, -50)],
        [0, cc.p(250, 50)],
        [0, cc.p(250, -50)],
        [0, cc.p(250, -250)],
        [0, cc.p(350, -50)],
        [0, cc.p(450, -50)]
    )
    for (let i = 1, v = config[1]; v; i++, v = config[i]) {
        let sprite = GameGuideTimelineAnims._destroyEffect()
        let size = sprite.getContentSize()
        sprite.setScale(100 / size.width)
        sprite.setPosition(v)
        ph.addChild(sprite)
        ph.setCascadeOpacityEnabled(true)
        table.insert(blasts, sprite)
    }
    let linefx = anim.getChildByName("linefx")
    function loopAnim() {
        action.setLastFrameCallFunc(function () {
            action.clearLastFrameCallFunc()
            let $st709 = table(3, 4)
            for (let i = 1, v = $st709[1]; v; i++, v = $st709[i]) {
                blasts[v].playAnim()
            }
            action.setLastFrameCallFunc(function () {
                action.clearLastFrameCallFunc()
                let $st711 = table(4, 5)
                for (let i = 1, v = $st711[1]; v; i++, v = $st711[i]) {
                    blasts[v].playAnim()
                }
                action.setLastFrameCallFunc(function () {
                    action.clearLastFrameCallFunc()
                    let GameGuideTimelineFx = require("clover/gameGuide/GameGuideTimelineLineFx")
                    let fx = GameGuideTimelineFx.create(false)
                    fx.setScale(100 / 70)
                    fx.setPosition(cc.pAdd(cc.p(ph.getPosition()), cc.p(20, 80)))
                    linefx.addChild(fx)
                    action.setLastFrameCallFunc(function () {
                        action.clearLastFrameCallFunc()
                        let $st715 = table(
                            1,
                            2,
                            6,
                            7
                        )
                        for (let i = 1, v = $st715[1]; v; i++, v = $st715[i]) {
                            blasts[v].playAnim()
                        }
                        action.setLastFrameCallFunc(function () {
                            action.clearLastFrameCallFunc()
                            anim.runAction(cc.Sequence.create(cc.FadeOut.create(0.4), cc.CallFunc.create(function () {
                                loopAnim()
                            })))
                        })
                        action.play("part5", false)
                    })
                    action.play("part4", false)
                })
                action.play("part3", false)
            })
            action.play("part2", false)
        })
        action.play("part1", false)
        action.pause()
        anim.runAction(cc.Sequence.create(cc.FadeIn.create(0.4), cc.CallFunc.create(function () {
            action.resume()
        })))
    }
    // action.gotoFrameAndPlay = function (self) {
    //     loopAnim()
    // }
    changeGotoFrameAndPlay(action, loopAnim)
    action.play("part1", false)
    action.pause()
    // FIXME: multi result
    return [anim, action]
}
GameGuideTimelineAnims.colorCollector = function () {
    let self = this
    let anim = cc.CSLoader.createNode("cocos/obstacle_anim_tilecolorcollector_animation.csb")
    let action = cc.CSLoader.createTimeline("cocos/obstacle_anim_tilecolorcollector_animation.csb")
    anim.runAction(action)
    let bg = anim.getChildByName("checkboard_32")
    anim.setContentSize(bg.getContentSize())
    let blasts = table()
    let ph = anim.getChildByName("blastfx")
    let config = table(
        [0, cc.p(250, 50)],
        [0, cc.p(350, 50)],
        [0, cc.p(450, 50)],
        [0, cc.p(50, -50)],
        [0, cc.p(50, -150)],
        [0, cc.p(50, -250)],
        [0, cc.p(150, -50)],
        [0, cc.p(250, -50)],
        [0, cc.p(350, -50)],
        [0, cc.p(150, -150)],
        [0, cc.p(350, -150)],
        [0, cc.p(150, -250)],
        [0, cc.p(250, -250)],
        [0, cc.p(350, -250)]
    )
    for (let i = 1, v = config[1]; v; i++, v = config[i]) {
        let sprite = GameGuideTimelineAnims._destroyEffect()
        let size = sprite.getContentSize()
        sprite.setScale(100 / size.width)
        sprite.setPosition(v)
        ph.addChild(sprite)
        ph.setCascadeOpacityEnabled(true)
        table.insert(blasts, sprite)
    }
    ph = anim.getChildByName("collector")
    ph.setCascadeOpacityEnabled(true)
    let fish = GameGuideTimelineAnims._pufferFish(1, 4, 10)
    fish.setScale(100 / 70)
    fish.setPosition(cc.p(50, 50))
    ph.addChild(fish)
    function loopAnim() {
        fish.resetAnim()
        action.setLastFrameCallFunc(function () {
            action.clearLastFrameCallFunc()
            let $st730 = table(
                1,
                2,
                3
            )
            for (let i = 1, v = $st730[1]; v; i++, v = $st730[i]) {
                blasts[v].playAnim()
            }
            action.setLastFrameCallFunc(function () {
                action.clearLastFrameCallFunc()
                fish.playAnim(1)
                action.setLastFrameCallFunc(function () {
                    action.clearLastFrameCallFunc()
                    let $st732 = table(
                        4,
                        5,
                        6
                    )
                    for (let i = 1, v = $st732[1]; v; i++, v = $st732[i]) {
                        blasts[v].playAnim()
                    }
                    action.setLastFrameCallFunc(function () {
                        action.clearLastFrameCallFunc()
                        fish.endingAnim()
                        action.setLastFrameCallFunc(function () {
                            action.clearLastFrameCallFunc()
                            action.setLastFrameCallFunc(function () {
                                action.clearLastFrameCallFunc()
                                fish.finAnim()
                                action.setLastFrameCallFunc(function () {
                                    action.clearLastFrameCallFunc()
                                    let $st734 = table(
                                        7,
                                        8,
                                        9,
                                        10,
                                        11,
                                        12,
                                        13,
                                        14
                                    )
                                    for (let i = 1, v = $st734[1]; v; i++, v = $st734[i]) {
                                        blasts[v].playAnim()
                                    }
                                    action.setLastFrameCallFunc(function () {
                                        action.clearLastFrameCallFunc()
                                        anim.runAction(cc.Sequence.create(cc.FadeOut.create(0.4), cc.CallFunc.create(loopAnim)))
                                    })
                                    action.play("part8", false)
                                })
                                action.play("part7", false)
                            })
                            action.play("part6", false)
                        })
                        action.play("part5", false)
                    })
                    action.play("part4", false)
                })
                action.play("part3", false)
            })
            action.play("part2", false)
        })
        action.play("part1", false)
        action.pause()
        anim.runAction(cc.Sequence.create(cc.FadeIn.create(0.4), cc.CallFunc.create(function () {
            action.resume()
        })))
    }
    // action.gotoFrameAndPlay = function () {
    //     loopAnim()
    // }
    changeGotoFrameAndPlay(action, loopAnim)
    fish.resetAnim()
    action.play("part1", false)
    action.pause()
    // FIXME: multi result
    return [anim, action]
}
GameGuideTimelineAnims.colorFish = function () {
    let self = this
    let anim = cc.CSLoader.createNode("cocos/obstacle_anim_color_fish_guide.csb")
    let action = cc.CSLoader.createTimeline("cocos/obstacle_anim_color_fish_guide.csb")
    anim.runAction(action)
    let river = anim.getChildByName("river")
    let config = table(
        [0, table(
            [1, "isCorner", false],
            [1, "position", cc.p(50, -150)],
            [1, "rotation", 0]
        )],
        [0, table(
            [1, "isCorner", false],
            [1, "position", cc.p(150, -150)],
            [1, "rotation", 0]
        )],
        [0, table(
            [1, "isCorner", false],
            [1, "position", cc.p(250, -150)],
            [1, "rotation", 0]
        )],
        [0, table(
            [1, "isCorner", false],
            [1, "position", cc.p(350, -150)],
            [1, "rotation", 0]
        )],
        [0, table(
            [1, "isCorner", false],
            [1, "position", cc.p(450, -150)],
            [1, "rotation", 0]
        )],
        [0, table(
            [1, "isCorner", false],
            [1, "position", cc.p(550, -150)],
            [1, "rotation", 0]
        )]
    )
    for (let i = 1, v = config[1]; v; i++, v = config[i]) {
        let road
        if (v.isCorner) {
            road = GameGuideTimelineAnims._createWaterCorner()
        } else {
            road = GameGuideTimelineAnims._createWaterNormal()
        }
        let size = road.getContentSize()
        if (v.isCorner) {
            road.setScaleX(-101 / size.width)
        } else {
            road.setScaleX(101 / size.width)
        }
        road.setScaleY(101 / size.height)
        road.setPosition(v.position)
        road.setRotation(v.rotation)
        river.addChild(road)
    }
    let sprays = table()
    config = table(
        [0, cc.p(150, -150)],
        [0, cc.p(250, -150)],
        [0, cc.p(350, -150)],
        [0, cc.p(450, -150)]
    )
    for (let i = 1, v = config[1]; v; i++, v = config[i]) {
        let sprite = GameGuideTimelineAnims._createWaterSpray()
        sprite.setPosition(v)
        river.addChild(sprite)
        table.insert(sprays, sprite)
    }
    let gate = anim.getChildByName("entrance")
    let entranceAnim = GameGuideTimelineAnims._createWaterEntrance()
    let aSize = entranceAnim.getContentSize()
    entranceAnim.setScaleX(103 / aSize.width)
    entranceAnim.setScaleY(103 / aSize.height)
    entranceAnim.setRotation(0)
    entranceAnim.setPosition(cc.p(51, 49))
    gate.addChild(entranceAnim)
    let exit = anim.getChildByName("exit")
    let exitAnim = GameGuideTimelineAnims._createWaterExit()
    aSize = exitAnim.getContentSize()
    exitAnim.setScaleX(103 / aSize.width)
    exitAnim.setScaleY(103 / aSize.height)
    exitAnim.setPosition(cc.p(48, 48))
    exit.addChild(exitAnim)
    config = table(
        [0, table([1, "color", 1], [1, "panic", false])],
        [0, table([1, "color", 4], [1, "panic", true])],
        [0, table([1, "color", 5], [1, "panic", true])],
        [0, table([1, "color", 1], [1, "panic", true])],
        [0, table([1, "color", 6], [1, "panic", true])],
        [0, table([1, "color", 6], [1, "panic", false])],
        [0, table([1, "color", 1], [1, "panic", false])],
        [0, table([1, "color", 5], [1, "panic", false])],
        [0, table([1, "color", 4], [1, "panic", false])]
    )
    let fishes = table()
    for (let i = 1, v = config[1]; v; i++, v = config[i]) {
        let fishLayer = anim.getChildByName("fish" + tostring(i))
        let fish = GameGuideTimelineAnims._createFishNormal(v.color)
        let size = fish.getContentSize()
        fish.setScaleX(110 / size.width)
        fish.setScaleY(110 / size.height)
        fish.setPosition(cc.p(45, 55))
        fishLayer.addChild(fish)
        let panic
        if (v.panic) {
            panic = GameGuideTimelineAnims._createFishPanic(v.color)
            let size = panic.getContentSize()
            panic.setScaleX(110 / size.width)
            panic.setScaleY(110 / size.height)
            panic.setPosition(cc.p(45, 55))
            fishLayer.addChild(panic)
        }
        fish.normal = function (self) {
            fish.setVisible(true)
            if (panic) {
                panic.setVisible(false)
            }
        }
        fish.panic = function (self) {
            if (panic) {
                fish.setVisible(false)
                panic.setVisible(true)
            }
        }
        fish.normal()
        table.insert(fishes, fish)
    }
    let lightConfig = table([0, table(
            [1, "fish", fishes[1]],
            [1, "color", 1],
            [1, "dirFront", true]
        )], [0, table(
            [1, "fish", fishes[4]],
            [1, "color", 1],
            [1, "dirFront", false]
        )])
    let lights = table()
    for (let i = 1, v = lightConfig[1]; v; i++, v = lightConfig[i]) {
        let elem = table()
        for (let j = 1; j <= 4; j += 1) {
            let light = GameGuideTimelineAnims._createFishLight(v.color)
            let size = light.getContentSize()
            let oSize = v.fish.getContentSize()
            light.setScaleX(oSize.width / size.width + 0.2)
            light.setScaleY(oSize.height / size.height + 0.2)
            light.setPosition(cc.p(oSize.width / 2, oSize.height / 2 + 3))
            light.setOpacity(0)
            v.fish.addChild(light)
            table.insert(elem, light)
        }
        elem.flash = function () {
            let time = table(
                0.25,
                0.1667,
                0.125
            )
            let length = table(
                45.4,
                30.9,
                20.9
            )
            for (let i = 2; i <= 4; i += 1) {
                elem[i].setOpacity(204)
                elem[i].setPosition(cc.p(elem[1].getPosition()))
                elem[i].runAction(cc.Sequence.create(cc.DelayTime.create(0.15 * (i - 2)), cc.Spawn.create(cc.MoveBy.create(time[i - 1], cc.p(v.dirFront && length[i - 1] || -length[i - 1], 0)), cc.FadeOut.create(time[i - 1]))))
            }
        }
        elem.fadeIn = function () {
            elem[1].runAction(cc.FadeIn.create(0.2))
        }
        elem.fadeOut = function () {
            elem[1].runAction(cc.FadeOut.create(0.2))
        }
        table.insert(lights, elem)
    }
    let blasts = table()
    let positions = table(
        [0, cc.p(150, 50)],
        [0, cc.p(150, -50)],
        [0, cc.p(250, -50)],
        [0, cc.p(350, -50)],
        [0, cc.p(450, -50)]
    )
    let ph = anim.getChildByName("blastfx")
    for (let i = 1; i <= 5; i += 1) {
        let sprite = GameGuideTimelineAnims._destroyEffect()
        sprite.setPosition(positions[i])
        ph.addChild(sprite)
        table.insert(blasts, sprite)
    }
    function loopAnim() {
        let $st886 = table(
            2,
            3,
            4,
            5
        )
        for (let i = 1, v = $st886[1]; v; i++, v = $st886[i]) {
            fishes[v].normal()
        }
        action.setLastFrameCallFunc(function () {
            action.clearLastFrameCallFunc()
            let $st888 = table(1, 2)
            for (let i = 1, v = $st888[1]; v; i++, v = $st888[i]) {
                blasts[v].playAnim()
            }
            fishes[5].panic()
            action.setLastFrameCallFunc(function () {
                action.clearLastFrameCallFunc()
                sprays[1].playAnim()
                action.setLastFrameCallFunc(function () {
                    action.clearLastFrameCallFunc()
                    for (let i = 1, v = lights[1]; v; i++, v = lights[i]) {
                        v.fadeIn()
                        v.flash()
                    }
                    action.setLastFrameCallFunc(function () {
                        action.clearLastFrameCallFunc()
                        action.setLastFrameCallFunc(function () {
                            action.clearLastFrameCallFunc()
                            for (let i = 1, v = lights[1]; v; i++, v = lights[i]) {
                                v.fadeOut()
                            }
                            action.setLastFrameCallFunc(function () {
                                action.clearLastFrameCallFunc()
                                let $st894 = table(
                                    3,
                                    4,
                                    5
                                )
                                for (let i = 1, v = $st894[1]; v; i++, v = $st894[i]) {
                                    blasts[v].playAnim()
                                }
                                let $st896 = table(
                                    2,
                                    3,
                                    4
                                )
                                for (let i = 1, v = $st896[1]; v; i++, v = $st896[i]) {
                                    fishes[v].panic()
                                }
                                action.setLastFrameCallFunc(function () {
                                    action.clearLastFrameCallFunc()
                                    let $st898 = table(
                                        2,
                                        3,
                                        4
                                    )
                                    for (let i = 1, v = $st898[1]; v; i++, v = $st898[i]) {
                                        sprays[v].playAnim()
                                    }
                                    action.setLastFrameCallFunc(function () {
                                        action.clearLastFrameCallFunc()
                                        anim.runAction(cc.Sequence.create(cc.FadeOut.create(0.4), cc.CallFunc.create(loopAnim)))
                                    })
                                    action.play("part8", false)
                                })
                                action.play("part7", false)
                            })
                            action.play("part6", false)
                        })
                        action.play("part5", false)
                    })
                    action.play("part4", false)
                })
                action.play("part3", false)
            })
            action.play("part2", false)
        })
        action.play("part1", false)
        action.pause()
        anim.runAction(cc.Sequence.create(cc.FadeIn.create(0.4), cc.CallFunc.create(function () {
            action.resume()
        })))
    }
    //action.gotoFrameAndPlay = function () {
    //    loopAnim()
    //}
    changeGotoFrameAndPlay(action, loopAnim)
    action.play("part1", false)
    action.pause()
    // FIXME: multi result
    return [anim, action]
}
GameGuideTimelineAnims.colorlessFish = function () {
    let self = this
    let anim = cc.CSLoader.createNode("cocos/obstacle_anim_colorless_fish_guide.csb")
    let action = cc.CSLoader.createTimeline("cocos/obstacle_anim_colorless_fish_guide.csb")
    anim.runAction(action)
    let bg = anim.getChildByName("checkboard")
    anim.setContentSize(bg.getContentSize())
    let river = anim.getChildByName("river")
    let config = table(
        [0, table(
            [1, "isCorner", false],
            [1, "position", cc.p(50, 50)],
            [1, "rotation", 0]
        )],
        [0, table(
            [1, "isCorner", false],
            [1, "position", cc.p(150, 50)],
            [1, "rotation", 0]
        )],
        [0, table(
            [1, "isCorner", false],
            [1, "position", cc.p(250, 50)],
            [1, "rotation", 0]
        )],
        [0, table(
            [1, "isCorner", false],
            [1, "position", cc.p(350, 50)],
            [1, "rotation", 0]
        )],
        [0, table(
            [1, "isCorner", false],
            [1, "position", cc.p(450, 50)],
            [1, "rotation", 0]
        )],
        [0, table(
            [1, "isCorner", false],
            [1, "position", cc.p(550, 50)],
            [1, "rotation", 0]
        )]
    )
    for (let i = 1, v = config[1]; v; i++, v = config[i]) {
        let road
        if (v.isCorner) {
            road = GameGuideTimelineAnims._createWaterCorner()
        } else {
            road = GameGuideTimelineAnims._createWaterNormal()
        }
        let size = road.getContentSize()
        if (v.isCorner) {
            road.setScaleX(-101 / size.width)
        } else {
            road.setScaleX(101 / size.width)
        }
        road.setScaleY(101 / size.height)
        road.setPosition(v.position)
        road.setRotation(v.rotation)
        river.addChild(road)
    }
    let sprays = table()
    config = table(
        [0, cc.p(50, 50)],
        [0, cc.p(150, 50)],
        [0, cc.p(250, 50)],
        [0, cc.p(450, 50)]
    )
    for (let i = 1, v = config[1]; v; i++, v = config[i]) {
        let sprite = GameGuideTimelineAnims._createWaterSpray()
        sprite.setPosition(v)
        river.addChild(sprite)
        table.insert(sprays, sprite)
    }
    let gate = anim.getChildByName("entrance")
    let entranceAnim = GameGuideTimelineAnims._createWaterEntrance()
    let aSize = entranceAnim.getContentSize()
    entranceAnim.setScaleX(103 / aSize.width)
    entranceAnim.setScaleY(103 / aSize.height)
    entranceAnim.setRotation(0)
    entranceAnim.setPosition(cc.p(51, 50))
    gate.addChild(entranceAnim)
    let exit = anim.getChildByName("exit")
    let exitAnim = GameGuideTimelineAnims._createWaterExit()
    aSize = exitAnim.getContentSize()
    exitAnim.setScaleX(103 / aSize.width)
    exitAnim.setScaleY(103 / aSize.height)
    exitAnim.setPosition(cc.p(50, 50))
    exit.addChild(exitAnim)
    config = table(
        [0, table([1, "color", AnimalTypeConfig.kNone], [1, "panic", true])],
        [0, table([1, "color", AnimalTypeConfig.kNone], [1, "panic", true])],
        [0, table([1, "color", AnimalTypeConfig.kNone], [1, "panic", true])],
        [0, table([1, "color", AnimalTypeConfig.kNone], [1, "panic", true])],
        [0, table([1, "color", AnimalTypeConfig.kNone], [1, "panic", false])],
        [0, table([1, "color", AnimalTypeConfig.kNone], [1, "panic", false])],
        [0, table([1, "color", AnimalTypeConfig.kNone], [1, "panic", false])],
        [0, table([1, "color", AnimalTypeConfig.kNone], [1, "panic", false])]
    )
    let fishes = table()
    for (let i = 1, v = config[1]; v; i++, v = config[i]) {
        let fishLayer = anim.getChildByName("fish" + tostring(i))
        let fish = GameGuideTimelineAnims._createFishNormal(v.color)
        let size = fish.getContentSize()
        fish.setScaleX(110 / size.width)
        fish.setScaleY(110 / size.height)
        fish.setPosition(cc.p(45, 55))
        fishLayer.addChild(fish)
        let panic
        if (v.panic) {
            panic = GameGuideTimelineAnims._createFishPanic(v.color)
            let size = panic.getContentSize()
            panic.setScaleX(110 / size.width)
            panic.setScaleY(110 / size.height)
            panic.setPosition(cc.p(45, 55))
            fishLayer.addChild(panic)
        }
        fish.normal = function (self) {
            fish.setVisible(true)
            if (panic) {
                panic.setVisible(false)
            }
        }
        fish.panic = function (self) {
            if (panic) {
                fish.setVisible(false)
                panic.setVisible(true)
            }
        }
        fish.normal()
        table.insert(fishes, fish)
    }
    let blasts = table()
    let positions = table(
        [0, cc.p(50, -50)],
        [0, cc.p(150, -50)],
        [0, cc.p(250, -50)],
        [0, cc.p(350, -50)],
        [0, cc.p(450, -50)],
        [0, cc.p(550, -50)]
    )
    let ph = anim.getChildByName("blastfx")
    for (let i = 1, v = positions[1]; v; i++, v = positions[i]) {
        let sprite = GameGuideTimelineAnims._destroyEffect()
        sprite.setPosition(positions[i])
        ph.addChild(sprite)
        table.insert(blasts, sprite)
    }
    function loopAnim() {
        let $st936 = table(
            1,
            2,
            3,
            4
        )
        for (let i = 1, v = $st936[1]; v; i++, v = $st936[i]) {
            fishes[v].normal()
        }
        action.setLastFrameCallFunc(function () {
            action.clearLastFrameCallFunc()
            let $st938 = table(
                1,
                2,
                3
            )
            for (let i = 1, v = $st938[1]; v; i++, v = $st938[i]) {
                blasts[v].playAnim()
            }
            let $st940 = table(
                1,
                2,
                3
            )
            for (let i = 1, v = $st940[1]; v; i++, v = $st940[i]) {
                fishes[v].panic()
            }
            action.setLastFrameCallFunc(function () {
                action.clearLastFrameCallFunc()
                let $st942 = table(
                    1,
                    2,
                    3
                )
                for (let i = 1, v = $st942[1]; v; i++, v = $st942[i]) {
                    sprays[v].playAnim()
                }
                action.setLastFrameCallFunc(function () {
                    action.clearLastFrameCallFunc()
                    let $st944 = table(
                        4,
                        5,
                        6
                    )
                    for (let i = 1, v = $st944[1]; v; i++, v = $st944[i]) {
                        blasts[v].playAnim()
                    }
                    fishes[4].panic()
                    action.setLastFrameCallFunc(function () {
                        action.clearLastFrameCallFunc()
                        sprays[4].playAnim()
                        action.setLastFrameCallFunc(function () {
                            action.clearLastFrameCallFunc()
                            anim.runAction(cc.Sequence.create(cc.FadeOut.create(0.4), cc.CallFunc.create(loopAnim)))
                        })
                        action.play("part5", false)
                    })
                    action.play("part4", false)
                })
                action.play("part3", false)
            })
            action.play("part2", false)
        })
        action.play("part1", false)
        action.pause()
        anim.runAction(cc.Sequence.create(cc.FadeIn.create(0.4), cc.CallFunc.create(function () {
            action.resume()
        })))
    }
    //action.gotoFrameAndPlay = function () {
    //    loopAnim()
    //}
    changeGotoFrameAndPlay(action, loopAnim)
    action.play("part1", false)
    action.pause()
    // FIXME: multi result
    return [anim, action]
}
GameGuideTimelineAnims.chocolate = function () {
    let self = this
    let anim = cc.CSLoader.createNode("cocos/obstacle_anim_chocolate_animation.csb")
    let action = cc.CSLoader.createTimeline("cocos/obstacle_anim_chocolate_animation.csb")
    anim.runAction(action)
    function loopAnim() {
        action.setLastFrameCallFunc(function () {
            action.clearLastFrameCallFunc()
            anim.runAction(cc.Sequence.create(cc.FadeOut.create(0.4), cc.CallFunc.create(loopAnim)))
        })
        action.play("part1", false)
        action.pause()
        anim.runAction(cc.Sequence.create(cc.FadeIn.create(0.4), cc.CallFunc.create(function () {
            action.resume()
        })))
    }
    // action.gotoFrameAndPlay = function () {
    //     loopAnim()
    // }
    changeGotoFrameAndPlay(action, loopAnim)
    // FIXME: multi result
    return [anim, action]
}
GameGuideTimelineAnims.pursueFinish = function (animConfig) {
    let self = this
    // body
    FrameLoader.loadImageWithPlist("flash/pursue_role_main_e.plist")
    FrameLoader.loadImageWithPlist("flash/pursue_role_main_s.plist")
    let fileName = "cocos/obstacle_anim_pursue_guide.csb"
    let anim = cc.CSLoader.createNode(fileName)
    let action = cc.CSLoader.createTimeline(fileName)
    anim.runAction(action)
    anim.setContentSize(315, 280)
    let bear_c = anim.getChildByName("bear_replace")
    let bear = TileAnimationFactory.getInstance().getTileClass("TilePursueStartMain").create(GameItemDirection.kRight)
    bear.setPositionY(-10)
    bear_c.addChild(bear)
    let rose_c = anim.getChildByName("rose_replace")
    let rose = TileAnimationFactory.getInstance().getTileClass("TilePursueEndMain").create()
    rose.setCascadeOpacityEnabled(true)
    rose_c.addChild(rose)
    let blasts = table()
    for (let k = 1; k <= 2; k += 1) {
        let boom = anim.getChildByName("boom" + k)
        let sprite = GameGuideTimelineAnims._destroyEffect()
        let size = sprite.getContentSize()
        sprite.setScale(100 / size.width)
        boom.addChild(sprite)
        boom.setCascadeOpacityEnabled(true)
        table.insert(blasts, sprite)
    }
    let loopAnim
    function finish() {
        let __VA_ARG = $slice(arguments, 0)
        // body
        bear.finish()
        action.clearLastFrameCallFunc()
        action.play("finish", false)
        action.setLastFrameCallFunc(loopAnim)
    }
    function walk() {
        let __VA_ARG = $slice(arguments, 0)
        // body
        bear.jumpAndDown(GameItemDirection.kRight)
        action.clearLastFrameCallFunc()
        action.play("walk", false)
        action.setLastFrameCallFunc(finish)
    }
    function score() {
        let __VA_ARG = $slice(arguments, 0)
        // body
        bear.score()
        action.clearLastFrameCallFunc()
        action.play("score", false)
        action.setLastFrameCallFunc(walk)
    }
    function boom() {
        let __VA_ARG = $slice(arguments, 0)
        // body
        for (let i = 1, v = blasts[1]; v; i++, v = blasts[i]) {
            v.playAnim()
        }
        action.clearLastFrameCallFunc()
        action.play("boom", false)
        action.setLastFrameCallFunc(score)
    }
    loopAnim = function () {
        let __VA_ARG = $slice(arguments, 0)
        // body
        bear.idle()
        action.clearLastFrameCallFunc()
        action.play("idle", false)
        action.setLastFrameCallFunc(boom)
    }
    //action.gotoFrameAndPlay = function (self) {
        // body
    //    loopAnim()
    //}
    changeGotoFrameAndPlay(action, loopAnim)
    // FIXME: multi result
    return [anim, action]
}

GameGuideTimelineAnims._destroyEffect = function () {
    FrameLoader.loadImageWithPlist("flash/destroy_effect.plist")
    var sprite = cc.Sprite.createWithSpriteFrameName("destroy_effect_0000.png")
    require.ensure([], () => {
        require("clover/itemView/ItemView")
        var blast = ItemView.getDestroyEffectAnimation()
        blast.retain()
        sprite.setVisible(false)
        sprite.playAnim = function () {
            sprite.setVisible(true)
            sprite.play(blast, 0, 1)
        }
        sprite.enableNodeEvents()
        sprite.onCleanup = function () {
            blast.release()
        }
    }, null, 'game')
    
    return sprite
}
GameGuideTimelineAnims._buildIceChain = function (level) {
    FrameLoader.loadImageWithPlist("flash/ice_chain.plist")
    syncRequireGameModule("clover/animation/TileChain")
    var sprite = cc.Sprite.createWithSpriteFrameName("chain_h_lv_1_0000.png")
    var texture = sprite.getTexture()
    var ret = table()
    ret.obj = TileChain.createWithChains(table([1, "strength", level], [1, "isHEdge", false]), texture)
    ret.obj.setCascadeOpacityEnabled(true)
    ret.setScale = function (scale) {
        ret.obj.setScale(scale)
    }
    ret.setPosition = function (position) {
        ret.obj.setPosition(position)
    }
    var count = 0
    ret.playAnim = function (self) {
        count = count + 1
        if (level - count >= 0) {
            ret.obj.playBreakAnimation(table([1, "strength", level - count], [1, "isHEdge", false]))
        }
    }
    ret.resetAnim = function (self) {
        var texture = ret.obj.getTexture()
        texture.retain()
        var parent = ret.obj.getParent()
        var position = cc.p(ret.obj.getPosition())
        var scale = ret.obj.getScale()
        ret.obj.removeFromParent(true)
        ret.obj = TileChain.createWithChains(table([1, "strength", level], [1, "isHEdge", false]), texture)
        ret.obj.setScale(scale)
        ret.obj.setPosition(position)
        parent.addChild(ret.obj)
        texture.release()
        ret.obj.setCascadeOpacityEnabled(true)
        count = 0
    }
    ret.getObj = function (self) {
        return ret.obj
    }
    return ret
}
GameGuideTimelineAnims._buildGenerator = function (level) {
    syncRequireGameModule("clover/itemView/ItemViewUtils")
    syncRequireGameModule("clover/levelTarget/TargetIcon")
    syncRequireGameModule("clover/animation/TileVariousBox")
    FrameLoader.loadImageWithPlist("flash/gum.plist")
    FrameLoader.loadImageWithPlist("flash/various_box.plist")
    var ret = table()
    ret.obj = TileVariousBox.create(table(
        [1, "variousBoxID", GameItemDefMapKey.kGum_6],
        [1, "variousBoxCount", 1],
        [1, "variousBoxLevel", level]
    ), null)
    ret.obj.setCascadeOpacityEnabled(true)
    ret.obj.container.setCascadeOpacityEnabled(true)
    ret.obj.item.setCascadeOpacityEnabled(true)
    var $st600 = ret.obj.item.getChildren()
    for (var i = 1, v = $st600[1]; v; i++ , v = $st600[i]) {
        v.setCascadeOpacityEnabled(true)
    }
    var $st602 = ret.obj.container.getChildren()
    for (var i = 1, v = $st602[1]; v; i++ , v = $st602[i]) {
        v.setCascadeOpacityEnabled(true)
    }
    ret.setScale = function (scale) {
        ret.obj.setScale(scale)
    }
    ret.setPosition = function (position) {
        ret.obj.setPosition(position)
    }
    var l = level
    ret.playAnim = function (self) {
        l = l + 1
        if (l > 4) {
            ret.obj.playReplaceAnimation(function () { })
        } else {
            ret.obj.playUpgradeAnimation(function () { })
        }
    }
    ret.resetAnim = function (self) {
        var parent = ret.obj.getParent()
        var position = cc.p(ret.obj.getPosition())
        var scale = ret.obj.getScale()
        ret.obj.removeFromParent(true)
        FrameLoader.loadImageWithPlist("flash/gum.plist")
        FrameLoader.loadImageWithPlist("flash/various_box.plist")
        ret.obj = TileVariousBox.create(table(
            [1, "variousBoxID", GameItemDefMapKey.kGum_6],
            [1, "variousBoxCount", 1],
            [1, "variousBoxLevel", level]
        ), null)
        ret.obj.setCascadeOpacityEnabled(true)
        ret.obj.container.setCascadeOpacityEnabled(true)
        ret.obj.item.setCascadeOpacityEnabled(true)
        var $st608 = ret.obj.item.getChildren()
        for (var i = 1, v = $st608[1]; v; i++ , v = $st608[i]) {
            v.setCascadeOpacityEnabled(true)
        }
        var $st610 = ret.obj.container.getChildren()
        for (var i = 1, v = $st610[1]; v; i++ , v = $st610[i]) {
            v.setCascadeOpacityEnabled(true)
        }
        ret.obj.setScale(scale)
        ret.obj.setPosition(position)
        parent.addChild(ret.obj)
        l = level
    }
    ret.getObj = function (self) {
        return ret.obj
    }
    return ret
}
GameGuideTimelineAnims._iceBreak = function (level) {
    FrameLoader.loadImageWithPlist("flash/mapLight.plist")
    var sprite = cc.Sprite.createWithSpriteFrameName("ice_lv_" + level + "_0000.png")
    var frames = SpriteUtil.buildFrames("ice_lv_" + level + "_%04d.png", 3, 25)
    var animate = SpriteUtil.buildAnimate(frames, 1 / 30)
    animate.retain()
    sprite.playAnim = function (self) {
        sprite.play(animate, 0, 1)
    }
    sprite.resetAnim = function (self) {
        sprite.setSpriteFrame("ice_lv_" + level + "_0000.png")
    }
    sprite.enableNodeEvents()
    sprite.onCleanup = function (self) {
        animate.release()
    }
    return sprite
}
GameGuideTimelineAnims._wrapFx = function () {
    FrameLoader.loadImageWithPlist("flash/wrap_effect.plist")
    var sprite = cc.Sprite.createWithSpriteFrameName("wrap_effect_0000.png")
    sprite.setBlendFunc(table([1, "src", gl.SRC_ALPHA], [1, "dst", gl.ONE]))
    let frames = SpriteUtil.buildFrames("wrap_effect_%04d.png", 0, 23)
    var animate = SpriteUtil.buildAnimate(frames, 1 / 30)
    animate.retain()
    sprite.playAnim = function (self) {
        sprite.play(animate, 0, 1)
    }
    sprite.enableNodeEvents()
    sprite.onCleanup = function (self) {
        animate.release()
    }
    return sprite
}
GameGuideTimelineAnims._createWaterNormal = function () {
    FrameLoader.loadImageWithPlist("flash/water.plist")
    var animation = cc.Sprite.createWithSpriteFrameName("water_normal_0000.png")
    var frames = SpriteUtil.buildFrames("water_normal_%04d.png", 0, 29)
    var animate = SpriteUtil.buildAnimate(frames, 1 / 30)
    animation.setScaleX(1.02)
    animation.play(animate)
    return animation
}
GameGuideTimelineAnims._createWaterCorner = function () {
    FrameLoader.loadImageWithPlist("flash/water.plist")
    var animation = cc.Sprite.createWithSpriteFrameName("water_corner_0000.png")
    var frames = SpriteUtil.buildFrames("water_corner_%04d.png", 0, 29)
    var animate = SpriteUtil.buildAnimate(frames, 1 / 30)
    animation.play(animate)
    return animation
}
GameGuideTimelineAnims._createWaterEntrance = function () {
    FrameLoader.loadImageWithPlist("flash/water.plist")
    var animation = cc.Sprite.createWithSpriteFrameName("water_start_0000.png")
    var frames = SpriteUtil.buildFrames("water_start_%04d.png", 0, 31)
    var animate = SpriteUtil.buildAnimate(frames, 1 / 30)
    animation.play(animate)
    return animation
}
GameGuideTimelineAnims._createWaterExit = function () {
    FrameLoader.loadImageWithPlist("flash/water.plist")
    var endNode = cc.Sprite.createWithSpriteFrameName("water_end_0000.png")
    var frames = SpriteUtil.buildFrames("water_end_%04d.png", 0, 43)
    var animate = SpriteUtil.buildAnimate(frames, 1 / 30)
    endNode.play(animate)
    return endNode
}
GameGuideTimelineAnims._createWaterBackLineNormal = function () {
    FrameLoader.loadImageWithPlist("flash/water.plist")
    var animation = cc.Sprite.createWithSpriteFrameName("water_back_normal_0000.png")
    var frames = SpriteUtil.buildFrames("water_back_normal_%04d.png", 0, 14)
    var animate = SpriteUtil.buildAnimate(frames, 1 / 30)
    animation.play(animate)
    return animation
}
GameGuideTimelineAnims._createWaterBackLineCorner = function () {
    FrameLoader.loadImageWithPlist("flash/water.plist")
    var animation = cc.Sprite.createWithSpriteFrameName("water_back_corner_0000.png")
    var frames = SpriteUtil.buildFrames("water_back_corner_%04d.png", 0, 15)
    var animate = SpriteUtil.buildAnimate(frames, 1 / 30)
    animation.play(animate)
    return animation
}
GameGuideTimelineAnims._createWaterSpray = function () {
    FrameLoader.loadImageWithPlist("flash/stone_combine.plist")
    var node = cc.Node.create()
    var sprite1 = cc.Sprite.createWithSpriteFrameName("bubble_bomb_bg_0000.png")
    var frames1 = SpriteUtil.buildFrames("bubble_bomb_bg_%04d.png", 0, 24)
    var animate1 = SpriteUtil.buildAnimate(frames1, 1 / 30)
    node.addChild(sprite1)
    var sprite2 = cc.Sprite.createWithSpriteFrameName("bubble_bomb_0000.png")
    var frames2 = SpriteUtil.buildFrames("bubble_bomb_%04d.png", 0, 22)
    var animate2 = SpriteUtil.buildAnimate(frames2, 1 / 30)
    node.addChild(sprite2)
    animate1.retain()
    animate2.retain()
    node.playAnim = function (self) {
        sprite1.setVisible(true)
        sprite1.play(animate1, 0, 1, function () {
            sprite1.setVisible(false)
        })
        sprite2.setVisible(true)
        sprite2.play(animate2, 0, 1, function () {
            sprite2.setVisible(false)
        })
    }
    node.enableNodeEvents()
    node.onCleanup = function (self) {
        animate1.release()
        animate2.release()
    }
    sprite1.setVisible(false)
    sprite2.setVisible(false)
    return node
}
require("clover/config/CloverConst")
var colors = table(
    "blue",
    "green",
    "brown",
    "purpple",
    "red",
    "yellow"
)
colors[AnimalTypeConfig.kNone] = "alpha"
GameGuideTimelineAnims._createFishNormal = function (color) {
    FrameLoader.loadImageWithPlist("flash/fish_combine.plist")
    var fish = cc.Sprite.createWithSpriteFrameName("fish_" + colors[color] + "_normal_0000.png")
    var frames = SpriteUtil.buildFrames("fish_" + colors[color] + "_normal_%04d.png", 0, 45)
    var animate = SpriteUtil.buildAnimate(frames, 1 / 30)
    fish.play(animate)
    return fish
}
GameGuideTimelineAnims._createFishTurn = function (color) {
    FrameLoader.loadImageWithPlist("flash/fish_combine.plist")
    var fish = cc.Sprite.createWithSpriteFrameName("fish_" + colors[color] + "_normal_0000.png")
    var frames = SpriteUtil.buildFrames("fish_" + colors[color] + "_corner_%04d.png", 0, 20)
    var animate = SpriteUtil.buildAnimate(frames, 1 / 30)
    fish.play(animate, 0, 1)
    return fish
}
GameGuideTimelineAnims._createFishRetreat = function (color) {
    FrameLoader.loadImageWithPlist("flash/fish_combine.plist")
    var fish = cc.Sprite.createWithSpriteFrameName("fish_" + colors[color] + "_normal_0000.png")
    var frames = SpriteUtil.buildFrames("fish_" + colors[color] + "_fast_%04d.png", 0, 24)
    var animate = SpriteUtil.buildAnimate(frames, 1 / 60)
    fish.play(animate)
    return fish
}
GameGuideTimelineAnims._createFishLight = function (color) {
    FrameLoader.loadImageWithPlist("flash/fish_light.plist")
    return cc.Sprite.createWithSpriteFrameName("fish_" + colors[color] + "_light_0000.png")
}
GameGuideTimelineAnims._createFishPanic = function (color) {
    FrameLoader.loadImageWithPlist("flash/fish_combine.plist")
    var fish = cc.Sprite.createWithSpriteFrameName("fish_" + colors[color] + "_normal_0000.png")
    var frames = SpriteUtil.buildFrames("fish_" + colors[color] + "_scare_%04d.png", 0, 8)
    var animate = SpriteUtil.buildAnimate(frames, 1 / 60)
    fish.play(animate, 0, 0)
    return fish
}
GameGuideTimelineAnims._buildStarFish = function (color, level) {
    var StarFish = syncRequireGameModule("clover/animation/TileStarfish")
    FrameLoader.loadImageWithPlist("flash/starfish.plist")
    FrameLoader.loadImageWithPlist("flash/starfish_ex.plist")
    ret = table()
    ret.obj = StarFish.create(2, 3)
    ret.obj.setCascadeOpacityEnabled(true)
    ret.setScale = function (scale) {
        ret.obj.setScale(scale)
    }
    ret.setPosition = function (position) {
        ret.obj.setPosition(position)
    }
    var l = level
    ret.playAnim = function (color) {
        l = l - 1
        if (l <= 0) {
            ret.obj.playJumpOutAnimation(l, color)
        } else {
            ret.obj.playChangeAnimation(l, color)
        }
    }
    ret.resetAnim = function (self) {
        var parent = ret.obj.getParent()
        var position = cc.p(ret.obj.getPosition())
        var scale = ret.obj.getScale()
        ret.obj.removeFromParent(true)
        FrameLoader.loadImageWithPlist("flash/starfish.plist")
        FrameLoader.loadImageWithPlist("flash/starfish_ex.plist")
        ret.obj = StarFish.create(2, 3)
        ret.obj.setCascadeOpacityEnabled(true)
        ret.obj.setScale(scale)
        ret.obj.setPosition(position)
        parent.addChild(ret.obj)
        l = level
    }
    ret.getObj = function (self) {
        return ret.obj
    }
    return ret
}
GameGuideTimelineAnims._buildBombBottle = function (color, level) {
    FrameLoader.loadImageWithPlist("flash/bomb.plist")
    var sprite = cc.Sprite.createWithSpriteFrameName("bomb_bottle_0000.png")
    var frames = SpriteUtil.buildFrames("bomb_bottle_%04d.png", 1, 26)
    var animate = SpriteUtil.buildAnimate(frames, 1 / 30)
    animate.retain()
    sprite.setVisible(false)
    sprite.playAnim = function () {
        this.setVisible(true)
        this.play(animate, 0, 1)
    }
    sprite.enableNodeEvents()
    sprite.onCleanup = function () {
        animate.release()
    }
    return sprite
}
GameGuideTimelineAnims._buildBombButterfly = function (color, level) {
    FrameLoader.loadImageWithPlist("flash/bomb.plist")
    var sprite = cc.Sprite.createWithSpriteFrameName("butterfly_bomb_0000.png")
    var frames = SpriteUtil.buildFrames("butterfly_bomb_%04d.png", 1, 18)
    var animate = SpriteUtil.buildAnimate(frames, 1 / 30)
    animate.retain()
    sprite.setVisible(false)
    sprite.playAnim = function () {
        this.setVisible(true)
        this.play(animate, 0, 1)
    }
    sprite.enableNodeEvents()
    sprite.onCleanup = function () {
        animate.release()
    }
    return sprite
}
GameGuideTimelineAnims._buildSoilDestroy = function () {
    FrameLoader.loadImageWithPlist("flash/waterdig.plist")
    var sprite = cc.Sprite.createWithSpriteFrameName("soil_1_destroy_0000.png")
    var frames = SpriteUtil.buildFrames("soil_1_destroy_%04d.png", 0, 20)
    var animate = SpriteUtil.buildAnimate(frames, 1 / 30)
    animate.retain()
    sprite.setVisible(false)
    sprite.playAnim = function () {
        this.setVisible(true)
        this.play(animate, 0, 1)
    }
    sprite.enableNodeEvents()
    sprite.onCleanup = function () {
        animate.release()
    }
    return sprite
}
GameGuideTimelineAnims._buildPortalEnter = function () {
    FrameLoader.loadImageWithPlist("flash/link_item.plist")
    var sprite = cc.Sprite.createWithSpriteFrameName("portal_enter0000.png")
    var frames = SpriteUtil.buildFrames("portal_enter%04d.png", 0, 20)
    var animate = SpriteUtil.buildAnimate(frames, 1 / 30)
    sprite.play(animate)
    return sprite
}
GameGuideTimelineAnims._buildPortalExit = function () {
    FrameLoader.loadImageWithPlist("flash/link_item.plist")
    var sprite = cc.Sprite.createWithSpriteFrameName("portal_exit0000.png")
    var frames = SpriteUtil.buildFrames("portal_exit%04d.png", 0, 20)
    var animate = SpriteUtil.buildAnimate(frames, 1 / 30)
    sprite.play(animate)
    return sprite
}
GameGuideTimelineAnims._buildVenom = function (fromVoid) {
    var TileVenom = syncRequireGameModule("clover/animation/TileVenom")
    FrameLoader.loadImageWithPlist("flash/venom.plist")
    var sprite
    if (fromVoid) {
        sprite = TileVenom.createAppear()
    } else {
        sprite = TileVenom.create(false)
    }
    sprite.setCascadeOpacityEnabled(true)
    sprite.dirAnim = function (dir) {
        sprite.playDirectionAnimation(dir, function () {
            sprite.playNormalAnimation()
        })
    }
    sprite.appearAnim = function (self) {
        sprite.playAppear(function () {
            sprite.playNormalAnimation()
        })
    }
    sprite.destroyAnim = function (self) {
        sprite.playDestroyAnimation()
    }
    sprite.resetAnim = function (self) {
        if (fromVoid) {
            if (sprite.effectSprite) {
                sprite.effectSprite.removeFromParent(true)
                sprite.effectSprite = null
            }
        } else {
            sprite.playNormalAnimation()
        }
    }
    sprite.resetAnim()
    return sprite
}
GameGuideTimelineAnims._buildJellyfish = function (strength) {
    var self = this
    FrameLoader.loadImageWithPlist("flash/jellyfish.plist")
    var Jellyfish = syncRequireGameModule("clover/animation/TileJellyfish")
    var jellyfish = Jellyfish.create(strength)
    jellyfish.setCascadeOpacityEnabled(true)
    jellyfish.playNormal()
    jellyfish.splitAnim = jellyfish.playSplit
    jellyfish.beatAnim = jellyfish.playBeaten
    jellyfish.resetAnim = function () {
        this.strength = strength
        this.blood.strength = strength
        var view = this.blood.viewList[1]
        view.stopAllActions()
        view.setScale(1.4 / 6)
        view.setOpacity(255)
        view.setVisible(true)
        this.playNormal()
    }
    return jellyfish
}
GameGuideTimelineAnims._buildLotus = function () {
    var node = cc.Node.create()
    node.setCascadeOpacityEnabled(true)
    FrameLoader.loadImageWithPlist("flash/lotus.plist")
    var Lotus = syncRequireGameModule("clover/animation/TileLotus")
    var lotus = Lotus.create(true)
    node.addChild(lotus)
    node.playWave = function (dir) {
        FrameLoader.loadImageWithPlist("flash/lotus.plist")
        var Container = require("clover/animation/FishMoveContainer")
        var wave
        wave = Container.createLotusWaves(function () {
            wave.removeFromParent(true)
        })
        wave.setRotation((dir - 2) * 90)
        wave.setPosition(cc.p(Math.cos((dir - 2) * Math.PI / 2) * -70, Math.sin((dir - 2) * Math.PI / 2) * 70))
        node.addChild(wave)
    }
    return node
}

GameGuideTimelineAnims._buildBee = function () {
    let self = this
    require("clover/const/QualityConst")
    let node = cc.Node.create()
    node.setCascadeOpacityEnabled(true)
    node.reset = function (self) {
        // if (self.bee) {
        //     self.removeAllChildren(true)
        //     self.bee = null
        // }
        FrameLoader.loadImageWithPlist("flash/lighthouse.plist")
        let Bee = syncRequireGameModule("clover/animation/BeeAnimation")
        let bee = Bee.create(false)
        bee.setPosition(cc.p(50, 50))
        node.addChild(bee)
        node.bee = bee
    }
    node.playAnim = function (self) {
        if (node.bee) {
            FrameLoader.loadImageWithPlist("flash/lighthouse.plist")
            node.bee.playAniamtion()
        }
    }
    node.addTail = function (self) {
        let context = node.getParent()
        let parent = context.getParent()
        function buildStar() {
            FrameLoader.loadImageWithPlist("flash/lighthouse.plist")
            let star = cc.Sprite.createWithSpriteFrameName("beehive_star.png")
            star.setScale(math.random() * 0.4 + 0.6)
            let rad = context.getRotation() * Math.PI / 180
            let time = 0.6
            star.setScale(1.4)
            star.setOpacity(255)
            let action = cc.Spawn.create(cc.ScaleTo.create(time, 0.4), cc.FadeOut.create(time), cc.RotateBy.create(time, 180), cc.MoveBy.create(time, cc.p(-Math.sin(rad) * 50, -Math.cos(rad) * 50)))
            star.runAction(cc.Sequence.create(action, cc.CallFunc.create(function () {
                let __VA_ARG = $slice(arguments, 0)
                // body
                star.removeFromParent(true)
            })))
            star.setPosition(cc.p(context.getPositionX() + math.random() * 20 - 10, context.getPositionY() + math.random() * 20 - 10))
            parent.addChild(star, 998)
        }
        if (cc.Director.getInstance().getAvgFrameRate() >= Quality.kBossModeFPSGuardLine) {
            let action = cc.RepeatForever.create(cc.Sequence.create(cc.DelayTime.create(0.06), cc.CallFunc.create(function () {
                buildStar()
            })))
            action.setTag(1024)
            node.runAction(action)
        }
    }
    node.removeTail = function (self) {
        node.stopActionByTag(1024)
    }
    return node
}
GameGuideTimelineAnims._buildLighthouse = function (strength) {
    var node = cc.Node.create()
    node.setCascadeOpacityEnabled(true)
    var TileLighthouse = syncRequireGameModule("clover/animation/TileLighthouse")
    var str = strength
    node.reset = function () {
        FrameLoader.loadImageWithPlist("flash/lighthouse.plist")
        this.sp = TileLighthouse.create({strength:strength})
        this.sp.setCascadeOpacityEnabled(true)
        this.addChild(this.sp)
        str = strength
    }
    node.playAnim = function () {
        FrameLoader.loadImageWithPlist("flash/lighthouse.plist")
        str = str + 1
        this.sp.addStrength(cc.clampf(str, 0, 3))
    }
    node.finAnim = function () {
        FrameLoader.loadImageWithPlist("flash/lighthouse.plist")
        this.sp.playAttackBoss()
    }
    return node
}
GameGuideTimelineAnims._pufferFish = function (color, strength, maxStrengh) {
    let self = this
    FrameLoader.loadImageWithPlist("cocos/colorCollector_common.plist")
    FrameLoader.loadImageWithPlist("flash/colorCollector.plist")
    let node = cc.Node.create()
    node.setCascadeOpacityEnabled(true)
    let rec = strength
    let fish
    node.resetAnim = function () {
        if (fish) {
            fish.removeFromParent(true)
        }
        fish = TileAnimationFactory.getInstance().getTileClass("TileColorCollector").create(table(
            [1, "itemColorType", color],
            [1, "strength", maxStrengh - strength],
            [1, "colorCollectorPower", maxStrengh],
            [1, "getColorCollectorNeedBomb", function () {
                return false
            }]
        ))
        function recCasOpt(node) {
            let $st1013 = node.getChildren()
            for (let i = 1, v = $st1013[1]; v; i++, v = $st1013[i]) {
                v.setCascadeOpacityEnabled(true)
                recCasOpt(v)
            }
        }
        fish.setCascadeOpacityEnabled(true)
        recCasOpt(fish)
        node.addChild(fish)
        rec = strength
    }
    node.playAnim = function (value) {
        fish.onCollision(rec, maxStrengh - value)
        rec = value
    }
    node.endingAnim = function () {
        fish.onCollision(rec, 0)
        rec = 0
    }
    node.finAnim = function () {
        FrameLoader.loadImageWithPlist("flash/colorCollector.plist")
        fish.playColorCollectorBomb()
    }
    return node
}
GameGuideTimelineAnims.produceMark = function () {
    let __VA_ARG = $slice(arguments, 0)
    let self = this
    // body
    let fileName = "cocos/obstacle_anim_produceMark_guide.csb"
    let anim = cc.CSLoader.createNode(fileName)
    let action = cc.CSLoader.createTimeline(fileName)
    anim.runAction(action)
    anim.setContentSize(cc.size(350, 318))
    let blasts = table()
    for (let k = 1; k <= 9; k += 1) {
        // let sp = GameGuideTimelineAnims._destroyEffect()
        let sp = GameGuideTimelineAnims._destroyEffect()
        let ph = anim.getChildByName("boom" + k)
        let s = ph.getContentSize()
        ph.addChild(sp)
        sp.setPosition(s.width / 2, s.height / 2)
        table.insert(blasts, sp)
    }
    let loopAnim
    function restart() {
        let __VA_ARG = $slice(arguments, 0)
        // body
        action.clearLastFrameCallFunc()
        if (loopAnim) {
            loopAnim()
        }
    }
    function boom3() {
        let __VA_ARG = $slice(arguments, 0)
        // body
        for (let k = 7; k <= 9; k += 1) {
            blasts[k].playAnim()
        }
        action.play("boom3", false)
        action.setLastFrameCallFunc(restart)
    }
    function boom2() {
        let __VA_ARG = $slice(arguments, 0)
        // body
        for (let k = 4; k <= 6; k += 1) {
            blasts[k].playAnim()
        }
        action.play("boom2", false)
        action.setLastFrameCallFunc(boom3)
    }
    function boom1() {
        let __VA_ARG = $slice(arguments, 0)
        // body
        for (let k = 1; k <= 3; k += 1) {
            blasts[k].playAnim()
        }
        action.play("boom1", false)
        action.setLastFrameCallFunc(boom2)
    }
    loopAnim = function () {
        let __VA_ARG = $slice(arguments, 0)
        // body
        action.play("start", false)
        action.setLastFrameCallFunc(boom1)
    }
    // action.gotoFrameAndPlay = function (self) {
    //     loopAnim()
    // }
    changeGotoFrameAndPlay(action, loopAnim)
    // FIXME: multi result
    return [anim, action]
}
GameGuideTimelineAnims.shell = function () {
    let __VA_ARG = $slice(arguments, 0)
    let self = this
    // body
    FrameLoader.loadImageWithPlist("flash/shell.plist")
    let fileName = "cocos/obstacle_anim_shell_guide.csb"
    let anim = cc.CSLoader.createNode(fileName)
    let action = cc.CSLoader.createTimeline(fileName)
    anim.runAction(action)
    anim.setContentSize(cc.size(350, 280))
    let blasts = table()
    for (let k = 1; k <= 9; k += 1) {
        let sp = self._destroyEffect()
        let ic = anim.getChildByName("boom" + k)
        ic.addChild(sp)
        let size = ic.getContentSize()
        sp.setPosition(size.width / 2, size.height / 2)
        table.insert(blasts, sp)
    }
    let iceBalls = table()
    for (let k = 1; k <= 3; k += 1) {
        let level = k === 1 && 2 || 3
        let sp = TileAnimationFactory.getInstance().getTileClass("TileShell").create(level)
        let ic = anim.getChildByName("ice_ball_" + k)
        let size = ic.getContentSize()
        sp.setPosition(size.width / 2, size.height / 2)
        ic.addChild(sp)
        table.insert(iceBalls, sp)
    }
    let loopAnim
    function dec_1() {
        let __VA_ARG = $slice(arguments, 0)
        // body
        action.clearLastFrameCallFunc()
        action.play("dec_1", false)
        action.setLastFrameCallFunc(loopAnim)
        for (let k = 7; k <= 9; k += 1) {
            blasts[k].playAnim()
        }
        for (let k = 1; k <= 3; k += 1) {
            let shell = iceBalls[k]
            shell.playDec(shell.level - 1)
        }
    }
    function dec_2() {
        let __VA_ARG = $slice(arguments, 0)
        // body
        action.play("dec_2", false)
        action.setLastFrameCallFunc(dec_1)
        for (let k = 4; k <= 6; k += 1) {
            blasts[k].playAnim()
        }
        for (let k = 1; k <= 3; k += 1) {
            let shell = iceBalls[k]
            shell.playDec(shell.level - 1)
        }
    }
    function dec_3() {
        let __VA_ARG = $slice(arguments, 0)
        // body
        action.play("dec_3", false)
        action.setLastFrameCallFunc(dec_2)
        for (let k = 1; k <= 3; k += 1) {
            blasts[k].playAnim()
        }
        for (let k = 2; k <= 3; k += 1) {
            let shell = iceBalls[k]
            shell.playDec(shell.level - 1)
        }
    }
    loopAnim = function () {
        let __VA_ARG = $slice(arguments, 0)
        // body
        action.play("start", false)
        action.setLastFrameCallFunc(dec_3)
        for (let k = 1; k <= 3; k += 1) {
            iceBalls[k].forceUpdateLevel(k === 1 && 2 || 3)
        }
    }
    changeGotoFrameAndPlay(action, loopAnim)
    // action.gotoFrameAndPlay = function (self) {
    //     // body
    //     loopAnim()
    // }
    let size = anim.getContentSize()
    let clip = cc.ClippingRectangleNode.create()
    clip.setClippingRegion(cc.rect(0, -size.height, size.width, size.height))
    clip.setClippingEnabled(true)
    clip.addChild(anim)
    clip.setContentSize(size)
    // FIXME: multi result
    return [clip, action]
}
GameGuideTimelineAnims.showSodaAnim = function (animConfig) {
    let self = this
    require("clover/animation/CommonEffect")
    FrameLoader.loadImageWithPlist("flash/sea_animal.plist")
    FrameLoader.loadImageWithPlist("flash/mapLight.plist")
    FrameLoader.loadImageWithPlist("flash/var_snow.plist")
    FrameLoader.loadImageWithPlist("cocos/sodaAnim.plist")
    let actionSeq = 0
    let anim = cc.CSLoader.createNode("cocos/obstacle_anim_soda_guide_soda.csb")
    let bg = anim.getChildByName("checkboard_4526")
    let size = bg.getContentSize()
    let action = cc.CSLoader.createTimeline("cocos/obstacle_anim_soda_guide_soda.csb")
    anim.runAction(action)
    action.setLastFrameCallFunc(function () {
        actionSeq = actionSeq + 1
        action.setCurrentFrame(0)
    })
    let soda
    let ices = table()
    let snow
    let snow2
    let blasts = table()
    for (let i = 1; i <= 4; i += 1) {
        let layer = anim.getChildByName("boomfx_icon" + i)
        layer.setCascadeOpacityEnabled(false)
        let sprite = self._destroyEffect()
        sprite.setPosition(50, 50)
        layer.addChild(sprite)
        table.insert(blasts, sprite)
    }
    function shakeBottle() {
        if (snow) {
            snow.removeFromParent(true)
            snow = null
        }
        if (snow2) {
            snow2.removeFromParent(true)
            snow2 = null
        }
        soda = TileAnimationFactory.getInstance().getTileClass("TileSeaAnimal").create(GameItemDefMapKey.kSoda_1_2)
        soda.setPosition(50, 50)
        anim.getChildByName("ice_icon3").addChild(soda)
        soda.effectSprite.shakeSelf()
        for (let i = 1; i <= 2; i += 1) {
            let ice = ItemViewUtils.buildLight(1, 1)
            ice.setPosition(50, 50)
            anim.getChildByName("ice_icon" + i).addChild(ice)
            table.insert(ices, ice)
        }
        snow = TileAnimationFactory.getInstance().getTileClass("TileVarSnow").create(3)
        snow.setPosition(50, 50)
        anim.getChildByName("snow_icon").addChild(snow)
        snow2 = TileAnimationFactory.getInstance().getTileClass("TileVarSnow").create(2)
        snow2.setPosition(50, 50)
        anim.getChildByName("snow_icon2").addChild(snow2)
    }
    function bomb() {
        for (let i = 1; i <= 3; i += 1) {
            blasts[i].playAnim()
        }
        soda.playShowAnimation1_2()
        soda = null
        for (let k in ices) {
            let v = ices[k]
            if ($null(v)) continue
            v.removeFromParent(true)
        }
        ices = table()
        for (let i = 1; i <= 2; i += 1) {
            let ice = ItemViewUtils.buildLighttAction(1)
            ice.setPosition(50, 50)
            anim.getChildByName("ice_icon" + i).addChild(ice)
        }
        let snowEffect = snow.playVarSnowDecEffect(2)
        snowEffect.setPosition(50, 50)
        anim.getChildByName("snow_icon").addChild(snowEffect)
    }
    function showLineEffect() {
        let effect = CommonEffect.buildLineEffect(null, null, true)
        effect.setRotation(90)
        effect.setPosition(50, 50)
        anim.getChildByName("linefx_icon").addChild(effect)
    }
    function showLineBomb() {
        blasts[4].playAnim()
        let snowEffect = snow.playVarSnowDecEffect(1)
        snowEffect.setPosition(50, 50)
        anim.getChildByName("snow_icon").addChild(snowEffect)
        let snowEffect2 = snow2.playVarSnowDecEffect(1)
        snowEffect2.setPosition(50, 50)
        anim.getChildByName("snow_icon2").addChild(snowEffect2)
    }
    let actionCallbacks = {}
    actionCallbacks[1] = shakeBottle
    actionCallbacks[40] = bomb
    actionCallbacks[66] = showLineEffect
    actionCallbacks[71] = showLineBomb
    let callbackSeq = {}
    anim.runAction(cc.RepeatForever.create(cc.Sequence.create(cc.CallFunc.create(function () {
        let frame = action.getCurrentFrame()
        for (let k in actionCallbacks) {
            let v = actionCallbacks[k]
            if ($null(v)) continue
            if (k <= frame) {
                if (callbackSeq[k] === undefined) {
                    callbackSeq[k] = -1
                }
                if (callbackSeq[k] < actionSeq) {
                    pcall(function () {
                        actionCallbacks[k]()
                    })
                    callbackSeq[k] = callbackSeq[k] + 1
                }
            }
        }
    }), cc.DelayTime.create(1 / 60))))
    let clip = cc.ClippingRectangleNode.create()
    clip.setClippingRegion(cc.rect(0, -size.height, size.width, size.height))
    clip.setContentSize(cc.size(size.width, size.height))
    clip.setClippingEnabled(true)
    clip.addChild(anim)
    // FIXME: multi result
    return [clip, action]
}
// GameGuideTimelineAnims.gold = function (config) {
//     let self = this
//     // body
//     let [node, action] = syncRequireGameModule("clover/gameGuide/childAni/GoldChildAni").create()
//     // FIXME: multi result
//     return [node, action]
// }
GameGuideTimelineAnims.superHoneyBottle = function (config) {
    let self = this
    // body
    let [node, action] = syncRequireGameModule("clover/gameGuide/childAni/SuperHoneyBottleChildAni").create()
    // FIXME: multi result
    return [node, action]
}
GameGuideTimelineAnims.candyFloss = function (config) {
    let self = this
    // body
    let fileName = "cocos/obstacle_anim_candyFloss_guide.csb"
    let anim = cc.CSLoader.createNode(fileName)
    let action = cc.CSLoader.createTimeline(fileName)
    anim.runAction(action)
    let size = cc.size(350, 280)
    anim.setContentSize(size)
    let blasts = table()
    for (let k = 1; k <= 3; k += 1) {
        let sp = self._destroyEffect()
        let ic = anim.getChildByName("boom" + k)
        ic.addChild(sp)
        let _size = ic.getContentSize()
        sp.setPosition(_size.width / 2, _size.height / 2)
        table.insert(blasts, sp)
    }
    let crash_ani = cc.CSLoader.createNode("cocos/candy_floss_boom.csb")
    let action_crash = cc.CSLoader.createTimeline("cocos/candy_floss_boom.csb")
    crash_ani.runAction(action_crash)
    let container = anim.getChildByName("road_heng")
    container.addChild(crash_ani)
    crash_ani.setPosition(50, 50)
    let loopAnim
    function crash3() {
        let __VA_ARG = $slice(arguments, 0)
        // body
        action.play("crash3", false)
        action.setLastFrameCallFunc(loopAnim)
        action_crash.gotoFrameAndPlay(0, false)
    }
    function boom3() {
        let __VA_ARG = $slice(arguments, 0)
        // body
        action.play("boom3", false)
        action.setLastFrameCallFunc(crash3)
        for (let i = 1; i <= 3; i += 1) {
            blasts[i].playAnim()
        }
    }
    function crash2() {
        let __VA_ARG = $slice(arguments, 0)
        // body
        action.play("crash2", false)
        action.setLastFrameCallFunc(boom3)
        action_crash.gotoFrameAndPlay(0, false)
    }
    function boom2() {
        let __VA_ARG = $slice(arguments, 0)
        // body
        action.play("boom2", false)
        action.setLastFrameCallFunc(crash2)
        for (let i = 1; i <= 3; i += 1) {
            blasts[i].playAnim()
        }
    }
    function crash1() {
        let __VA_ARG = $slice(arguments, 0)
        // body
        action.play("crash1", false)
        action.setLastFrameCallFunc(boom2)
        action_crash.gotoFrameAndPlay(0, false)
    }
    function boom1() {
        let __VA_ARG = $slice(arguments, 0)
        // body
        action.play("boom1", false)
        action.setLastFrameCallFunc(crash1)
        for (let i = 1; i <= 3; i += 1) {
            blasts[i].playAnim()
        }
    }
    loopAnim = function () {
        let __VA_ARG = $slice(arguments, 0)
        // body
        action.play("start", false)
        action.setLastFrameCallFunc(boom1)
    }
    // action.gotoFrameAndPlay = function (self) {
    //     // body
    //     loopAnim()
    // }
    changeGotoFrameAndPlay(action, loopAnim)
    let clip = cc.ClippingRectangleNode.create()
    clip.setClippingRegion(cc.rect(0, -size.height, size.width, size.height))
    clip.setContentSize(cc.size(size.width, size.height))
    clip.setClippingEnabled(true)
    clip.addChild(anim)
    // FIXME: multi result
    return [clip, action]
}
GameGuideTimelineAnims.ratel = function (config) {
    let self = this
    let actionSeq = 0
    let name = "cocos/obstacle_anim_ratel_guide.csb"
    let anim = cc.CSLoader.createNode(name)
    let action = cc.CSLoader.createTimeline(name)
    anim.runAction(action)
    action.setLastFrameCallFunc(function () {
        actionSeq = actionSeq + 1 
        action.setCurrentFrame(0)
    })
    let bg = anim.getChildByName("checkboard_16")
    let size = bg.getContentSize()
    size.width = size.width + 150
    size.height = size.height + 100
    anim.setPositionY(anim.getPositionY() - 100)
    let container = cc.Node.create()
    anim.addChild(container, 9999)
    let tileRatel = null
    function createStar(arr) {
        let list = table()
        for (let k in arr) {
            let v = arr[k]
            if ($null(v)) continue
            let sprite = self._destroyEffect()
            sprite.setPosition(v)
            container.addChild(sprite, 1)
            setTimeout(() => {
                sprite.playAnim()
                sprite.runAction(cc.Sequence.create(cc.DelayTime.create(1), cc.CallFunc.create(function () {
                    sprite.removeFromParent(true)
                })))
            }, 0)
        }
    }
    function createRatel() {
        // 重置水母初始位置
        anim.getChildByName("shuimu_10").x = 244
        anim.getChildByName("shuimu_10").y = -106

        container.removeAllChildren(true)
        tileRatel = null
        tileRatel = TileAnimationFactory.getInstance().getTileClass("TileRatel").create(table([1, "strength", 2], [1, "ratelDirection", GameItemDirection.kRight]))
        tileRatel.setPosition(105, -105)
        container.addChild(tileRatel)
    }
    function onDecTo1() {
        if (tileRatel && tileRatel.nodeExist) {
            tileRatel.playItemCoverAnimation(1, 2)
            createStar(table(
                [0, cc.p(105, -35)],
                [0, cc.p(175, -35)],
                [0, cc.p(245, -35)]
            ))
        }
    }
    function onDecTo0() {
        if (tileRatel && tileRatel.nodeExist) {
            tileRatel.updateStrength(table([1, "strength", 1], [1, "ratelDirection", GameItemDirection.kRight]))
            createStar(table(
                [0, cc.p(35, -35)],
                [0, cc.p(105, -35)],
                [0, cc.p(175, -35)]
            ))
        }
    }
    function onStartRoll() {
        if (tileRatel && tileRatel.nodeExist) {
            tileRatel.playRatelRoll(cc.p(70, 0))
        }
    }
    function onRefresh_2() {
        if (tileRatel && tileRatel.nodeExist) {
            tileRatel.updateStrength(table([1, "strength", 2], [1, "ratelDirection", GameItemDirection.kRight]))
            tileRatel.setPositionX(tileRatel.getPositionX() + 70)
        }
    }
    function onDecTo1_2() {
        if (tileRatel && tileRatel.nodeExist) {
            tileRatel.playItemCoverAnimation(1, 2)
            createStar(table(
                [0, cc.p(35, -35)],
                [0, cc.p(105, -35)],
                [0, cc.p(175, -35)]
            ))
        }
    }
    function onDecTo0_2() {
        if (tileRatel && tileRatel.nodeExist) {
            tileRatel.updateStrength(table([1, "strength", 1], [1, "ratelDirection", GameItemDirection.kRight]))
            createStar(table(
                [0, cc.p(35, -35)],
                [0, cc.p(105, -35)],
                [0, cc.p(175, -35)]
            ))
        }
    }
    function onStartRoll_2() {
        if (tileRatel && tileRatel.nodeExist) {
            tileRatel.playRatelRoll(cc.p(70, 0))
        }
    }
    function onRefresh_3() {
        if (tileRatel && tileRatel.nodeExist) {
            tileRatel.updateStrength(table([1, "strength", 2], [1, "ratelDirection", GameItemDirection.kRight]))
            tileRatel.setPositionX(tileRatel.getPositionX() + 70)
        }
    }
    function onDecTo1_3() {
        if (tileRatel && tileRatel.nodeExist) {
            tileRatel.playItemCoverAnimation(1, 2)
            createStar(table(
                [0, cc.p(105, -35)],
                [0, cc.p(175, -35)],
                [0, cc.p(245, -35)]
            ))
        }
    }
    function onDecTo0_3() {
        if (tileRatel && tileRatel.nodeExist) {
            tileRatel.updateStrength(table([1, "strength", 1], [1, "ratelDirection", GameItemDirection.kRight]))
            createStar(table(
                [0, cc.p(105, -175)],
                [0, cc.p(175, -175)],
                [0, cc.p(245, -175)]
            ))
        }
    }
    function onStartRoll_3() {
        if (tileRatel && tileRatel.nodeExist) {
            tileRatel.playRatelOut(cc.p(70, 0))
        }
    }
    let actionCallbacks = table()
    actionCallbacks[1] = createRatel
    actionCallbacks[9] = onDecTo1
    actionCallbacks[44] = onDecTo0
    actionCallbacks[45] = onStartRoll
    actionCallbacks[77] = onRefresh_2
    actionCallbacks[78] = onDecTo1_2
    actionCallbacks[105] = onDecTo0_2
    actionCallbacks[106] = onStartRoll_2
    actionCallbacks[146] = onRefresh_3
    actionCallbacks[147] = onDecTo1_3
    actionCallbacks[169] = onDecTo0_3
    actionCallbacks[170] = onStartRoll_3
    let callbackSeq = table()
    anim.runAction(cc.RepeatForever.create(cc.Sequence.create(cc.CallFunc.create(function () {
        let frame = action.getCurrentFrame()
        for (let k in actionCallbacks) {
            let v = actionCallbacks[k]
            if ($null(v)) continue
            if (k <= frame) {
                if (callbackSeq[k] === undefined) {
                    callbackSeq[k] = -1
                }
                if (callbackSeq[k] < actionSeq) {
                    pcall(function () {
                        actionCallbacks[k]()
                    })
                    callbackSeq[k] = callbackSeq[k] + 1
                }
            }
        }
    }), cc.DelayTime.create(1 / 60))))
    let clip = cc.ClippingRectangleNode.create()
    clip.setClippingRegion(cc.rect(0, -size.height, size.width, size.height))
    clip.setContentSize(cc.size(size.width, size.height))
    clip.setClippingEnabled(true)
    clip.addChild(anim)
    // FIXME: multi result
    return [clip, action]
}
GameGuideTimelineAnims.ratelBoss = function (config) {
    let self = this
    let actionSeq = 0
    let name = "cocos/obstacle_anim_ratelBoss_guide.csb"
    let anim = cc.CSLoader.createNode(name)
    let action = cc.CSLoader.createTimeline(name)
    anim.runAction(action)
    action.setLastFrameCallFunc(function () {
        actionSeq = actionSeq + 1
        action.setCurrentFrame(0)
    })
    let size = cc.size(350, 350)
    anim.setPosition(-25, 266)
    let container = cc.Node.create()
    anim.addChild(container, 9999)
    let tileRatel = null
    let offset = cc.p(45, -330)
    function createStar(arr) {
        let list = table()
        for (let k in arr) {
            let v = arr[k]
            if ($null(v)) continue
            let sprite = self._destroyEffect()
            sprite.setPosition(v)
            container.addChild(sprite, 1)
            setTimeout(() => {
                sprite.playAnim()
                sprite.runAction(cc.Sequence.create(cc.DelayTime.create(1), cc.CallFunc.create(function () {
                    sprite.removeFromParent(true)
                })))
            }, 0)
        }
    }
    function createRatel() {
        let names = table("ciweif1_7", "ciweif2_5")
        for (let k in names) {
            let v = names[k]
            if ($null(v)) continue
            let child = anim.getChildByName(v)
            if (child && child.removeAllChildren) {
                child.removeAllChildren(true)
            }
        }
        container.removeAllChildren(true)
        tileRatel = null
        tileRatel = TileAnimationFactory.getInstance().getTileClass("TileRatel").create(table([1, "strength", 2], [1, "ratelDirection", GameItemDirection.kRight]))
        tileRatel.setPosition(offset.x + 245, offset.y - 105)
        container.addChild(tileRatel)
        anim.setPosition(-25, 266)
        anim.setScale(1)
    }
    function onDecTo1() {
        if (tileRatel && tileRatel.nodeExist) {
            tileRatel.playItemCoverAnimation(1, 2)
            createStar(table(
                [0, cc.p(offset.x + 105, offset.y - 35)],
                [0, cc.p(offset.x + 175, offset.y - 35)],
                [0, cc.p(offset.x + 245, offset.y - 35)]
            ))
        }
    }
    function onDecTo0() {
        if (tileRatel && tileRatel.nodeExist) {
            tileRatel.updateStrength(table([1, "strength", 1], [1, "ratelDirection", GameItemDirection.kRight]))
            createStar(table(
                [0, cc.p(offset.x + 105, offset.y - 175)],
                [0, cc.p(offset.x + 175, offset.y - 175)],
                [0, cc.p(offset.x + 245, offset.y - 175)]
            ))
        }
    }
    function onStartRoll() {
        if (tileRatel && tileRatel.nodeExist) {
            tileRatel.playRatelRoll(cc.p(70, 0))
        }
        anim.runAction(cc.MoveBy.create(12 / 30, cc.p(-70, 0)))
    }
    function onJump() {
        let temp = cc.CSLoader.createNode("cocos/ratel_hedgehog_before_attack.csb")
        let action = cc.CSLoader.createTimeline("cocos/ratel_hedgehog_before_attack.csb")
        temp.runAction(action)
        temp.setPosition(tileRatel.getPositionX() + 70, tileRatel.getPositionY())
        container.removeAllChildren(true)
        container.addChild(temp)
        action.gotoFrameAndPlay(0, false)
        anim.runAction(cc.EaseSineOut.create(cc.ScaleTo.create(15 / 30, 1.3)))
        anim.runAction(cc.EaseSineOut.create(cc.MoveBy.create(15 / 30, cc.p(-180, 130))))
    }
    function onBossAttack() {
        container.removeAllChildren(true)
        let temp = cc.CSLoader.createNode("cocos/ratel_hedgehog_before_attack.csb")
        let action = cc.CSLoader.createTimeline("cocos/ratel_hedgehog_before_attack.csb")
        temp.runAction(action)
        action.gotoFrameAndPause(38)
        temp.setPosition(50, 50)
        anim.getChildByName("ciweif1_7").addChild(temp)
        anim.runAction(cc.EaseSineOut.create(cc.MoveBy.create(15 / 30, cc.p(0, -370))))
    }
    function onBossAttackAfter() {
        anim.getChildByName("ciweif1_7").removeAllChildren(true)
        let temp = cc.CSLoader.createNode("cocos/ratel_hedgehog_before_attack.csb")
        let action = cc.CSLoader.createTimeline("cocos/ratel_hedgehog_before_attack.csb")
        temp.runAction(action)
        action.gotoFrameAndPause(38)
        temp.setPosition(50, 50)
        anim.getChildByName("ciweif2_5").addChild(temp)
    }
    let actionCallbacks = table()
    actionCallbacks[1] = createRatel
    actionCallbacks[6] = onDecTo1
    actionCallbacks[32] = onDecTo0
    actionCallbacks[33] = onStartRoll
    actionCallbacks[53] = onJump
    actionCallbacks[90] = onBossAttack
    actionCallbacks[106] = onBossAttackAfter
    let callbackSeq = table()
    anim.runAction(cc.RepeatForever.create(cc.Sequence.create(cc.CallFunc.create(function () {
        let frame = action.getCurrentFrame()
        for (let k in actionCallbacks) {
            let v = actionCallbacks[k]
            if ($null(v)) continue
            if (k <= frame) {
                if (callbackSeq[k] === undefined) {
                    callbackSeq[k] = -1
                }
                if (callbackSeq[k] < actionSeq) {
                    pcall(function () {
                        actionCallbacks[k]()
                    })
                    callbackSeq[k] = callbackSeq[k] + 1
                }
            }
        }
    }), cc.DelayTime.create(1 / 60))))
    let clip = cc.ClippingRectangleNode.create()
    clip.setClippingRegion(cc.rect(0, -size.height, size.width, size.height))
    clip.setContentSize(cc.size(size.width, size.height))
    clip.setClippingEnabled(true)
    clip.addChild(anim)
    // FIXME: multi result
    return [clip, action]
}
GameGuideTimelineAnims.capsuleToy = function (config) {
    let self = this
    syncRequireGameModule("clover/itemView/ItemView")
    syncRequireGameModule("clover/itemView/ItemTypeViewFactory")
    syncRequireGameModule("clover/levelTarget/TargetIcon")
    FrameLoader.loadImageWithPlist("cocos/capsuleToyAnimation.plist")
    FrameLoader.loadImageWithPlist("flash/capsuleToy.plist")
    FrameLoader.loadImageWithPlist("flash/various_box.plist")
    FrameLoader.loadImageWithPlist("flash/gum.plist")
    FrameLoader.loadImageWithPlist("flash/absorb_animal_super_gum.plist")
    let actionSeq = 0
    let name = "cocos/obstacle_anim_capsuleToy_guide.csb"
    let anim = cc.CSLoader.createNode(name)
    let action = cc.CSLoader.createTimeline(name)
    anim.runAction(action)
    action.setLastFrameCallFunc(function () {
        actionSeq = actionSeq + 1
        action.setCurrentFrame(0)
    })
    let size = cc.size(350, 280)
    anim.setPosition(-193, 295)
    let container = cc.Node.create()
    anim.addChild(container, 9999)
    let tileCapsuleToy = null
    let offset = cc.p(193, -295)
    function createStar(arr) {
        let list = table()
        for (let k in arr) {
            let v = arr[k]
            if ($null(v)) continue
            let sprite = self._destroyEffect()
            sprite.setPosition(v)
            container.addChild(sprite, 1)
            setTimeout(() => {
                sprite.playAnim()
                sprite.runAction(cc.Sequence.create(cc.DelayTime.create(1), cc.CallFunc.create(function () {
                    sprite.removeFromParent(true)
                })))
            }, 0)
        }
    }
    function createCapsuleToy() {        
        container.removeAllChildren(true)
        anim.getChildByName("honey0_iconplaceholder").removeAllChildren(true)
        tileCapsuleToy = null
        tileCapsuleToy = TileAnimationFactory.getInstance().getTileClass("TileCapsuleToy").create(table(
            [1, "itemStrength", 3],
            [1, "itemBindID", 131],
            [1, "itemBindCount", 3]
        ))
        tileCapsuleToy.setPosition(50, 50)
        anim.getChildByName("honey0_iconplaceholder").addChild(tileCapsuleToy)
        anim.setPosition(-193, 295)
        anim.setScale(1)
    }
    function onDecTo2() {
        if (tileCapsuleToy && tileCapsuleToy.nodeExist) {
            tileCapsuleToy.playDecCapsuleToy(2, 2)
            createStar(table(
                [0, cc.p(offset.x + 105, offset.y - 105)],
                [0, cc.p(offset.x + 105, offset.y - 175)],
                [0, cc.p(offset.x + 105, offset.y - 245)]
            ))
        }
    }
    function onDecTo1() {
        if (tileCapsuleToy && tileCapsuleToy.nodeExist) {
            tileCapsuleToy.playDecCapsuleToy(1, 1)
            createStar(table(
                [0, cc.p(offset.x + 105, offset.y - 175)],
                [0, cc.p(offset.x + 175, offset.y - 175)],
                [0, cc.p(offset.x + 245, offset.y - 175)]
            ))
        }
    }
    function onDecTo0() {
        if (tileCapsuleToy && tileCapsuleToy.nodeExist) {
            tileCapsuleToy.playDecCapsuleToy(0, 0)
            createStar(table(
                [0, cc.p(offset.x + 105, offset.y - 245)],
                [0, cc.p(offset.x + 175, offset.y - 245)],
                [0, cc.p(offset.x + 245, offset.y - 245)]
            ))
        }
    }
    function onDestroy() {
        if (tileCapsuleToy && tileCapsuleToy.nodeExist) {
            tileCapsuleToy.playDestroyCapsuleToy(function () { })
        }
    }
    let actionCallbacks = {}
    actionCallbacks[1] = createCapsuleToy
    actionCallbacks[21] = onDecTo2
    actionCallbacks[70] = onDecTo1
    actionCallbacks[131] = onDecTo0
    actionCallbacks[180] = onDestroy
    let callbackSeq = {}
    anim.runAction(cc.RepeatForever.create(cc.Sequence.create(cc.CallFunc.create(function () {
        let frame = action.getCurrentFrame()
        for (let k in actionCallbacks) {
            let v = actionCallbacks[k]
            if (k <= frame) {
                if (callbackSeq[k] === undefined) {
                    callbackSeq[k] = -1
                }
                if (callbackSeq[k] < actionSeq) {
                    pcall(function () {
                        actionCallbacks[k]()
                    })
                    callbackSeq[k] = callbackSeq[k] + 1
                }
            }
        }
    }), cc.DelayTime.create(1 / 60))))
    let clip = cc.ClippingRectangleNode.create()
    clip.setClippingRegion(cc.rect(0, -size.height, size.width, size.height))
    clip.setContentSize(cc.size(size.width, size.height))
    clip.setClippingEnabled(true)
    clip.addChild(anim)
    // FIXME: multi result
    return [clip, action]
}
GameGuideTimelineAnims.vulnerable = function () {
    // body
    let [node, action] = syncRequireGameModule("clover/gameGuide/childAni/VulnerableChildAni").create()
    // FIXME: multi result
    return [node, action]
}
GameGuideTimelineAnims.grass = function () {
    let [node, action] = syncRequireGameModule("clover/gameGuide/childAni/GrassChildAni").create()
    // FIXME: multi result
    return [node, action]
}
GameGuideTimelineAnims.iceBomb = function () {
    let [node, action] = syncRequireGameModule("clover/gameGuide/childAni/IceBombChildAni").create()
    // FIXME: multi result
    return [node, action]
}
GameGuideTimelineAnims.variantMatts = function() {
    let self = this
    let [node, action] = syncRequireGameModule("clover/gameGuide/childAni/VariantMattsChildAni").create()
    // FIXME: multi result
    return [node, action]
}
GameGuideTimelineAnims.cakeShooter = function () {
    let self = this
    let [node, action] = syncRequireGameModule("clover/gameGuide/childAni/CakeShooterChildAni").create()
    // FIXME: multi result
    return [node, action]
}
GameGuideTimelineAnims.gummyWorm = function () {
    let self = this
    let [node, action] = syncRequireGameModule("clover/gameGuide/childAni/GummyWormChildAni").create()
    // FIXME: multi result
    return [node, action]
}
GameGuideTimelineAnims.nestDoll = function () {
    let self = this
    let [node, action] = syncRequireGameModule("clover/gameGuide/childAni/NestDollChildAni").create()
    // FIXME: multi result
    return [node, action]
}
GameGuideTimelineAnims.advice = function() {
	let self = this;
    let [node, action] = syncRequireGameModule("clover/gameGuide/childAni/AdviceAni").create();
	return [node, action]
}
GameGuideTimelineAnims.rocket = function () {
    let self = this
    let [node, action] = syncRequireGameModule("clover/gameGuide/childAni/RocketChildAni").create()
    // FIXME: multi result
    return [node, action]
}
GameGuideTimelineAnims.coloredFrosting = function () {
    let self = this
    let [node, action] = syncRequireGameModule("clover/gameGuide/childAni/ColoredFrostingChildAni").create()
    // FIXME: multi result
    return [node, action]
}
GameGuideTimelineAnims.candyYoyo = function () {
    let self = this
    let [node, action] = syncRequireGameModule("clover/gameGuide/childAni/CandyYoyoChildAni").create()
    // FIXME: multi result
    return [node, action]
}
GameGuideTimelineAnims.jamJar = function () {
    let self = this
    let [node, action] = syncRequireGameModule("clover/gameGuide/childAni/JamJarAni").create()
    // FIXME: multi result
    return [node, action]
}
GameGuideTimelineAnims.mint = function () {
    let self = this
    let [node, action] = syncRequireGameModule("clover/gameGuide/childAni/MintAni").create()
    // FIXME: multi result
    return [node, action]
}
GameGuideTimelineAnims.seaAnemone = function () {
    let self = this
    let [node, action] = syncRequireGameModule("clover/gameGuide/childAni/SeaAnemoneChildAni").create()
    // FIXME: multi result
    return [node, action]
}
GameGuideTimelineAnims.mushroom = function () {
    let [node, action] = syncRequireGameModule("clover/gameGuide/childAni/MushroomChildAni").create()
    // FIXME: multi result
    return [node, action]
}
GameGuideTimelineAnims.fishnet = function () {
    let [node, action] = syncRequireGameModule("clover/gameGuide/childAni/FishnetChildAni").create()
    // FIXME: multi result
    return [node, action]
}
GameGuideTimelineAnims.ufo = function () {
    let [node, action] = syncRequireGameModule("clover/gameGuide/childAni/UFOChildAni").create()
    return [node, action]
}
GameGuideTimelineAnims.flash_bird = function () {
    let [node, action] = syncRequireGameModule("clover/gameGuide/childAni/FlashBirdChildAni").create()
    // FIXME: multi result
    return [node, action]
}
GameGuideTimelineAnims.cheese_rat = function () {
    let [node, action] = syncRequireGameModule("clover/gameGuide/childAni/CheeseRatChildAni").create()
    // FIXME: multi result
    return [node, action]
}
GameGuideTimelineAnims.pastry = function () {
    let [node, action] = syncRequireGameModule("clover/gameGuide/childAni/PastryChildAni").create()
    // FIXME: multi result
    return [node, action]
}

GameGuideTimelineAnims.croissant = function () {
    let [node, action] = syncRequireGameModule("clover/gameGuide/childAni/CroissantChildAni").create()
    // FIXME: multi result
    return [node, action]
}
GameGuideTimelineAnims.popcan = function () {
    let self = this
    let [node, action] = syncRequireGameModule("clover/gameGuide/childAni/PopCanChildAni").create()
    // FIXME: multi result
    return [node, action]
}
GameGuideTimelineAnims.filbert = function () {
    let self = this
    let [node, action] = syncRequireGameModule("clover/gameGuide/childAni/FilbertChildAni").create()
    // FIXME: multi result
    return [node, action]
}
GameGuideTimelineAnims.firework = function () {
    let self = this
    let [node, action] = syncRequireGameModule("clover/gameGuide/childAni/FireWorkChildAni").create()
    // FIXME: multi result
    return [node, action]
}
GameGuideTimelineAnims.firecracker = function () {
    let self = this
    let [node, action] = syncRequireGameModule("clover/gameGuide/childAni/FireCrackerChildAni").create()
    // FIXME: multi result
    return [node, action]
}
GameGuideTimelineAnims.icecream = function () {
    let self = this
    let [node, action] = syncRequireGameModule("clover/gameGuide/childAni/IcecreamChildAni").create()
    // FIXME: multi result
    return [node, action]
}
GameGuideTimelineAnims.lamp = function () {
    let self = this
    let [node, action] = syncRequireGameModule("clover/gameGuide/childAni/LampChildAni").create()
    // FIXME: multi result
    return [node, action]
}
GameGuideTimelineAnims.laser = function () {
    let self = this
    let [node, action] = syncRequireGameModule("clover/gameGuide/childAni/LaserChildAni").create()
    //let [node, action] = require("clover/gameGuide/childAni/EggChildAni").create()
    
    // FIXME: multi result
    return [node, action]
}
GameGuideTimelineAnims.egg = function () {
    let self = this
    let [node, action] = syncRequireGameModule("clover/gameGuide/childAni/EggChildAni").create()
    // FIXME: multi result
    return [node, action]
}
GameGuideTimelineAnims.dye = function () {
    let self = this
    let [node, action] = syncRequireGameModule("clover/gameGuide/childAni/DyeChildAni").create()
    // FIXME: multi result
    return [node, action]
}
GameGuideTimelineAnims.magicbottle = function () {
    let self = this
    let [node, action] = syncRequireGameModule("clover/gameGuide/childAni/MagicbottleChildAni").create()
    // FIXME: multi result
    return [node, action]
}
GameGuideTimelineAnims.dinnertable = function () {
    let self = this
    let [node, action] = syncRequireGameModule("clover/gameGuide/childAni/DinnertableChildAni").create()
    // FIXME: multi result
    return [node, action]
}
GameGuideTimelineAnims.bombCandy = function () {
    let self = this
    let [node, action] = syncRequireGameModule("clover/gameGuide/childAni/BombCandyChildAni").create()
    // FIXME: multi result
    return [node, action]
}
GameGuideTimelineAnims.torpedo = function () {
    let self = this
    let [node, action] = syncRequireGameModule("clover/gameGuide/childAni/TorpedoChildAni").create()
    // FIXME: multi result
    return [node, action]
}
GameGuideTimelineAnims.biscuit = function () {
    let self = this
    let [node, action] = syncRequireGameModule("clover/gameGuide/childAni/BiscuitChildAni").create()
    // FIXME: multi result
    return [node, action]
}
GameGuideTimelineAnims.popcorn = function () {
    let self = this
    let [node, action] = syncRequireGameModule("clover/gameGuide/childAni/PopcornChildAni").create()
    // FIXME: multi result
    return [node, action]
}
GameGuideTimelineAnims.hunter = function () {
    let self = this
    let [node, action] = syncRequireGameModule("clover/gameGuide/childAni/HunterChildAni").create()
    // FIXME: multi result
    return [node, action]
}
GameGuideTimelineAnims.nest = function () {
    let self = this
    let [node, action] = syncRequireGameModule("clover/gameGuide/childAni/NestChildAni").create()
    // FIXME: multi result
    return [node, action]
}
GameGuideTimelineAnims.diamond = function () {
    let self = this
    let [node, action] = syncRequireGameModule("clover/gameGuide/childAni/DiamondChildAni").create()
    // FIXME: multi result
    return [node, action]
}
GameGuideTimelineAnims.turnTile = function () {
    let self = this
    let [node, action] = syncRequireGameModule("clover/gameGuide/childAni/TurnTileChildAni").create()
    // FIXME: multi result
    return [node, action]
}
GameGuideTimelineAnims.cannedFish = function () {
    let self = this
    let [node, action] = syncRequireGameModule("clover/gameGuide/childAni/CannedFishChildAni").create()
    // FIXME: multi result
    return [node, action]
}
GameGuideTimelineAnims.shark = function () {
    let self = this
    let [node, action] = syncRequireGameModule("clover/gameGuide/childAni/SharkChildAni").create()
    // FIXME: multi result
    return [node, action]
}
GameGuideTimelineAnims.minioctopus = function () {
    let self = this
    let [node, action] = syncRequireGameModule("clover/gameGuide/childAni/MiniOctopusChildAni").create()
    // FIXME: multi result
    return [node, action]
}
GameGuideTimelineAnims.supportStick = function () {
    let self = this
    let [node, action] = syncRequireGameModule("clover/gameGuide/childAni/SupportStickChildAni").create()
    // FIXME: multi result
    return [node, action]
}
let SpecialObstacleAnim = table(
    [1, "candy", GameGuideTimelineAnims.obstacleCandy],
    [1, "four_tile", GameGuideTimelineAnims.obstacleFourTile],
    [1, "fish", GameGuideTimelineAnims.fishFx],
    [1, "fish_pull", GameGuideTimelineAnims.fishPull],
    [1, "ice_chain", GameGuideTimelineAnims.iceChain],
    [1, "orange", GameGuideTimelineAnims.orange],
    [1, "generator", GameGuideTimelineAnims.generator],
    [1, "cage", GameGuideTimelineAnims.lock],
    [1, "line", GameGuideTimelineAnims.lineFx],
    [1, "ice", GameGuideTimelineAnims.iceBreak],
    [1, "wrap", GameGuideTimelineAnims.wrapFx],
    [1, "toy", GameGuideTimelineAnims.obstacleToy],
    [1, "bird", GameGuideTimelineAnims.birdFx],
    [1, "boss", GameGuideTimelineAnims.bossFx],
    [1, "boss_alert", GameGuideTimelineAnims.bossAlert],
    [1, "super_bird", GameGuideTimelineAnims.superBird],
    [1, "toy_collect", GameGuideTimelineAnims.collectToy],
    [1, "coconut", GameGuideTimelineAnims.coconutFx],
    [1, "water_dig", GameGuideTimelineAnims.waterDig],
    [1, "reef", GameGuideTimelineAnims.reef],
    [1, "butterfly", GameGuideTimelineAnims.butterfly],
    [1, "venom", GameGuideTimelineAnims.venom],
    [1, "boss2", GameGuideTimelineAnims.bossFx2],
    [1, "boss_update", GameGuideTimelineAnims.boss_update],
    [1, "jellyfish", GameGuideTimelineAnims.jellyfish],
    [1, "corssProp", GameGuideTimelineAnims.corssProp],
    [1, "lotus", GameGuideTimelineAnims.lotus],
    [1, "beehive", GameGuideTimelineAnims.lighthouse],
    [1, "teamstar", GameGuideTimelineAnims.teamGetStar],
    [1, "weekgame", GameGuideTimelineAnims.weekgame],
    [1, "hat", GameGuideTimelineAnims.hat],
    [1, "color_collect", GameGuideTimelineAnims.colorCollector],
    [1, "color_fish", GameGuideTimelineAnims.colorFish],
    [1, "colorless_fish", GameGuideTimelineAnims.colorlessFish],
    [1, "chocolate", GameGuideTimelineAnims.chocolate],
    [1, "pursue", GameGuideTimelineAnims.pursueFinish],
    [1, "cake", GameGuideTimelineAnims.cake],
    [1, "waterbomb", GameGuideTimelineAnims.waterbomb],
    [1, "bowknot", GameGuideTimelineAnims.bowknot],
    [1, "hammerBig", GameGuideTimelineAnims.hammerBig],
    [1, "hammerBigIsland", GameGuideTimelineAnims.hammerBigIsland],
    [1, "dice", GameGuideTimelineAnims.dice],
    [1, "lineBig", GameGuideTimelineAnims.lineBig],
    [1, "mirrorI", GameGuideTimelineAnims.mirrorI],
    [1, "mirrorII", GameGuideTimelineAnims.mirrorII],
    [1, "dyeingAgent", GameGuideTimelineAnims.dyeingAgent],
    [1, "columnDyeing", GameGuideTimelineAnims.columnDyeing],
    [1, "shockWave_1", GameGuideTimelineAnims.shockWaveI],
    [1, "shockWave_2", GameGuideTimelineAnims.shockWaveII],
    [1, "blastCrystalProp", GameGuideTimelineAnims.blastCrystalProp],
    [1, "produceMark", GameGuideTimelineAnims.produceMark],
    [1, "shell", GameGuideTimelineAnims.shell],
    [1, "soda", GameGuideTimelineAnims.showSodaAnim],
    [1, "gold", GameGuideTimelineAnims.gold],
    [1, "superHoneyBottle", GameGuideTimelineAnims.superHoneyBottle],
    [1, "candyFloss", GameGuideTimelineAnims.candyFloss],
    [1, "ratel", GameGuideTimelineAnims.ratel],
    [1, "ratelBoss", GameGuideTimelineAnims.ratelBoss],
    [1, "vulnerable", GameGuideTimelineAnims.vulnerable],
    [1, "advice", GameGuideTimelineAnims.advice],    // 原生第三关引导
    [1, "capsuleToy", GameGuideTimelineAnims.capsuleToy],
    [1, "grass", GameGuideTimelineAnims.grass],
    [1, "iceBomb", GameGuideTimelineAnims.iceBomb],
    [1, "variantMatts", GameGuideTimelineAnims.variantMatts],  // 原生第三关引导
	[1, "cakeShooter", GameGuideTimelineAnims.cakeShooter],
	[1, "gummyWorm", GameGuideTimelineAnims.gummyWorm],
	[1, "nestDoll", GameGuideTimelineAnims.nestDoll],
    [1, "rocket", GameGuideTimelineAnims.rocket],
    [1, "coloredFrosting", GameGuideTimelineAnims.coloredFrosting],  
    [1, "candyYoyo", GameGuideTimelineAnims.candyYoyo],
    [1, "jamJar", GameGuideTimelineAnims.jamJar],
    [1, "mint", GameGuideTimelineAnims.mint],    
    [1, "seaAnemone", GameGuideTimelineAnims.seaAnemone],
    [1, "mushroom", GameGuideTimelineAnims.mushroom],
    [1, "fishnet", GameGuideTimelineAnims.fishnet],
    [1, "ufo", GameGuideTimelineAnims.ufo],
    [1, "flash_bird", GameGuideTimelineAnims.flash_bird],
    [1, "cheese_rat", GameGuideTimelineAnims.cheese_rat],
    [1, "pastry", GameGuideTimelineAnims.pastry],
    [1, "croissant", GameGuideTimelineAnims.croissant],
    [1, "popcan", GameGuideTimelineAnims.popcan],
    [1, "filbert", GameGuideTimelineAnims.filbert],
    [1, "firework", GameGuideTimelineAnims.firework],
    [1, "firecracker", GameGuideTimelineAnims.firecracker],
    [1, "icecream", GameGuideTimelineAnims.icecream],
    [1, "lamp", GameGuideTimelineAnims.lamp],
    [1, "laser", GameGuideTimelineAnims.laser],
    [1, "egg", GameGuideTimelineAnims.egg],
    [1, "dye", GameGuideTimelineAnims.dye],
    [1, "magicbottle", GameGuideTimelineAnims.magicbottle],
    [1, "dinnertable", GameGuideTimelineAnims.dinnertable],
    [1, "bombCandy", GameGuideTimelineAnims.bombCandy],
    [1, "torpedo", GameGuideTimelineAnims.torpedo],
    [1, "biscuit", GameGuideTimelineAnims.biscuit],
    [1, "popcorn", GameGuideTimelineAnims.popcorn],
    [1, "nest", GameGuideTimelineAnims.nest],
    [1, "hunter", GameGuideTimelineAnims.hunter],
    [1, "diamond", GameGuideTimelineAnims.diamond],
    [1, "turnTile", GameGuideTimelineAnims.turnTile],
    [1, "cannedFish", GameGuideTimelineAnims.cannedFish],
    [1, "shark", GameGuideTimelineAnims.shark],
    [1, "minioctopus", GameGuideTimelineAnims.minioctopus],
    [1, "supportStick", GameGuideTimelineAnims.supportStick]
)
GameGuideTimelineAnims.obstacle = function (animConfig) {
    let self = this
    if (SpecialObstacleAnim[animConfig.obstName]) {
        // WARN: maybe multi result
        // return SpecialObstacleAnim[animConfig.obstName](self, animConfig)
        return SpecialObstacleAnim[animConfig.obstName].call(GameGuideTimelineAnims, animConfig)
    }
    let anim = cc.CSLoader.createNode("cocos/obstacle_anim_" + tostring(animConfig.obstName) + ".csb")
    let bg = anim.getChildByName("bg")
    let size = bg.getContentSize()
    let action = cc.CSLoader.createTimeline("cocos/obstacle_anim_" + tostring(animConfig.obstName) + ".csb")
    anim.runAction(action)
    let clip = cc.ClippingRectangleNode.create()
    clip.setClippingRegion(cc.rect(0, -size.height, size.width, size.height))
    clip.setContentSize(cc.size(size.width, size.height))
    clip.setClippingEnabled(true)
    clip.addChild(anim)
    // FIXME: multi result
    return [clip, action]
}
GameGuideTimelineAnims.changeGotoFrameAndPlay = changeGotoFrameAndPlay
module.exports = GameGuideTimelineAnims
